/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Nabis NY Web API
 * Nabis NY Web API docs
 * OpenAPI spec version: 1.0
 */
export type OrderStatusNotificationControllerUnsubscribeBySubscriptionIdParams = {
  /**
   * Notification ID for the subscription to be unsubscribed
   */
  notificationId: string;
};

export type OrderStatusNotificationControllerGetSubscriptionDetailsParams = {
  /**
   * ID of the organization for which the notification is subscribed
   */
  organizationId: string;
  /**
   * Type of notification subscription e.g. ORDER_STATUS
   */
  notificationType: string;
};

export type OrderStatusNotificationControllerGetIsNotificationSubscribedParams = {
  /**
   * ID of the organization for which the notification is subscribed
   */
  organizationId: string;
  /**
   * Type of notification subscription e.g. ORDER_STATUS
   */
  notificationType: string;
};

export type AccountingRemittanceControllerDownloadReportCSVParams = {
  /**
   * The report id
   */
  id: string;
};

export type AccountingRemittanceControllerFetchRemittanceReportByOrgState =
  (typeof AccountingRemittanceControllerFetchRemittanceReportByOrgState)[keyof typeof AccountingRemittanceControllerFetchRemittanceReportByOrgState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountingRemittanceControllerFetchRemittanceReportByOrgState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export type AccountingRemittanceControllerFetchRemittanceReportByOrgStatus =
  (typeof AccountingRemittanceControllerFetchRemittanceReportByOrgStatus)[keyof typeof AccountingRemittanceControllerFetchRemittanceReportByOrgStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountingRemittanceControllerFetchRemittanceReportByOrgStatus = {
  GENERATED: 'GENERATED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
} as const;

export type AccountingRemittanceControllerFetchRemittanceReportByOrgParams = {
  /**
   * The org id
   */
  orgId: string;
  /**
   * The at least amount
   */
  atLeastAmount?: number;
  /**
   * The at least end date
   */
  atLeastEndDate?: string;
  /**
   * The at least start date
   */
  atLeastStartDate?: string;
  /**
   * The at most amount
   */
  atMostAmount?: number;
  /**
   * The at most end date
   */
  atMostEndDate?: string;
  /**
   * The at most start date
   */
  atMostStartDate?: string;
  /**
   * The equal amount
   */
  equalAmount?: number;
  /**
   * The equal end date
   */
  equalEndDate?: string;
  /**
   * The equal start date
   */
  equalStartDate?: string;
  /**
   * The status
   */
  status?: AccountingRemittanceControllerFetchRemittanceReportByOrgStatus;
  /**
   * The state
   */
  state?: AccountingRemittanceControllerFetchRemittanceReportByOrgState;
  page: number;
  numItemsPerPage: number;
};

export type AccountingTransactionControllerFetchDetailedInvoicesByNumberParams = {
  /**
   * The invoice number
   */
  number: number;
  /**
   * The state
   */
  state: string;
};

export type AccountingTransactionControllerFetchDetailedTransactionParams = {
  /**
   * The transaction number
   */
  transactionNumber: number;
  /**
   * The state
   */
  state: string;
};

export type AccountingTransactionControllerFindAllAccountsState =
  (typeof AccountingTransactionControllerFindAllAccountsState)[keyof typeof AccountingTransactionControllerFindAllAccountsState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountingTransactionControllerFindAllAccountsState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export type AccountingTransactionControllerFindAllAccountsParams = {
  /**
   * The state
   */
  state: AccountingTransactionControllerFindAllAccountsState;
};

export type AccountingTransactionControllerGetPaymentTransactionsState =
  (typeof AccountingTransactionControllerGetPaymentTransactionsState)[keyof typeof AccountingTransactionControllerGetPaymentTransactionsState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountingTransactionControllerGetPaymentTransactionsState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export type AccountingTransactionControllerGetPaymentTransactionsUnappliedReason =
  (typeof AccountingTransactionControllerGetPaymentTransactionsUnappliedReason)[keyof typeof AccountingTransactionControllerGetPaymentTransactionsUnappliedReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountingTransactionControllerGetPaymentTransactionsUnappliedReason = {
  NO_BREAKDOWN_PROVIDED: 'NO_BREAKDOWN_PROVIDED',
  INCOMPLETE_BREAKDOWN: 'INCOMPLETE_BREAKDOWN',
  UNCLEAR_BREAKDOWN: 'UNCLEAR_BREAKDOWN',
  INVALID_ORDER_NUMBER: 'INVALID_ORDER_NUMBER',
  CLOSED_PREVIOUSLY_PAID: 'CLOSED_PREVIOUSLY_PAID',
  CLOSED_ALLOCATED_WITH_OP: 'CLOSED_ALLOCATED_WITH_OP',
  CLOSED_SAMPLE_ORDER: 'CLOSED_SAMPLE_ORDER',
  CLOSED_SELF_COLLECTED: 'CLOSED_SELF_COLLECTED',
  CLOSED_SHORT_PAYMENT_ENTERED: 'CLOSED_SHORT_PAYMENT_ENTERED',
  ORDER_NOT_DELIVERED_YET: 'ORDER_NOT_DELIVERED_YET',
  ORDER_REJECTED: 'ORDER_REJECTED',
  ORDER_OVERPAID: 'ORDER_OVERPAID',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  POST_DELIVERY_ADJUSTMENTS: 'POST_DELIVERY_ADJUSTMENTS',
  NO_HISTORICAL_DATA_UNKNOWN_PAYER: 'NO_HISTORICAL_DATA_UNKNOWN_PAYER',
  SITE_NOT_FLIPPED: 'SITE_NOT_FLIPPED',
  WRITE_OFF: 'WRITE_OFF',
  UNIDENTIFIED_OVERPAYMENT: 'UNIDENTIFIED_OVERPAYMENT',
  NABIS_BILLPAY: 'NABIS_BILLPAY',
  CREDIT_NOT_CONFIRMED: 'CREDIT_NOT_CONFIRMED',
  CREDIT_MISSING_INSTRUCTIONS: 'CREDIT_MISSING_INSTRUCTIONS',
  BRAND_OFFBOARDED: 'BRAND_OFFBOARDED',
  RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED: 'RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED',
  null: null,
} as const;

export type AccountingTransactionControllerGetPaymentTransactionsType =
  (typeof AccountingTransactionControllerGetPaymentTransactionsType)[keyof typeof AccountingTransactionControllerGetPaymentTransactionsType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountingTransactionControllerGetPaymentTransactionsType = {
  PAYMENT: 'PAYMENT',
  SELF_COLLECTED: 'SELF_COLLECTED',
  CREDIT_MEMO: 'CREDIT_MEMO',
  DISCOUNT: 'DISCOUNT',
  WRITE_OFF_NABIS: 'WRITE_OFF_NABIS',
  WRITE_OFF_EXTERNAL: 'WRITE_OFF_EXTERNAL',
  NABIS_CREDIT_MEMO: 'NABIS_CREDIT_MEMO',
} as const;

export type AccountingTransactionControllerGetPaymentTransactionsTransactionType =
  (typeof AccountingTransactionControllerGetPaymentTransactionsTransactionType)[keyof typeof AccountingTransactionControllerGetPaymentTransactionsTransactionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountingTransactionControllerGetPaymentTransactionsTransactionType = {
  PAYMENT: 'PAYMENT',
  SELF_COLLECTED: 'SELF_COLLECTED',
  CREDIT_MEMO: 'CREDIT_MEMO',
  DISCOUNT: 'DISCOUNT',
  WRITE_OFF_NABIS: 'WRITE_OFF_NABIS',
  WRITE_OFF_EXTERNAL: 'WRITE_OFF_EXTERNAL',
  NABIS_CREDIT_MEMO: 'NABIS_CREDIT_MEMO',
} as const;

export type AccountingTransactionControllerGetPaymentTransactionsParams = {
  /**
   * The transaction number
   */
  transactionNumber?: number;
  /**
   * The transaction type
   */
  transactionType?: AccountingTransactionControllerGetPaymentTransactionsTransactionType;
  /**
   * The from account ids
   */
  fromAccountId?: string[];
  /**
   * The to account ids
   */
  toAccountId?: string[];
  /**
   * The original transaction number
   */
  originalTransactionNumber?: number;
  /**
   * The name
   */
  name?: string;
  /**
   * The before created at date
   */
  beforeCreatedAtDate?: string;
  /**
   * The after created at date
   */
  afterCreatedAtDate?: string;
  /**
   * The same created at date
   */
  sameCreatedAtDate?: string;
  /**
   * The before paid at date
   */
  beforePaidAtDate?: string;
  /**
   * The after paid at date
   */
  afterPaidAtDate?: string;
  /**
   * The same paid at date
   */
  samePaidAtDate?: string;
  /**
   * The before remitted at date
   */
  beforeRemittedAtDate?: string;
  /**
   * The after remitted at date
   */
  afterRemittedAtDate?: string;
  /**
   * The same remitted at date
   */
  sameRemittedAtDate?: string;
  /**
   * The before applied at date
   */
  beforeAppliedAtDate?: string;
  /**
   * The after applied at date
   */
  afterAppliedAtDate?: string;
  /**
   * The same applied at date
   */
  sameAppliedAtDate?: string;
  /**
   * The paid by
   */
  paidBy?: string;
  /**
   * The at least amount
   */
  atLeastAmount?: number;
  /**
   * The at most amount
   */
  atMostAmount?: number;
  /**
   * The equal amount
   */
  equalAmount?: number;
  /**
   * The at least unapplied
   */
  atLeastUnapplied?: number;
  /**
   * The at most unapplied
   */
  atMostUnapplied?: number;
  /**
   * The equal unapplied
   */
  equalUnapplied?: number;
  /**
   * The location
   */
  location?: string;
  /**
   * The invoice paid to
   */
  invoicePaidTo?: string;
  /**
   * The invoice paid by
   */
  invoicePaidBy?: string;
  /**
   * The transaction type
   */
  type?: AccountingTransactionControllerGetPaymentTransactionsType;
  /**
   * The paid by organization for group
   */
  paidByForGroup?: string;
  /**
   * The order number the original transaction has children attached to
   */
  appliedOrderNumber?: number;
  /**
   * The unapplied reason
   */
  unappliedReason?: AccountingTransactionControllerGetPaymentTransactionsUnappliedReason;
  /**
   * The state
   */
  state: AccountingTransactionControllerGetPaymentTransactionsState;
  /**
   * The text search
   */
  textSearch?: string;
  page: number;
  numItemsPerPage: number;
};

export type AdminOrganizationsControllerFindAllForAdminType =
  (typeof AdminOrganizationsControllerFindAllForAdminType)[keyof typeof AdminOrganizationsControllerFindAllForAdminType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminOrganizationsControllerFindAllForAdminType = {
  BRAND: 'BRAND',
  MANUFACTURER: 'MANUFACTURER',
  DISTRIBUTOR: 'DISTRIBUTOR',
  RETAILER: 'RETAILER',
  SALES: 'SALES',
} as const;

export type AdminOrganizationsControllerFindAllForAdminParams = {
  /**
   * Page number (starting from 1)
   */
  page?: number;
  /**
   * Number of items per page (max 50)
   */
  limit?: number;
  /**
   * Filter by organization type
   */
  type?: AdminOrganizationsControllerFindAllForAdminType;
  /**
   * Filter by organization name (partial match)
   */
  name?: string;
  /**
   * Filter by organization ID
   */
  id?: string;
};

export type DraftsApiControllerFindAllByOrgIdParams = {
  page: number;
  limit: number;
  orderBy: string[];
};

export type InvoiceControllerFetchDetailedInvoiceParams = {
  /**
   * The invoice number
   */
  invoiceNumber: number;
};

export type InvoiceControllerFetchInvoicesPageState =
  (typeof InvoiceControllerFetchInvoicesPageState)[keyof typeof InvoiceControllerFetchInvoicesPageState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceControllerFetchInvoicesPageState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export type InvoiceControllerFetchInvoicesPageParams = {
  orderNumber?: number;
  invoiceNumber?: number;
  brandOrganizationId?: string;
  retailerOrganizationId?: string;
  paidTo?: string;
  paidBy?: string;
  state?: InvoiceControllerFetchInvoicesPageState;
  page: number;
  numItemsPerPage: number;
};

export type AccountingPageControllerFetchJournalsForDatesParams = {
  /**
   * The start date
   */
  startDate: string;
  /**
   * The end date
   */
  endDate: string;
};

export type AccountingPageControllerGetQuickbooksInvoicesForMultipleOrdersParams = {
  orderIds: string[];
};

export type AccountingPageControllerCsvPaymentStatusItem =
  (typeof AccountingPageControllerCsvPaymentStatusItem)[keyof typeof AccountingPageControllerCsvPaymentStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountingPageControllerCsvPaymentStatusItem = {
  UNPAID: 'UNPAID',
  COD_PAID: 'COD_PAID',
  NET_TERMS_PAID: 'NET_TERMS_PAID',
  REMITTED: 'REMITTED',
  SELF_COLLECTED: 'SELF_COLLECTED',
  PROCESSING: 'PROCESSING',
  PAYMENT_SENT: 'PAYMENT_SENT',
  WRITE_OFF: 'WRITE_OFF',
  THIRD_PARTY_COLLECTIONS: 'THIRD_PARTY_COLLECTIONS',
  PARTIAL_PAID: 'PARTIAL_PAID',
  DRIVER_PROCESSING: 'DRIVER_PROCESSING',
} as const;

export type AccountingPageControllerCsvParams = {
  /**
   * The start date for the CSV export in ISO 8601 format (e.g., YYYY-MM-DD). Optional.
   */
  startDate?: string;
  /**
   * The end date for the CSV export in ISO 8601 format (e.g., YYYY-MM-DD). Must be within 60 days from the start date. Optional.
   */
  endDate?: string;
  /**
   * The order number to filter results by. Optional.
   */
  orderNumber?: number;
  /**
   * The name of the retailer to filter results by. Optional.
   */
  retailerName?: string;
  /**
   * The name of the brand to filter results by. Optional.
   */
  brandName?: string;
  /**
   * The payment status of the order to filter results by. Optional.
   */
  paymentStatus?: AccountingPageControllerCsvPaymentStatusItem[];
};

export type AccountingPageControllerFindAllPaymentStatusItem =
  (typeof AccountingPageControllerFindAllPaymentStatusItem)[keyof typeof AccountingPageControllerFindAllPaymentStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountingPageControllerFindAllPaymentStatusItem = {
  UNPAID: 'UNPAID',
  COD_PAID: 'COD_PAID',
  NET_TERMS_PAID: 'NET_TERMS_PAID',
  REMITTED: 'REMITTED',
  SELF_COLLECTED: 'SELF_COLLECTED',
  PROCESSING: 'PROCESSING',
  PAYMENT_SENT: 'PAYMENT_SENT',
  WRITE_OFF: 'WRITE_OFF',
  THIRD_PARTY_COLLECTIONS: 'THIRD_PARTY_COLLECTIONS',
  PARTIAL_PAID: 'PARTIAL_PAID',
  DRIVER_PROCESSING: 'DRIVER_PROCESSING',
} as const;

export type AccountingPageControllerFindAllParams = {
  /**
   * The page number for paginated results, starting from 1.
   */
  page: number;
  /**
   * The number of items per page for paginated results. Defaults to 10, with a maximum of 50.
   */
  limit: number;
  /**
   * The order number to filter results by. Optional.
   */
  orderNumber?: number;
  /**
   * The name of the retailer to filter results by. Optional.
   */
  retailerName?: string;
  /**
   * The name of the brand to filter results by. Optional.
   */
  brandName?: string;
  /**
   * The payment status of the order to filter results by. Optional.
   */
  paymentStatus?: AccountingPageControllerFindAllPaymentStatusItem[];
};

export type ZipcodesControllerFindAllPeriod =
  (typeof ZipcodesControllerFindAllPeriod)[keyof typeof ZipcodesControllerFindAllPeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZipcodesControllerFindAllPeriod = {
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
  AS_NEEDED: 'AS_NEEDED',
} as const;

export type ZipcodesControllerFindAllState =
  (typeof ZipcodesControllerFindAllState)[keyof typeof ZipcodesControllerFindAllState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZipcodesControllerFindAllState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export type ZipcodesControllerFindAllParams = {
  page: number;
  limit: number;
  zipcode?: string;
  city?: string;
  state?: ZipcodesControllerFindAllState;
  county?: string;
  receivingWarehouseId?: string;
  deliveringWarehouseId?: string;
  period?: ZipcodesControllerFindAllPeriod;
};

export type ItemPricingControllerFindForItemsParams = {
  itemIds: string[];
};

export type GetManyBaseAdminOrdersControllerFullOrderViewEntityParams = {
  /**
   * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
   */
  fields?: string[];
  /**
   * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
   */
  s?: string;
  /**
   * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
   */
  filter?: string[];
  /**
   * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
   */
  or?: string[];
  /**
   * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
   */
  sort?: string[];
  /**
   * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
   */
  join?: string[];
  /**
   * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
   */
  limit?: number;
  /**
   * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
   */
  offset?: number;
  /**
   * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
   */
  page?: number;
  /**
   * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
   */
  cache?: number;
};

export type StagingAreasControllerFindManyWithPaginationParams = {
  page: number;
  limit: number;
  warehouseId?: string;
};

export type ItemsControllerFindManyWithDetailsPaginationParams = {
  page: number;
  limit: number;
  orderBy: string[];
  /**
   * searches for items with code and name
   */
  s?: string;
};

export type ItemsControllerFindAllParams = {
  page: number;
  limit: number;
  orderBy?: string[];
  /**
   * Filter by name
   */
  itemNameSearch?: string;
};

export type FeeControllerFindOneParams = {
  /**
   * Unique identifier for order fee
   */
  id: string;
  /**
   * User id that is requesting order fees
   */
  userId: string;
};

export type FeeControllerFindAllParams = {
  /**
   * order id associated with order fees
   */
  orderId: string;
  /**
   * User id that is requesting order fees
   */
  userId: string;
};

export type FeeControllerDeleteOrderFeeParams = {
  /**
   * Unique identifier for the order fee to be deleted
   */
  id: string;
  /**
   * Unique identifier for the user requesting the deletion
   */
  userId: string;
};

export type OrganizationContactControllerFindOneParams = {
  /**
   * Type of org contact. Options: AUTHORIZED_FINANCIAL_CONTACT,AUTHORIZED_TAX_CONTACT
   */
  contactType: string;
};

export type FeatureFlagControllerFindOneParams = {
  /**
   * Optional organization alias for organization-based feature flags
   */
  organizationAlias?: string;
};

export type TaxControllerGetApplicableTaxesParams = {
  /**
   * Reference date for tax calculation
   */
  referenceDateOnly?: string;
  /**
   * US state code
   */
  state: string;
};

export type TaxControllerGetActiveTaxParams = {
  /**
   * Reference date for tax calculation
   */
  referenceDateOnly?: string;
  /**
   * US state code
   */
  state: string;
};

export type ItemBatchesControllerFindManyWithDetailsPaginationParams = {
  page: number;
  limit: number;
  orderBy: string[];
  /**
   * searches for item batches with item code and name
   */
  s?: string;
};

export type ItemBatchesControllerFindManyByIdsParams = {
  /**
   * The IDs of item batches to fetch
   */
  ibIds: string[];
};

export type ItemBatchesControllerFindManyWithPaginationParams = {
  page: number;
  limit: number;
  /**
   * Include archived rows
   */
  includeArchived?: boolean;
  /**
   * Include out of stock items
   */
  includeOutOfStock?: boolean;
  includeExpired: boolean;
  /**
   * searches for item batches with item code and name
   */
  searchTerm?: string;
  /**
   * Filter by warehouse ID
   */
  warehouseId?: string;
};

export type DatepickersControllerGetDatePickerDatesTimezone =
  (typeof DatepickersControllerGetDatePickerDatesTimezone)[keyof typeof DatepickersControllerGetDatePickerDatesTimezone];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DatepickersControllerGetDatePickerDatesTimezone = {
  'America/Anchorage': 'America/Anchorage',
  'America/Phoenix': 'America/Phoenix',
  'America/Chicago': 'America/Chicago',
  'America/New_York': 'America/New_York',
  'Pacific/Honolulu': 'Pacific/Honolulu',
  'America/Denver': 'America/Denver',
  'America/Los_Angeles': 'America/Los_Angeles',
  'Etc/UTC': 'Etc/UTC',
} as const;

export type DatepickersControllerGetDatePickerDatesParams = {
  licensedLocationId: string;
  action: string;
  /**
   * Optional timezone to use for proper date values (defaults to Eastern US)
   */
  timezone?: DatepickersControllerGetDatePickerDatesTimezone;
  /**
   * Allows a Nabis Admin user to view delivery dates as if they were a brand user
   */
  isBrandUserViewForNabisAdmin?: boolean;
};

export type LicensesControllerFindManyWithPaginationParams = {
  page: number;
  limit: number;
};

export type LicensesControllerFindAllActiveDistributionLicensesForOrganizationParams = {
  state: string;
  date: string;
};

export type LicensesControllerFindManyWithPaginationForOrganizationParams = {
  page: number;
  limit: number;
  /**
   * Filter by nickname
   */
  licenseNicknameSearch?: string;
};

export type LicensesControllerFindManyWithPaginationForLicensedLocationParams = {
  page: number;
  limit: number;
};

export type WarehouseControllerFindAllParams = {
  page: number;
  limit: number;
};

export type ShipmentsControllerGetOrderStatusItem =
  (typeof ShipmentsControllerGetOrderStatusItem)[keyof typeof ShipmentsControllerGetOrderStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsControllerGetOrderStatusItem = {
  UNSCHEDULED: 'UNSCHEDULED',
  SCHEDULED: 'SCHEDULED',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSFERRING: 'TRANSFERRING',
  DELIVERED: 'DELIVERED',
  DELIVERED_WITH_EDITS: 'DELIVERED_WITH_EDITS',
  DELAYED: 'DELAYED',
  CANCELED: 'CANCELED',
  REJECTED: 'REJECTED',
  ATTEMPTED: 'ATTEMPTED',
} as const;

export type ShipmentsControllerGetShipmentStatusItem =
  (typeof ShipmentsControllerGetShipmentStatusItem)[keyof typeof ShipmentsControllerGetShipmentStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsControllerGetShipmentStatusItem = {
  CREATED: 'CREATED',
  TRANSFER_CANCELED: 'TRANSFER_CANCELED',
  TRANSFER_COMPLETE: 'TRANSFER_COMPLETE',
  TRANSFER_DELAYED: 'TRANSFER_DELAYED',
  TRANSFERRING: 'TRANSFERRING',
} as const;

export type ShipmentsControllerGetOrderActionItem =
  (typeof ShipmentsControllerGetOrderActionItem)[keyof typeof ShipmentsControllerGetOrderActionItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsControllerGetOrderActionItem = {
  DELIVERY_TO_RETAILER: 'DELIVERY_TO_RETAILER',
  DELIVERY_TO_BRAND: 'DELIVERY_TO_BRAND',
  DROPOFF_TO_NABIS: 'DROPOFF_TO_NABIS',
  PICKUP_FROM_BRAND: 'PICKUP_FROM_BRAND',
  PICKUP_FROM_NABIS: 'PICKUP_FROM_NABIS',
  RETURN_FROM_RETAILER: 'RETURN_FROM_RETAILER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
} as const;

export type ShipmentsControllerGetParams = {
  page: number;
  limit: number;
  receiveDateStart?: string;
  receiveDateEnd?: string;
  orderNumber?: number;
  orderAction?: ShipmentsControllerGetOrderActionItem[];
  orderId?: string;
  originLicensedLocationId?: string;
  destinationLicensedLocationId?: string;
  stagingAreaId?: string;
  shipmentStatus?: ShipmentsControllerGetShipmentStatusItem[];
  orderStatus?: ShipmentsControllerGetOrderStatusItem[];
  vehicleId?: string;
  driverId?: string;
  isStaged?: boolean;
  isUnloaded?: boolean;
  isLoaded?: boolean;
  isPicked?: boolean;
  isPrinted?: boolean;
};

export type DriversControllerFindManyWithPaginationParams = {
  page: number;
  limit: number;
  /**
   * Filter by archived status
   */
  archived?: boolean;
};

export type DriversControllerFindOneParams = {
  email: string;
};

export type VehiclesControllerFindManyWithPaginationParams = {
  page: number;
  limit: number;
  /**
   * Filter by archived status
   */
  archived?: boolean;
};

export type GetManyBaseOrdersViewControllerFullOrderViewEntityParams = {
  /**
   * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
   */
  fields?: string[];
  /**
   * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
   */
  s?: string;
  /**
   * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
   */
  filter?: string[];
  /**
   * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
   */
  or?: string[];
  /**
   * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
   */
  sort?: string[];
  /**
   * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
   */
  join?: string[];
  /**
   * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
   */
  limit?: number;
  /**
   * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
   */
  offset?: number;
  /**
   * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
   */
  page?: number;
  /**
   * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
   */
  cache?: number;
};

export type OrdersControllerGetBalancesParams = {
  page: number;
  limit: number;
  status: string;
};

export type OrdersControllerAdminFindAllParams = {
  page: number;
  limit: number;
  orderBy?: string[];
  licensedLocationNames: string[];
  licensedLocationIds: string[];
  organizationIds: string[];
};

export type OrdersControllerTriggerDetailedCsvEmailForAdminParams = {
  organizationIds: string[];
};

export type OrdersControllerTriggerCsvEmailForAdminParams = {
  organizationIds: string[];
};

export type OrdersControllerFindAllParams = {
  page: number;
  limit: number;
  orderBy?: string[];
  licensedLocationNames: string[];
  licensedLocationIds: string[];
  organizationIds: string[];
};

export type CreditMemoControllerFindForOrganizationParams = {
  includeApplied?: boolean;
};

export type DocumentationsControllerGetPresignedLinks200 = {
  data?: string[];
};

export type FileUploadControllerUploadFile200 = {
  filePath?: string;
};

export type FileUploadControllerUploadFileBody = {
  file?: Blob;
  module?: string;
};

export type BatchesControllerCreateCoa200 = {
  filePath?: string;
};

export type BatchesControllerCreateCoaBody = {
  file?: Blob;
};

export type BatchesControllerFindManyWithDetailsPaginationParams = {
  page: number;
  limit: number;
  orderBy: string[];
  /**
   * searches for batches with code and product name
   */
  s?: string;
};

export type BatchesControllerFindManyWithPaginationParams = {
  page: number;
  limit: number;
  /**
   * Filter by code
   */
  batchCodeSearch?: string;
};

export type OrganizationUsersControllerFindManyWithPaginationParams = {
  page: number;
  limit: number;
};

export type LicensedLocationsControllerFindManyForOrderFormWithPaginationParams = {
  page: number;
  limit: number;
  action: string;
  organizationId: string;
  llIds: string[];
};

export type LicensedLocationsControllerFindManyWithPaginationParams = {
  page: number;
  limit: number;
  include: string[];
};

export type OrganizationWarehouseControllerFindOneParams = {
  relationshipType: string;
};

export type OrganizationsControllerFindManyWithPagination200 = {
  data?: OrganizationEntity[];
  hasNextPage?: boolean;
};

export type OrganizationsControllerFindManyWithPaginationParams = {
  page: number;
  limit: number;
  /**
   * Filter by organization type
   */
  type?: string;
  /**
   * Filter by organization name
   */
  name?: string;
  /**
   * Filter by organization name
   */
  id?: string;
};

export type UsersControllerFindAllParams = {
  page: number;
  limit: number;
  onlyShowNabisUsers: boolean;
};

export type RoleEnumsDtoRoleOrgType = (typeof RoleEnumsDtoRoleOrgType)[keyof typeof RoleEnumsDtoRoleOrgType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleEnumsDtoRoleOrgType = {
  BRAND: 'BRAND',
  RETAILER: 'RETAILER',
} as const;

export type RoleEnumsDtoRoleType = (typeof RoleEnumsDtoRoleType)[keyof typeof RoleEnumsDtoRoleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleEnumsDtoRoleType = {
  NABIS: 'NABIS',
  ORGANIZATION: 'ORGANIZATION',
} as const;

export type RoleEnumsDtoRoleName = (typeof RoleEnumsDtoRoleName)[keyof typeof RoleEnumsDtoRoleName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleEnumsDtoRoleName = {
  NABIS_DASHBOARD_ADMIN: 'NABIS_DASHBOARD_ADMIN',
  NABIS_ADMIN: 'NABIS_ADMIN',
  ORG_ADMIN: 'ORG_ADMIN',
  AYRLOOM_ADMIN: 'AYRLOOM_ADMIN',
  TABLEAU_ANALYTICS_USER: 'TABLEAU_ANALYTICS_USER',
  ACCOUNTING_USER: 'ACCOUNTING_USER',
  CAN_MANAGE_USER: 'CAN_MANAGE_USER',
} as const;

export interface RoleEnumsDto {
  roleName: RoleEnumsDtoRoleName;
  roleType: RoleEnumsDtoRoleType;
  roleOrgType: RoleEnumsDtoRoleOrgType;
}

export type OrganizationContactEnumsDtoOrganizationContactEnum =
  (typeof OrganizationContactEnumsDtoOrganizationContactEnum)[keyof typeof OrganizationContactEnumsDtoOrganizationContactEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationContactEnumsDtoOrganizationContactEnum = {
  AUTHORIZED_FINANCIAL_CONTACT: 'AUTHORIZED_FINANCIAL_CONTACT',
  AUTHORIZED_TAX_CONTACT: 'AUTHORIZED_TAX_CONTACT',
} as const;

export interface OrganizationContactEnumsDto {
  organizationContactEnum: OrganizationContactEnumsDtoOrganizationContactEnum;
}

export type OrderDirectionDtoDirection = (typeof OrderDirectionDtoDirection)[keyof typeof OrderDirectionDtoDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderDirectionDtoDirection = {
  INCOMING: 'INCOMING',
  OUTGOING: 'OUTGOING',
  INCOMING_OUTGOING: 'INCOMING_OUTGOING',
} as const;

export interface OrderDirectionDto {
  direction: OrderDirectionDtoDirection;
}

export type PasswordValidationConfiguration =
  (typeof PasswordValidationConfiguration)[keyof typeof PasswordValidationConfiguration];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PasswordValidationConfiguration = {
  NUMBER_3: 3,
} as const;

export interface PasswordValidation {
  configuration: PasswordValidationConfiguration;
}

export type ItemClassesResponseCannabisInventoryClassEnum =
  (typeof ItemClassesResponseCannabisInventoryClassEnum)[keyof typeof ItemClassesResponseCannabisInventoryClassEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemClassesResponseCannabisInventoryClassEnum = {
  CONCENTRATE: 'CONCENTRATE',
  EDIBLES: 'EDIBLES',
  FLOWER: 'FLOWER',
  PRE_ROLL: 'PRE_ROLL',
  VAPE: 'VAPE',
  PERSONAL_CARE: 'PERSONAL_CARE',
} as const;

export type ItemClassesResponseNonCannabisInventoryClassEnum =
  (typeof ItemClassesResponseNonCannabisInventoryClassEnum)[keyof typeof ItemClassesResponseNonCannabisInventoryClassEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemClassesResponseNonCannabisInventoryClassEnum = {
  PERSONAL_CARE: 'PERSONAL_CARE',
  ACCESSORIES: 'ACCESSORIES',
} as const;

export interface ItemClassesResponse {
  NonCannabisInventoryClassEnum: ItemClassesResponseNonCannabisInventoryClassEnum;
  CannabisInventoryClassEnum: ItemClassesResponseCannabisInventoryClassEnum;
}

/**
 * Scope of the notification
 */
export type CreateOrderStatusNotificationDtoScope =
  (typeof CreateOrderStatusNotificationDtoScope)[keyof typeof CreateOrderStatusNotificationDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderStatusNotificationDtoScope = {
  MY_ORDERS: 'MY_ORDERS',
  ALL_ORDERS: 'ALL_ORDERS',
} as const;

/**
 * Type of notification
 */
export type CreateOrderStatusNotificationDtoNotificationType =
  (typeof CreateOrderStatusNotificationDtoNotificationType)[keyof typeof CreateOrderStatusNotificationDtoNotificationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderStatusNotificationDtoNotificationType = {
  ORDER_STATUS: 'ORDER_STATUS',
} as const;

export interface SubscribedStatusDto {
  /** Subscribed to delivered status */
  DELIVERED: boolean;
  /** Subscribed to rejected status */
  REJECTED: boolean;
  /** Subscribed to deliveredWithEdits status */
  DELIVERED_WITH_EDITS: boolean;
  /** Subscribed to canceled status */
  CANCELED: boolean;
  /** Subscribed to scheduled status */
  SCHEDULED: boolean;
}

export interface CreateOrderStatusNotificationDto {
  /** Type of notification */
  notificationType: CreateOrderStatusNotificationDtoNotificationType;
  /** Scope of the notification */
  scope: CreateOrderStatusNotificationDtoScope;
  /** Statuses the user is subscribed to */
  subscribedStatus: SubscribedStatusDto;
  /** Indicates if the subscription is active */
  isActive: boolean;
  /** Organization ID of the subscriber */
  organizationId: string;
}

/**
 * Scope of the notification
 */
export type OrderStatusSubscriptionDetailsDtoScope =
  (typeof OrderStatusSubscriptionDetailsDtoScope)[keyof typeof OrderStatusSubscriptionDetailsDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderStatusSubscriptionDetailsDtoScope = {
  MY_ORDERS: 'MY_ORDERS',
  ALL_ORDERS: 'ALL_ORDERS',
} as const;

/**
 * Type of notification subscribed
 */
export type OrderStatusSubscriptionDetailsDtoNotificationType =
  (typeof OrderStatusSubscriptionDetailsDtoNotificationType)[keyof typeof OrderStatusSubscriptionDetailsDtoNotificationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderStatusSubscriptionDetailsDtoNotificationType = {
  ORDER_STATUS: 'ORDER_STATUS',
} as const;

export interface OrderStatusSubscriptionDetailsDto {
  /** Unique ID of the subscription */
  id: string;
  /** Type of notification subscribed */
  notificationType: OrderStatusSubscriptionDetailsDtoNotificationType;
  /** Scope of the notification */
  scope: OrderStatusSubscriptionDetailsDtoScope;
  /** List of subscribed statuses */
  subscribedStatus: string[];
  /** Is the subscription active? */
  isActive: boolean;
  /** User ID of the subscriber */
  userId: string;
  /** Organization ID of the subscriber */
  organizationId: string;
}

export interface OrderStatusSubscriptionCheckDto {
  /** Is the user subscribed for order status notification */
  isSubscribed: boolean;
}

export interface DownloadReportCSVPayloadDTO {
  /** The signed url */
  signedUrl: string;
}

/**
 * The state
 */
export type UpdateDatesRemittanceReportInputDTOBaseState =
  (typeof UpdateDatesRemittanceReportInputDTOBaseState)[keyof typeof UpdateDatesRemittanceReportInputDTOBaseState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDatesRemittanceReportInputDTOBaseState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface UpdateDatesRemittanceReportInputDTOBase {
  /** The remittance report id */
  remittanceReportId: string;
  /** The start date */
  startDate: string;
  /** The end date */
  endDate: string;
  /** The state */
  state: UpdateDatesRemittanceReportInputDTOBaseState;
}

export interface RemittanceReportAcceptRejectInputDTOBase {
  /** The remittance report id */
  remittanceReportId: string;
  /** The state */
  state: string;
}

export interface RemittanceReportSibanGenerationInputDtoBase {
  /** The nabis org id */
  nabisOrgId: string;
  /** The start date */
  startDate: string;
  /** The end date */
  endDate: string;
  /** The state */
  state: string;
}

export interface RemittanceReportGenerationInputDtoBase {
  /** The org id */
  orgId: string;
  /** The start date */
  startDate: string;
  /** The end date */
  endDate: string;
  /** The state */
  state: string;
}

/**
 * The status
 */
export type RemittanceReportStatus = (typeof RemittanceReportStatus)[keyof typeof RemittanceReportStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RemittanceReportStatus = {
  GENERATED: 'GENERATED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
} as const;

export interface RemittanceReport {
  /** The id */
  id: string;
  /** The created at */
  createdAt: string;
  /** The finalized user id */
  finalizedUserId?: string;
  /** The generated user id */
  generatedUserId: string;
  /** The status */
  status: RemittanceReportStatus;
  /** The org id */
  orgId: string;
  /** The start date */
  startDate: string;
  /** The end date */
  endDate: string;
  /** The amount */
  amount: number;
  /** The s3 link */
  s3Link: string;
}

export interface FetchRemittanceReportByOrgPayloadDTO {
  /** The page info */
  pageInfo: PageInfo;
  /** The remittance reports */
  remittanceReports?: RemittanceReport[];
}

/**
 * The state
 */
export type GenerateUndeliveredOrdersTransactionsCSVInputDTOState =
  (typeof GenerateUndeliveredOrdersTransactionsCSVInputDTOState)[keyof typeof GenerateUndeliveredOrdersTransactionsCSVInputDTOState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateUndeliveredOrdersTransactionsCSVInputDTOState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface GenerateUndeliveredOrdersTransactionsCSVInputDTO {
  /** The state */
  state: GenerateUndeliveredOrdersTransactionsCSVInputDTOState;
  /** The email */
  email: string;
}

/**
 * The state
 */
export type GenerateSundayTransactionsCSVInputDTOState =
  (typeof GenerateSundayTransactionsCSVInputDTOState)[keyof typeof GenerateSundayTransactionsCSVInputDTOState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateSundayTransactionsCSVInputDTOState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface GenerateSundayTransactionsCSVInputDTO {
  /** The state */
  state: GenerateSundayTransactionsCSVInputDTOState;
  /** The email */
  email: string;
}

export interface UpdateAdjustmentMetaFieldsDTO {
  /** The adjustment number */
  adjustmentNumber: number;
  /** The adjusted at */
  adjustedAt: string;
  /** The name */
  name: string;
  /** The state */
  state: string;
}

/**
 * The state
 */
export type RollbackTransactionByNumberInputBaseState =
  (typeof RollbackTransactionByNumberInputBaseState)[keyof typeof RollbackTransactionByNumberInputBaseState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RollbackTransactionByNumberInputBaseState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

/**
 * The rollback reason
 */
export type RollbackTransactionByNumberInputBaseRollbackReason =
  (typeof RollbackTransactionByNumberInputBaseRollbackReason)[keyof typeof RollbackTransactionByNumberInputBaseRollbackReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RollbackTransactionByNumberInputBaseRollbackReason = {
  BOUNCED_CHECK: 'BOUNCED_CHECK',
  RETURNED_ACH: 'RETURNED_ACH',
  PAYMENT_CREATION_ERROR: 'PAYMENT_CREATION_ERROR',
  LA_CHANGED_ALLOCATION_INSTRUCTIONS: 'LA_CHANGED_ALLOCATION_INSTRUCTIONS',
  LA_INCORRECT_APPLICATION: 'LA_INCORRECT_APPLICATION',
  LA_PAYMENT_APPLIED_ON_REJECTED_ORDER: 'LA_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  LA_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION: 'LA_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  LA_TYPO_ON_PAYMENT_INSTRUCTIONS: 'LA_TYPO_ON_PAYMENT_INSTRUCTIONS',
  OAK_CHANGED_ALLOCATION_INSTRUCTIONS: 'OAK_CHANGED_ALLOCATION_INSTRUCTIONS',
  OAK_INCORRECT_APPLICATION: 'OAK_INCORRECT_APPLICATION',
  OAK_PAYMENT_APPLIED_ON_REJECTED_ORDER: 'OAK_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  OAK_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION: 'OAK_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  OAK_TYPO_ON_PAYMENT_INSTRUCTIONS: 'OAK_TYPO_ON_PAYMENT_INSTRUCTIONS',
  WL_CHANGED_ALLOCATION_INSTRUCTIONS: 'WL_CHANGED_ALLOCATION_INSTRUCTIONS',
  WL_INCORRECT_APPLICATION: 'WL_INCORRECT_APPLICATION',
  WL_PAYMENT_APPLIED_ON_REJECTED_ORDER: 'WL_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  WL_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION: 'WL_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  WL_TYPO_ON_PAYMENT_INSTRUCTIONS: 'WL_TYPO_ON_PAYMENT_INSTRUCTIONS',
  SF_CHANGED_ALLOCATION_INSTRUCTIONS: 'SF_CHANGED_ALLOCATION_INSTRUCTIONS',
  SF_INCORRECT_APPLICATION: 'SF_INCORRECT_APPLICATION',
  SF_PAYMENT_APPLIED_ON_REJECTED_ORDER: 'SF_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  SF_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION: 'SF_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  SF_TYPO_ON_PAYMENT_INSTRUCTIONS: 'SF_TYPO_ON_PAYMENT_INSTRUCTIONS',
  ROC_CHANGED_ALLOCATION_INSTRUCTIONS: 'ROC_CHANGED_ALLOCATION_INSTRUCTIONS',
  ROC_INCORRECT_APPLICATION: 'ROC_INCORRECT_APPLICATION',
  ROC_PAYMENT_APPLIED_ON_REJECTED_ORDER: 'ROC_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  ROC_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION: 'ROC_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  ROC_TYPO_ON_PAYMENT_INSTRUCTIONS: 'ROC_TYPO_ON_PAYMENT_INSTRUCTIONS',
  BX_CHANGED_ALLOCATION_INSTRUCTIONS: 'BX_CHANGED_ALLOCATION_INSTRUCTIONS',
  BX_INCORRECT_APPLICATION: 'BX_INCORRECT_APPLICATION',
  BX_PAYMENT_APPLIED_ON_REJECTED_ORDER: 'BX_PAYMENT_APPLIED_ON_REJECTED_ORDER',
  BX_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION: 'BX_PRICE_CHANGED_AFTER_PAYMENT_APPLICATION',
  BX_TYPO_ON_PAYMENT_INSTRUCTIONS: 'BX_TYPO_ON_PAYMENT_INSTRUCTIONS',
} as const;

export interface RollbackTransactionByNumberInputBase {
  /** The transaction number */
  transactionNumber: number;
  /** The rollback date */
  rollbackDate: string;
  /** The rollback reason */
  rollbackReason?: RollbackTransactionByNumberInputBaseRollbackReason;
  /** The state */
  state: RollbackTransactionByNumberInputBaseState;
}

export interface ApplyTransactionInputUpdateDto {
  /** The transaction number */
  transactionNumber: number;
  /** The applied at */
  appliedAt: string;
}

export interface ApplyTransactionInputNewDto {
  /** The amount */
  amount: number;
  /** The applied at */
  appliedAt: string;
  /** The invoice number */
  invoiceNumber: number;
}

export interface ApplyTransactionInputDTO {
  /** The new transactions */
  newTransactions: ApplyTransactionInputNewDto[];
  /** The update transactions */
  updateTransactions: ApplyTransactionInputUpdateDto[];
  /** The original transaction number */
  originalTransactionNumber: number;
  /** The state */
  state: string;
}

export interface FetchDetailedInvoicesByNumberPayloadDTOSingle {
  /** The invoice */
  invoice: InvoiceWithCalculatedFinancialFieldsAndOrgNames;
  /** The invoice type */
  invoiceType: InvoiceType;
}

export interface FetchDetailedInvoicesByNumberPayloadDTO {
  /** The matching order number */
  matchingOrderNumber: FetchDetailedInvoicesByNumberPayloadDTOSingle[];
  /** The matching invoice number */
  matchingInvoiceNumber?: FetchDetailedInvoicesByNumberPayloadDTOSingle;
}

/**
 * The state
 */
export type UpdateTransactionMetaFieldsInputDTOState =
  (typeof UpdateTransactionMetaFieldsInputDTOState)[keyof typeof UpdateTransactionMetaFieldsInputDTOState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTransactionMetaFieldsInputDTOState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

/**
 * The unapplied reason
 */
export type UpdateTransactionMetaFieldsInputDTOUnappliedReason =
  (typeof UpdateTransactionMetaFieldsInputDTOUnappliedReason)[keyof typeof UpdateTransactionMetaFieldsInputDTOUnappliedReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTransactionMetaFieldsInputDTOUnappliedReason = {
  NO_BREAKDOWN_PROVIDED: 'NO_BREAKDOWN_PROVIDED',
  INCOMPLETE_BREAKDOWN: 'INCOMPLETE_BREAKDOWN',
  UNCLEAR_BREAKDOWN: 'UNCLEAR_BREAKDOWN',
  INVALID_ORDER_NUMBER: 'INVALID_ORDER_NUMBER',
  CLOSED_PREVIOUSLY_PAID: 'CLOSED_PREVIOUSLY_PAID',
  CLOSED_ALLOCATED_WITH_OP: 'CLOSED_ALLOCATED_WITH_OP',
  CLOSED_SAMPLE_ORDER: 'CLOSED_SAMPLE_ORDER',
  CLOSED_SELF_COLLECTED: 'CLOSED_SELF_COLLECTED',
  CLOSED_SHORT_PAYMENT_ENTERED: 'CLOSED_SHORT_PAYMENT_ENTERED',
  ORDER_NOT_DELIVERED_YET: 'ORDER_NOT_DELIVERED_YET',
  ORDER_REJECTED: 'ORDER_REJECTED',
  ORDER_OVERPAID: 'ORDER_OVERPAID',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  POST_DELIVERY_ADJUSTMENTS: 'POST_DELIVERY_ADJUSTMENTS',
  NO_HISTORICAL_DATA_UNKNOWN_PAYER: 'NO_HISTORICAL_DATA_UNKNOWN_PAYER',
  SITE_NOT_FLIPPED: 'SITE_NOT_FLIPPED',
  WRITE_OFF: 'WRITE_OFF',
  UNIDENTIFIED_OVERPAYMENT: 'UNIDENTIFIED_OVERPAYMENT',
  NABIS_BILLPAY: 'NABIS_BILLPAY',
  CREDIT_NOT_CONFIRMED: 'CREDIT_NOT_CONFIRMED',
  CREDIT_MISSING_INSTRUCTIONS: 'CREDIT_MISSING_INSTRUCTIONS',
  BRAND_OFFBOARDED: 'BRAND_OFFBOARDED',
  RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED: 'RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED',
  null: null,
} as const;

/**
 * The origin company
 */
export type UpdateTransactionMetaFieldsInputDTOOriginCompany =
  (typeof UpdateTransactionMetaFieldsInputDTOOriginCompany)[keyof typeof UpdateTransactionMetaFieldsInputDTOOriginCompany];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTransactionMetaFieldsInputDTOOriginCompany = {
  NABIFOUR: 'NABIFOUR',
  NABIFIVE: 'NABIFIVE',
  NABITWO: 'NABITWO',
  SIBAN: 'SIBAN',
} as const;

/**
 * The method
 */
export type UpdateTransactionMetaFieldsInputDTOMethod =
  (typeof UpdateTransactionMetaFieldsInputDTOMethod)[keyof typeof UpdateTransactionMetaFieldsInputDTOMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTransactionMetaFieldsInputDTOMethod = {
  CASH: 'CASH',
  CHECK: 'CHECK',
  EFT: 'EFT',
} as const;

/**
 * The location
 */
export type UpdateTransactionMetaFieldsInputDTOLocation =
  (typeof UpdateTransactionMetaFieldsInputDTOLocation)[keyof typeof UpdateTransactionMetaFieldsInputDTOLocation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTransactionMetaFieldsInputDTOLocation = {
  CASH_IN_OAK: 'CASH_IN_OAK',
  CASH_IN_LA: 'CASH_IN_LA',
  CASH_IN_WOODLAKE: 'CASH_IN_WOODLAKE',
  CASH_IN_SF: 'CASH_IN_SF',
  CASH_IN_ROCHESTER: 'CASH_IN_ROCHESTER',
  CASH_IN_BRONX: 'CASH_IN_BRONX',
} as const;

export interface UpdateTransactionMetaFieldsInputDTO {
  /** The transaction number */
  transactionNumber: number;
  /** The public notes */
  publicNotes?: string;
  /** The admin notes */
  adminNotes?: string;
  /** The name */
  name?: string;
  /** The paid at */
  paidAt?: string;
  /** The applied at */
  appliedAt?: string;
  /** The location */
  location?: UpdateTransactionMetaFieldsInputDTOLocation;
  /** The method */
  method?: UpdateTransactionMetaFieldsInputDTOMethod;
  /** The earmarked organizations */
  earmarkedOrganizations?: string[];
  /** The user id */
  userId?: string;
  /** The origin company */
  originCompany?: UpdateTransactionMetaFieldsInputDTOOriginCompany;
  /** The unapplied reason */
  unappliedReason?: UpdateTransactionMetaFieldsInputDTOUnappliedReason;
  /** The state */
  state: UpdateTransactionMetaFieldsInputDTOState;
}

export interface GenerateTransactionsPageCSVPayloadDTO {
  /** The message */
  message: string;
  /** The link */
  link?: string | null;
}

/**
 * The state
 */
export type GenerateTransactionsPageCSVInputDTOState =
  (typeof GenerateTransactionsPageCSVInputDTOState)[keyof typeof GenerateTransactionsPageCSVInputDTOState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateTransactionsPageCSVInputDTOState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

/**
 * The unapplied reason
 */
export type GenerateTransactionsPageCSVInputDTOUnappliedReason =
  (typeof GenerateTransactionsPageCSVInputDTOUnappliedReason)[keyof typeof GenerateTransactionsPageCSVInputDTOUnappliedReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateTransactionsPageCSVInputDTOUnappliedReason = {
  NO_BREAKDOWN_PROVIDED: 'NO_BREAKDOWN_PROVIDED',
  INCOMPLETE_BREAKDOWN: 'INCOMPLETE_BREAKDOWN',
  UNCLEAR_BREAKDOWN: 'UNCLEAR_BREAKDOWN',
  INVALID_ORDER_NUMBER: 'INVALID_ORDER_NUMBER',
  CLOSED_PREVIOUSLY_PAID: 'CLOSED_PREVIOUSLY_PAID',
  CLOSED_ALLOCATED_WITH_OP: 'CLOSED_ALLOCATED_WITH_OP',
  CLOSED_SAMPLE_ORDER: 'CLOSED_SAMPLE_ORDER',
  CLOSED_SELF_COLLECTED: 'CLOSED_SELF_COLLECTED',
  CLOSED_SHORT_PAYMENT_ENTERED: 'CLOSED_SHORT_PAYMENT_ENTERED',
  ORDER_NOT_DELIVERED_YET: 'ORDER_NOT_DELIVERED_YET',
  ORDER_REJECTED: 'ORDER_REJECTED',
  ORDER_OVERPAID: 'ORDER_OVERPAID',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  POST_DELIVERY_ADJUSTMENTS: 'POST_DELIVERY_ADJUSTMENTS',
  NO_HISTORICAL_DATA_UNKNOWN_PAYER: 'NO_HISTORICAL_DATA_UNKNOWN_PAYER',
  SITE_NOT_FLIPPED: 'SITE_NOT_FLIPPED',
  WRITE_OFF: 'WRITE_OFF',
  UNIDENTIFIED_OVERPAYMENT: 'UNIDENTIFIED_OVERPAYMENT',
  NABIS_BILLPAY: 'NABIS_BILLPAY',
  CREDIT_NOT_CONFIRMED: 'CREDIT_NOT_CONFIRMED',
  CREDIT_MISSING_INSTRUCTIONS: 'CREDIT_MISSING_INSTRUCTIONS',
  BRAND_OFFBOARDED: 'BRAND_OFFBOARDED',
  RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED: 'RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED',
  null: null,
} as const;

/**
 * The transaction type
 */
export type GenerateTransactionsPageCSVInputDTOType =
  (typeof GenerateTransactionsPageCSVInputDTOType)[keyof typeof GenerateTransactionsPageCSVInputDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateTransactionsPageCSVInputDTOType = {
  PAYMENT: 'PAYMENT',
  SELF_COLLECTED: 'SELF_COLLECTED',
  CREDIT_MEMO: 'CREDIT_MEMO',
  DISCOUNT: 'DISCOUNT',
  WRITE_OFF_NABIS: 'WRITE_OFF_NABIS',
  WRITE_OFF_EXTERNAL: 'WRITE_OFF_EXTERNAL',
  NABIS_CREDIT_MEMO: 'NABIS_CREDIT_MEMO',
} as const;

/**
 * The transaction type
 */
export type GenerateTransactionsPageCSVInputDTOTransactionType =
  (typeof GenerateTransactionsPageCSVInputDTOTransactionType)[keyof typeof GenerateTransactionsPageCSVInputDTOTransactionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateTransactionsPageCSVInputDTOTransactionType = {
  PAYMENT: 'PAYMENT',
  SELF_COLLECTED: 'SELF_COLLECTED',
  CREDIT_MEMO: 'CREDIT_MEMO',
  DISCOUNT: 'DISCOUNT',
  WRITE_OFF_NABIS: 'WRITE_OFF_NABIS',
  WRITE_OFF_EXTERNAL: 'WRITE_OFF_EXTERNAL',
  NABIS_CREDIT_MEMO: 'NABIS_CREDIT_MEMO',
} as const;

export interface GenerateTransactionsPageCSVInputDTO {
  /** The transaction number */
  transactionNumber?: number;
  /** The transaction type */
  transactionType?: GenerateTransactionsPageCSVInputDTOTransactionType;
  /** The from account ids */
  fromAccountId?: string[];
  /** The to account ids */
  toAccountId?: string[];
  /** The original transaction number */
  originalTransactionNumber?: number;
  /** The name */
  name?: string;
  /** The before created at date */
  beforeCreatedAtDate?: string;
  /** The after created at date */
  afterCreatedAtDate?: string;
  /** The same created at date */
  sameCreatedAtDate?: string;
  /** The before paid at date */
  beforePaidAtDate?: string;
  /** The after paid at date */
  afterPaidAtDate?: string;
  /** The same paid at date */
  samePaidAtDate?: string;
  /** The before remitted at date */
  beforeRemittedAtDate?: string;
  /** The after remitted at date */
  afterRemittedAtDate?: string;
  /** The same remitted at date */
  sameRemittedAtDate?: string;
  /** The before applied at date */
  beforeAppliedAtDate?: string;
  /** The after applied at date */
  afterAppliedAtDate?: string;
  /** The same applied at date */
  sameAppliedAtDate?: string;
  /** The paid by */
  paidBy?: string;
  /** The at least amount */
  atLeastAmount?: number;
  /** The at most amount */
  atMostAmount?: number;
  /** The equal amount */
  equalAmount?: number;
  /** The at least unapplied */
  atLeastUnapplied?: number;
  /** The at most unapplied */
  atMostUnapplied?: number;
  /** The equal unapplied */
  equalUnapplied?: number;
  /** The location */
  location?: string;
  /** The invoice paid to */
  invoicePaidTo?: string;
  /** The invoice paid by */
  invoicePaidBy?: string;
  /** The transaction type */
  type?: GenerateTransactionsPageCSVInputDTOType;
  /** The paid by organization for group */
  paidByForGroup?: string;
  /** The order number the original transaction has children attached to */
  appliedOrderNumber?: number;
  /** The unapplied reason */
  unappliedReason?: GenerateTransactionsPageCSVInputDTOUnappliedReason;
  /** The state */
  state: GenerateTransactionsPageCSVInputDTOState;
  /** The text search */
  textSearch?: string;
  /** The page info */
  pageInfo?: PageInfoInput;
  /** The email */
  email: string;
}

/**
 * The state
 */
export type EarmarkedOrganizationWithOrgNameState =
  (typeof EarmarkedOrganizationWithOrgNameState)[keyof typeof EarmarkedOrganizationWithOrgNameState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EarmarkedOrganizationWithOrgNameState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface EarmarkedOrganizationWithOrgName {
  /** The id */
  id: string;
  /** The created at */
  createdAt: string;
  /** The updated at */
  updatedAt?: string;
  /** The deleted at */
  deletedAt?: string;
  /** The state */
  state: EarmarkedOrganizationWithOrgNameState;
  /** The organization id */
  organizationId: string;
  /** The transaction id */
  transactionId: string;
  /** The organization name */
  organizationName: string;
}

export interface FetchDetailedTransactionPayloadDTO {
  /** The transaction */
  transaction: TransactionWithOrgName;
  /** The children transaction group */
  childrenTransactions: FetchDetailedTransactionChildrenTransactionGroup[];
  /** The from account */
  fromAccount?: Account;
  /** The to account */
  toAccount?: Account;
  /** The invoice */
  invoice?: InvoiceWithCalculatedFinancialFieldsAndOrgNames;
  /** The original transaction */
  originalTransaction?: TransactionWithOrgName;
  /** The earmarked organizations */
  earmarkedOrganizations?: EarmarkedOrganizationWithOrgName[];
}

export interface FetchDetailedTransactionChildrenTransactionInvoiceGroup {
  /** The invoice */
  invoice: InvoiceWithCalculatedFinancialFieldsAndOrgNames;
  /** The invoice type */
  invoiceType: InvoiceType;
}

export interface FetchDetailedTransactionChildrenTransactionGroup {
  /** The transaction */
  transaction: TransactionWithOrgName;
  /** The invoice group containing the invoice and invoice type */
  invoice: FetchDetailedTransactionChildrenTransactionInvoiceGroup;
}

export interface FetchAllAccountsPayloadDTO {
  /** The accounts */
  accounts: Account[];
}

export interface RecordTransactionPayloadDTO {
  /** The transaction */
  transaction: Transaction;
}

/**
 * The state
 */
export type RecordTransactionUIInputDTOState =
  (typeof RecordTransactionUIInputDTOState)[keyof typeof RecordTransactionUIInputDTOState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordTransactionUIInputDTOState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

/**
 * The unapplied reason
 */
export type RecordTransactionUIInputDTOUnappliedReason =
  (typeof RecordTransactionUIInputDTOUnappliedReason)[keyof typeof RecordTransactionUIInputDTOUnappliedReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordTransactionUIInputDTOUnappliedReason = {
  NO_BREAKDOWN_PROVIDED: 'NO_BREAKDOWN_PROVIDED',
  INCOMPLETE_BREAKDOWN: 'INCOMPLETE_BREAKDOWN',
  UNCLEAR_BREAKDOWN: 'UNCLEAR_BREAKDOWN',
  INVALID_ORDER_NUMBER: 'INVALID_ORDER_NUMBER',
  CLOSED_PREVIOUSLY_PAID: 'CLOSED_PREVIOUSLY_PAID',
  CLOSED_ALLOCATED_WITH_OP: 'CLOSED_ALLOCATED_WITH_OP',
  CLOSED_SAMPLE_ORDER: 'CLOSED_SAMPLE_ORDER',
  CLOSED_SELF_COLLECTED: 'CLOSED_SELF_COLLECTED',
  CLOSED_SHORT_PAYMENT_ENTERED: 'CLOSED_SHORT_PAYMENT_ENTERED',
  ORDER_NOT_DELIVERED_YET: 'ORDER_NOT_DELIVERED_YET',
  ORDER_REJECTED: 'ORDER_REJECTED',
  ORDER_OVERPAID: 'ORDER_OVERPAID',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  POST_DELIVERY_ADJUSTMENTS: 'POST_DELIVERY_ADJUSTMENTS',
  NO_HISTORICAL_DATA_UNKNOWN_PAYER: 'NO_HISTORICAL_DATA_UNKNOWN_PAYER',
  SITE_NOT_FLIPPED: 'SITE_NOT_FLIPPED',
  WRITE_OFF: 'WRITE_OFF',
  UNIDENTIFIED_OVERPAYMENT: 'UNIDENTIFIED_OVERPAYMENT',
  NABIS_BILLPAY: 'NABIS_BILLPAY',
  CREDIT_NOT_CONFIRMED: 'CREDIT_NOT_CONFIRMED',
  CREDIT_MISSING_INSTRUCTIONS: 'CREDIT_MISSING_INSTRUCTIONS',
  BRAND_OFFBOARDED: 'BRAND_OFFBOARDED',
  RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED: 'RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED',
  null: null,
} as const;

/**
 * The origin company
 */
export type RecordTransactionUIInputDTOOriginCompany =
  (typeof RecordTransactionUIInputDTOOriginCompany)[keyof typeof RecordTransactionUIInputDTOOriginCompany];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordTransactionUIInputDTOOriginCompany = {
  NABIFOUR: 'NABIFOUR',
  NABIFIVE: 'NABIFIVE',
  NABITWO: 'NABITWO',
  SIBAN: 'SIBAN',
} as const;

/**
 * The location
 */
export type RecordTransactionUIInputDTOLocation =
  (typeof RecordTransactionUIInputDTOLocation)[keyof typeof RecordTransactionUIInputDTOLocation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordTransactionUIInputDTOLocation = {
  CASH_IN_OAK: 'CASH_IN_OAK',
  CASH_IN_LA: 'CASH_IN_LA',
  CASH_IN_WOODLAKE: 'CASH_IN_WOODLAKE',
  CASH_IN_SF: 'CASH_IN_SF',
  CASH_IN_ROCHESTER: 'CASH_IN_ROCHESTER',
  CASH_IN_BRONX: 'CASH_IN_BRONX',
} as const;

/**
 * The method
 */
export type RecordTransactionUIInputDTOMethod =
  (typeof RecordTransactionUIInputDTOMethod)[keyof typeof RecordTransactionUIInputDTOMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordTransactionUIInputDTOMethod = {
  CASH: 'CASH',
  CHECK: 'CHECK',
  EFT: 'EFT',
} as const;

/**
 * The transaction type
 */
export type RecordTransactionUIInputDTOTransactionType =
  (typeof RecordTransactionUIInputDTOTransactionType)[keyof typeof RecordTransactionUIInputDTOTransactionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordTransactionUIInputDTOTransactionType = {
  PAYMENT: 'PAYMENT',
  SELF_COLLECTED: 'SELF_COLLECTED',
  CREDIT_MEMO: 'CREDIT_MEMO',
  DISCOUNT: 'DISCOUNT',
  WRITE_OFF_NABIS: 'WRITE_OFF_NABIS',
  WRITE_OFF_EXTERNAL: 'WRITE_OFF_EXTERNAL',
  NABIS_CREDIT_MEMO: 'NABIS_CREDIT_MEMO',
} as const;

export interface RecordTransactionUIInputDTO {
  /** The transaction type */
  transactionType: RecordTransactionUIInputDTOTransactionType;
  /** The paid by */
  paidBy: string;
  /** The name */
  name: string;
  /** The paid at */
  paidAt: string;
  /** The amount */
  amount: number;
  /** The method */
  method: RecordTransactionUIInputDTOMethod;
  /** The admin notes */
  adminNotes: string;
  /** The public notes */
  publicNotes: string;
  /** The location */
  location?: RecordTransactionUIInputDTOLocation;
  /** The earmarked organization ids */
  earmarkedOrganizationIds?: string[];
  /** The origin company */
  originCompany?: RecordTransactionUIInputDTOOriginCompany;
  /** The unapplied reason */
  unappliedReason?: RecordTransactionUIInputDTOUnappliedReason;
  /** The state */
  state: RecordTransactionUIInputDTOState;
}

/**
 * The original transaction
 */
export type FetchPaymentTransactionsPayloadDTOSingleOriginalTransaction = Transaction | null;

/**
 * The invoice
 */
export type FetchPaymentTransactionsPayloadDTOSingleInvoice = Invoice | null;

export interface FetchPaymentTransactionsPayloadDTOSingle {
  /** The transaction */
  transaction: TransactionWithOrgName;
  /** The invoice */
  invoice?: FetchPaymentTransactionsPayloadDTOSingleInvoice;
  /** The from account */
  fromAccount?: FetchPaymentTransactionsPayloadDTOSingleFromAccount;
  /** The to account */
  toAccount?: FetchPaymentTransactionsPayloadDTOSingleToAccount;
  /** The original transaction */
  originalTransaction?: FetchPaymentTransactionsPayloadDTOSingleOriginalTransaction;
}

export interface FetchPaymentTransactionsPayloadDTO {
  /** The transactions */
  payments: FetchPaymentTransactionsPayloadDTOSingle[];
  /** The page info */
  pageInfo: PageInfo;
}

/**
 * The unapplied reason
 */
export type TransactionUnappliedReason = (typeof TransactionUnappliedReason)[keyof typeof TransactionUnappliedReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionUnappliedReason = {
  NO_BREAKDOWN_PROVIDED: 'NO_BREAKDOWN_PROVIDED',
  INCOMPLETE_BREAKDOWN: 'INCOMPLETE_BREAKDOWN',
  UNCLEAR_BREAKDOWN: 'UNCLEAR_BREAKDOWN',
  INVALID_ORDER_NUMBER: 'INVALID_ORDER_NUMBER',
  CLOSED_PREVIOUSLY_PAID: 'CLOSED_PREVIOUSLY_PAID',
  CLOSED_ALLOCATED_WITH_OP: 'CLOSED_ALLOCATED_WITH_OP',
  CLOSED_SAMPLE_ORDER: 'CLOSED_SAMPLE_ORDER',
  CLOSED_SELF_COLLECTED: 'CLOSED_SELF_COLLECTED',
  CLOSED_SHORT_PAYMENT_ENTERED: 'CLOSED_SHORT_PAYMENT_ENTERED',
  ORDER_NOT_DELIVERED_YET: 'ORDER_NOT_DELIVERED_YET',
  ORDER_REJECTED: 'ORDER_REJECTED',
  ORDER_OVERPAID: 'ORDER_OVERPAID',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  POST_DELIVERY_ADJUSTMENTS: 'POST_DELIVERY_ADJUSTMENTS',
  NO_HISTORICAL_DATA_UNKNOWN_PAYER: 'NO_HISTORICAL_DATA_UNKNOWN_PAYER',
  SITE_NOT_FLIPPED: 'SITE_NOT_FLIPPED',
  WRITE_OFF: 'WRITE_OFF',
  UNIDENTIFIED_OVERPAYMENT: 'UNIDENTIFIED_OVERPAYMENT',
  NABIS_BILLPAY: 'NABIS_BILLPAY',
  CREDIT_NOT_CONFIRMED: 'CREDIT_NOT_CONFIRMED',
  CREDIT_MISSING_INSTRUCTIONS: 'CREDIT_MISSING_INSTRUCTIONS',
  BRAND_OFFBOARDED: 'BRAND_OFFBOARDED',
  RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED: 'RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED',
} as const;

/**
 * The origin company
 */
export type TransactionOriginCompany = (typeof TransactionOriginCompany)[keyof typeof TransactionOriginCompany];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionOriginCompany = {
  NABIFOUR: 'NABIFOUR',
  NABIFIVE: 'NABIFIVE',
  NABITWO: 'NABITWO',
  SIBAN: 'SIBAN',
} as const;

/**
 * The special remitted status
 */
export type TransactionSpecialRemittedStatus =
  (typeof TransactionSpecialRemittedStatus)[keyof typeof TransactionSpecialRemittedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionSpecialRemittedStatus = {
  REGULAR_FINISHED: 'REGULAR_FINISHED',
} as const;

/**
 * The method
 */
export type TransactionMethod = (typeof TransactionMethod)[keyof typeof TransactionMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionMethod = {
  CASH: 'CASH',
  CHECK: 'CHECK',
  EFT: 'EFT',
} as const;

/**
 * The location
 */
export type TransactionLocation = (typeof TransactionLocation)[keyof typeof TransactionLocation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionLocation = {
  CASH_IN_OAK: 'CASH_IN_OAK',
  CASH_IN_LA: 'CASH_IN_LA',
  CASH_IN_WOODLAKE: 'CASH_IN_WOODLAKE',
  CASH_IN_SF: 'CASH_IN_SF',
  CASH_IN_ROCHESTER: 'CASH_IN_ROCHESTER',
  CASH_IN_BRONX: 'CASH_IN_BRONX',
} as const;

/**
 * The type
 */
export type TransactionType = (typeof TransactionType)[keyof typeof TransactionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionType = {
  PAYMENT: 'PAYMENT',
  SELF_COLLECTED: 'SELF_COLLECTED',
  CREDIT_MEMO: 'CREDIT_MEMO',
  DISCOUNT: 'DISCOUNT',
  WRITE_OFF_NABIS: 'WRITE_OFF_NABIS',
  WRITE_OFF_EXTERNAL: 'WRITE_OFF_EXTERNAL',
  NABIS_CREDIT_MEMO: 'NABIS_CREDIT_MEMO',
} as const;

export interface Transaction {
  /** The id */
  id: string;
  /** The created at */
  createdAt: string;
  /** The updated at */
  updatedAt: string;
  /** The deleted at */
  deletedAt?: string;
  /** The number */
  number: number;
  /** The brand org id */
  brandOrgId: string;
  /** The retailer org id */
  retailerOrgId: string;
  /** The paid by */
  paidBy: string;
  /** The rolled back at */
  rolledBackAt?: string;
  /** The original transaction id */
  originalTransactionId?: string;
  /** The previous transaction id */
  previousTransactionId?: string;
  /** The invoice id */
  invoiceId: string;
  /** The is extra balance */
  isExtraBalance: boolean;
  /** The amount */
  amount: number;
  /** The public notes */
  publicNotes: string;
  /** The admin notes */
  adminNotes: string;
  /** The name */
  name: string;
  /** The paid at */
  paidAt?: string;
  /** The applied at */
  appliedAt?: string;
  /** The remitted at */
  remittedAt?: string;
  /** The type */
  type: TransactionType;
  /** The balance */
  balance: number;
  /** The from account id */
  fromAccountId?: string;
  /** The to account id */
  toAccountId?: string;
  /** The auto generated */
  autoGenerated: boolean;
  /** The location */
  location?: TransactionLocation;
  /** The method */
  method?: TransactionMethod;
  /** The collected nabis */
  collectedNabis: number;
  /** The collected external */
  collectedExternal: number;
  /** The write off nabis */
  writeOffNabis: number;
  /** The write off external */
  writeOffExternal: number;
  /** The credit memo */
  creditMemo: number;
  /** The discount */
  discount: number;
  /** The remitted collected nabis */
  remittedCollectedNabis: number;
  /** The remitted collected external */
  remittedCollectedExternal: number;
  /** The remitted write off nabis */
  remittedWriteOffNabis: number;
  /** The remitted write off external */
  remittedWriteOffExternal: number;
  /** The remitted credit memo */
  remittedCreditMemo: number;
  /** The remitted discount */
  remittedDiscount: number;
  /** The special remitted status */
  specialRemittedStatus: TransactionSpecialRemittedStatus;
  /** The remittance report id */
  remittanceReportId?: string;
  /** The source rollback transaction id */
  sourceRollbackTransactionId?: string;
  /** The pending rollback deduction */
  pendingRollbackDeduction: number;
  /** The remitted rollback deduction */
  remittedRollbackDeduction: number;
  /** The nabis credit memo */
  nabisCreditMemo: number;
  /** The remitted nabis credit memo */
  remittedNabisCreditMemo: number;
  /** The origin company */
  originCompany: TransactionOriginCompany;
  /** The unapplied reason */
  unappliedReason: TransactionUnappliedReason;
}

/**
 * The type
 */
export type AccountType = (typeof AccountType)[keyof typeof AccountType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountType = {
  UNCATEGORIZED_PAYMENTS: 'UNCATEGORIZED_PAYMENTS',
  UNCATEGORIZED_CREDIT_MEMO: 'UNCATEGORIZED_CREDIT_MEMO',
  UNCATEGORIZED_NABIS_WRITE_OFF: 'UNCATEGORIZED_NABIS_WRITE_OFF',
  UNCATEGORIZED_EXTERNAL_WRITE_OFF: 'UNCATEGORIZED_EXTERNAL_WRITE_OFF',
  UNCATEGORIZED_EXTERNAL_COLLECTED: 'UNCATEGORIZED_EXTERNAL_COLLECTED',
  UNCATEGORIZED_DISCOUNTS: 'UNCATEGORIZED_DISCOUNTS',
  UNCATEGORIZED_NABIS_CREDIT_MEMO: 'UNCATEGORIZED_NABIS_CREDIT_MEMO',
  ORDER_APPLIED_PAYMENTS: 'ORDER_APPLIED_PAYMENTS',
  ORDER_APPLIED_CREDIT_MEMO: 'ORDER_APPLIED_CREDIT_MEMO',
  ORDER_APPLIED_NABIS_WRITE_OFF: 'ORDER_APPLIED_NABIS_WRITE_OFF',
  ORDER_APPLIED_EXTERNAL_WRITE_OFF: 'ORDER_APPLIED_EXTERNAL_WRITE_OFF',
  ORDER_APPLIED_EXTERNAL_COLLECTED: 'ORDER_APPLIED_EXTERNAL_COLLECTED',
  ORDER_APPLIED_DISCOUNTS: 'ORDER_APPLIED_DISCOUNTS',
  ORDER_APPLIED_NABIS_CREDIT_MEMO: 'ORDER_APPLIED_NABIS_CREDIT_MEMO',
  PRE_REMITTED_TO_BRAND: 'PRE_REMITTED_TO_BRAND',
  PRE_REMITTED_NABIS_KEPT: 'PRE_REMITTED_NABIS_KEPT',
  PRE_REMITTED_CREDIT_MEMO: 'PRE_REMITTED_CREDIT_MEMO',
  PRE_REMITTED_NABIS_WRITE_OFF: 'PRE_REMITTED_NABIS_WRITE_OFF',
  PRE_REMITTED_EXTERNAL_WRITE_OFF: 'PRE_REMITTED_EXTERNAL_WRITE_OFF',
  PRE_REMITTED_EXTERNAL_COLLECTED: 'PRE_REMITTED_EXTERNAL_COLLECTED',
  PRE_REMITTED_DISCOUNTS: 'PRE_REMITTED_DISCOUNTS',
  PRE_REMITTED_NABIS_CREDIT_MEMO: 'PRE_REMITTED_NABIS_CREDIT_MEMO',
  UNALLOCATED_NABIS_RECEIVED: 'UNALLOCATED_NABIS_RECEIVED',
  REMITTANCE_REPORT: 'REMITTANCE_REPORT',
  REMITTED_TO_BRAND: 'REMITTED_TO_BRAND',
  REMITTED_NABIS_KEPT: 'REMITTED_NABIS_KEPT',
  REMITTED_CREDIT_MEMO: 'REMITTED_CREDIT_MEMO',
  REMITTED_NABIS_WRITE_OFF: 'REMITTED_NABIS_WRITE_OFF',
  REMITTED_EXTERNAL_WRITE_OFF: 'REMITTED_EXTERNAL_WRITE_OFF',
  REMITTED_EXTERNAL_COLLECTED: 'REMITTED_EXTERNAL_COLLECTED',
  REMITTED_DISCOUNTS: 'REMITTED_DISCOUNTS',
  REMITTED_NABIS_CREDIT_MEMO: 'REMITTED_NABIS_CREDIT_MEMO',
  REMITTED_UNALLOCATED_NABIS_RECEIVED: 'REMITTED_UNALLOCATED_NABIS_RECEIVED',
} as const;

export interface Account {
  /** The id */
  id: string;
  /** The type */
  type: AccountType;
  /** The brand org id */
  brandOrgId?: string;
  /** The retailer org id */
  retailerOrgId?: string;
}

/**
 * The to account
 */
export type FetchPaymentTransactionsPayloadDTOSingleToAccount = Account | null;

/**
 * The from account
 */
export type FetchPaymentTransactionsPayloadDTOSingleFromAccount = Account | null;

export interface AttachUserDto {
  organizationId: string;
  userId: string;
}

export interface AdminOrganizationResponse {
  data: AdminOrganization[];
  hasNextPage: boolean;
}

export type AdminOrganizationType = (typeof AdminOrganizationType)[keyof typeof AdminOrganizationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminOrganizationType = {
  BRAND: 'BRAND',
  MANUFACTURER: 'MANUFACTURER',
  DISTRIBUTOR: 'DISTRIBUTOR',
  RETAILER: 'RETAILER',
  SALES: 'SALES',
} as const;

export interface AdminLicensedLocation {
  id: string;
  name: string;
  doingBusinessAs: string | null;
}

export interface AdminOrganization {
  id: string;
  name: string;
  doingBusinessAs: string | null;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zip: string;
  deletedAt: string | null;
  type: AdminOrganizationType;
  licensedLocations: AdminLicensedLocation[];
  hasAccessToOrganization: boolean;
}

export interface ProcessUserInputDto {
  /** The prompt message from the user */
  prompt: string;
  /** Endpoint used to identify the zod schema */
  endpoint: string;
}

export interface UpsertDraftDto {
  id?: string;
  action: string;
  licensedLocationId?: string;
  licenseId?: string;
  intakeContactIds: string[];
  orders: UpsertDraftOrderDto[];
  deliveryDateStr?: string;
  warehouseId?: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy: string;
  title?: string;
}

export interface FindAllDraftsDto {
  data: UpsertDraftDto[];
  hasNextPage: boolean;
}

export interface UpsertDraftCreditMemoTypeDto {
  id: string;
  typeName: string;
}

export type UpsertDraftCreditMemoDtoType = UpsertDraftCreditMemoTypeDto | null;

export interface UpsertDraftCreditMemoDto {
  id?: string;
  amount: number;
  type?: UpsertDraftCreditMemoDtoType;
  note?: string;
}

export interface UpsertDraftNotesDto {
  noteType: string;
  content: string;
}

export interface UpsertDraftLineItemDto {
  itemBatchId: string;
  quantity: number;
  pricePerUnit: number;
  additionalDiscount: number;
  isSample: boolean;
  sampleType?: string | null;
  notes?: string | null;
  overrideMoq: boolean;
  destinationItemBatchId?: string | null;
  appliedTaxId: string;
  volumePricingTierId?: string | null;
}

export interface UpsertDraftOrderDto {
  brandOrganizationId: string;
  lineItems: UpsertDraftLineItemDto[];
  poSoNumber?: string;
  title: string;
  notes: UpsertDraftNotesDto[];
  paymentTerms?: string | null;
  salesRepId?: string;
  surcharge?: number;
  orderLevelAdditionalDiscount?: number;
  creditMemo?: UpsertDraftCreditMemoDto;
  appliedPromotionIds: string[];
  mustPayMode: string;
}

export interface OrganizationMarketplaceSettingsDto {
  /** Is the organization marketplace settings enabled */
  isEnabled: boolean;
  /** The description of the organization marketplace settings */
  description?: string | null;
  /** The brand image URL of the organization marketplace settings */
  brandImageUrl?: string | null;
  /** The website URL of the brand */
  websiteUrl?: string | null;
  /** The brand icon URL of the organization marketplace settings */
  brandIconUrl?: string | null;
  /** The brand minimum order of the organization marketplace settings */
  brandMinimum: number;
  /** The list of licensed location IDs that are blocked from the marketplace */
  licensedLocationBlocklist: string[];
  /** The contact email for the organization */
  contactEmail?: string | null;
  /** The contact phone number for the organization */
  contactPhoneNumber?: string | null;
}

export interface OrganizationMarketplaceSettingsResponseDto {
  /** Is the organization marketplace settings enabled */
  isEnabled: boolean;
  /** The description of the organization marketplace settings */
  description?: string | null;
  /** The brand image URL of the organization marketplace settings */
  brandImageUrl?: string | null;
  /** The website URL of the brand */
  websiteUrl?: string | null;
  /** The brand icon URL of the organization marketplace settings */
  brandIconUrl?: string | null;
  /** The brand minimum order of the organization marketplace settings */
  brandMinimum: number;
  /** The list of licensed location IDs that are blocked from the marketplace */
  licensedLocationBlocklist: string[];
  /** The contact email for the organization */
  contactEmail?: string | null;
  /** The contact phone number for the organization */
  contactPhoneNumber?: string | null;
  /** The id of the record */
  id: string;
}

/**
 * The state
 */
export type GenerateTaxInvoicesWithNonPaymentsReportInputDTOState =
  (typeof GenerateTaxInvoicesWithNonPaymentsReportInputDTOState)[keyof typeof GenerateTaxInvoicesWithNonPaymentsReportInputDTOState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateTaxInvoicesWithNonPaymentsReportInputDTOState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface GenerateTaxInvoicesWithNonPaymentsReportInputDTO {
  /** The state */
  state: GenerateTaxInvoicesWithNonPaymentsReportInputDTOState;
  /** The email */
  email: string;
}

/**
 * The state
 */
export type GenerateOutstandingBalancesReportInputDTOState =
  (typeof GenerateOutstandingBalancesReportInputDTOState)[keyof typeof GenerateOutstandingBalancesReportInputDTOState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateOutstandingBalancesReportInputDTOState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface GenerateOutstandingBalancesReportInputDTO {
  /** The state */
  state: GenerateOutstandingBalancesReportInputDTOState;
  /** The email */
  email: string;
}

/**
 * The state
 */
export type GenerateOutstandingAndEligibleReportDTOState =
  (typeof GenerateOutstandingAndEligibleReportDTOState)[keyof typeof GenerateOutstandingAndEligibleReportDTOState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateOutstandingAndEligibleReportDTOState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface GenerateOutstandingAndEligibleReportDTO {
  /** The state */
  state: GenerateOutstandingAndEligibleReportDTOState;
  /** The email */
  email: string;
}

/**
 * The state
 */
export type GenerateReconReportDTOState =
  (typeof GenerateReconReportDTOState)[keyof typeof GenerateReconReportDTOState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateReconReportDTOState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface GenerateReconReportDTO {
  /** The state */
  state: GenerateReconReportDTOState;
  /** The email */
  email: string;
}

export interface GenerateInvoicePageCSVPayloadDTO {
  message: string;
  link: string;
}

export type GenerateInvoicePageCSVInputDTOState =
  (typeof GenerateInvoicePageCSVInputDTOState)[keyof typeof GenerateInvoicePageCSVInputDTOState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GenerateInvoicePageCSVInputDTOState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface PageInfoInput {
  /** The page number */
  page: number;
  /** The number of items per page */
  numItemsPerPage: number;
}

export interface GenerateInvoicePageCSVInputDTO {
  orderNumber?: number;
  invoiceNumber?: number;
  brandOrganizationId?: string;
  retailerOrganizationId?: string;
  paidTo?: string;
  paidBy?: string;
  state?: GenerateInvoicePageCSVInputDTOState;
  pageInfo?: PageInfoInput;
  /** Email to send the CSV to */
  email: string;
}

export interface DeleteInvoiceByInvoiceNumberUIInputDTO {
  /** The invoice number */
  invoiceNumber: number;
  /** The order total */
  orderNumber?: number;
}

export interface FetchDetailedInvoicePayloadDTO {
  /** The invoice */
  invoice: InvoiceWithCalculatedFinancialFieldsAndOrgNames;
  /** The invoice type */
  invoiceType: InvoiceType;
  /** The collected transactions */
  collectedTransactions: TransactionWithOrgNameAndOriginalTransaction[];
  /** The remitted transactions */
  remittedTransactions: TransactionWithOrgNameAndOriginalTransaction[];
  /** The order invoice */
  orderInvoice?: Invoice;
  /** The adjustments */
  adjustments: AdjustmentWithChildrenAdjustments[];
}

/**
 * The type
 */
export type AdjustmentType = (typeof AdjustmentType)[keyof typeof AdjustmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdjustmentType = {
  DEDUCTION: 'DEDUCTION',
} as const;

/**
 * The state
 */
export type AdjustmentState = (typeof AdjustmentState)[keyof typeof AdjustmentState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdjustmentState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface Adjustment {
  /** The id */
  id: string;
  /** The created at */
  createdAt: string;
  /** The updated at */
  updatedAt?: string;
  /** The deleted at */
  deletedAt?: string;
  /** The state */
  state: AdjustmentState;
  /** The adjusted at */
  adjustedAt?: string;
  /** The type */
  type: AdjustmentType;
  /** The number */
  number: number;
  /** The amount */
  amount: number;
  /** The name */
  name: string;
  /** The notes */
  notes: string;
  /** The invoice id */
  invoiceId?: string;
  /** The transaction id */
  transactionId?: string;
  /** The remittance report id */
  remittanceReportId?: string;
  /** The pending adjustment */
  pendingAdjustment: number;
  /** The parent adjustment id */
  parentAdjustmentId?: string;
}

export interface AdjustmentWithChildrenAdjustments {
  /** The children adjustments */
  childrenAdjustments: Adjustment[];
  /** The adjustment */
  adjustment: Adjustment;
}

export interface TransactionWithOrgNameAndOriginalTransaction {
  /** The original transaction */
  originalTransaction?: TransactionWithOrgName;
  /** The transaction */
  transaction: TransactionWithOrgName;
}

/**
 * The unapplied reason
 */
export type TransactionWithOrgNameUnappliedReason =
  (typeof TransactionWithOrgNameUnappliedReason)[keyof typeof TransactionWithOrgNameUnappliedReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionWithOrgNameUnappliedReason = {
  NO_BREAKDOWN_PROVIDED: 'NO_BREAKDOWN_PROVIDED',
  INCOMPLETE_BREAKDOWN: 'INCOMPLETE_BREAKDOWN',
  UNCLEAR_BREAKDOWN: 'UNCLEAR_BREAKDOWN',
  INVALID_ORDER_NUMBER: 'INVALID_ORDER_NUMBER',
  CLOSED_PREVIOUSLY_PAID: 'CLOSED_PREVIOUSLY_PAID',
  CLOSED_ALLOCATED_WITH_OP: 'CLOSED_ALLOCATED_WITH_OP',
  CLOSED_SAMPLE_ORDER: 'CLOSED_SAMPLE_ORDER',
  CLOSED_SELF_COLLECTED: 'CLOSED_SELF_COLLECTED',
  CLOSED_SHORT_PAYMENT_ENTERED: 'CLOSED_SHORT_PAYMENT_ENTERED',
  ORDER_NOT_DELIVERED_YET: 'ORDER_NOT_DELIVERED_YET',
  ORDER_REJECTED: 'ORDER_REJECTED',
  ORDER_OVERPAID: 'ORDER_OVERPAID',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  POST_DELIVERY_ADJUSTMENTS: 'POST_DELIVERY_ADJUSTMENTS',
  NO_HISTORICAL_DATA_UNKNOWN_PAYER: 'NO_HISTORICAL_DATA_UNKNOWN_PAYER',
  SITE_NOT_FLIPPED: 'SITE_NOT_FLIPPED',
  WRITE_OFF: 'WRITE_OFF',
  UNIDENTIFIED_OVERPAYMENT: 'UNIDENTIFIED_OVERPAYMENT',
  NABIS_BILLPAY: 'NABIS_BILLPAY',
  CREDIT_NOT_CONFIRMED: 'CREDIT_NOT_CONFIRMED',
  CREDIT_MISSING_INSTRUCTIONS: 'CREDIT_MISSING_INSTRUCTIONS',
  BRAND_OFFBOARDED: 'BRAND_OFFBOARDED',
  RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED: 'RESERVED_UNAPPLIED_PAYMENTS_ALREADY_RESTRICTED',
} as const;

/**
 * The origin company
 */
export type TransactionWithOrgNameOriginCompany =
  (typeof TransactionWithOrgNameOriginCompany)[keyof typeof TransactionWithOrgNameOriginCompany];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionWithOrgNameOriginCompany = {
  NABIFOUR: 'NABIFOUR',
  NABIFIVE: 'NABIFIVE',
  NABITWO: 'NABITWO',
  SIBAN: 'SIBAN',
} as const;

/**
 * The special remitted status
 */
export type TransactionWithOrgNameSpecialRemittedStatus =
  (typeof TransactionWithOrgNameSpecialRemittedStatus)[keyof typeof TransactionWithOrgNameSpecialRemittedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionWithOrgNameSpecialRemittedStatus = {
  REGULAR_FINISHED: 'REGULAR_FINISHED',
} as const;

/**
 * The method
 */
export type TransactionWithOrgNameMethod =
  (typeof TransactionWithOrgNameMethod)[keyof typeof TransactionWithOrgNameMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionWithOrgNameMethod = {
  CASH: 'CASH',
  CHECK: 'CHECK',
  EFT: 'EFT',
} as const;

/**
 * The location
 */
export type TransactionWithOrgNameLocation =
  (typeof TransactionWithOrgNameLocation)[keyof typeof TransactionWithOrgNameLocation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionWithOrgNameLocation = {
  CASH_IN_OAK: 'CASH_IN_OAK',
  CASH_IN_LA: 'CASH_IN_LA',
  CASH_IN_WOODLAKE: 'CASH_IN_WOODLAKE',
  CASH_IN_SF: 'CASH_IN_SF',
  CASH_IN_ROCHESTER: 'CASH_IN_ROCHESTER',
  CASH_IN_BRONX: 'CASH_IN_BRONX',
} as const;

/**
 * The type
 */
export type TransactionWithOrgNameType = (typeof TransactionWithOrgNameType)[keyof typeof TransactionWithOrgNameType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionWithOrgNameType = {
  PAYMENT: 'PAYMENT',
  SELF_COLLECTED: 'SELF_COLLECTED',
  CREDIT_MEMO: 'CREDIT_MEMO',
  DISCOUNT: 'DISCOUNT',
  WRITE_OFF_NABIS: 'WRITE_OFF_NABIS',
  WRITE_OFF_EXTERNAL: 'WRITE_OFF_EXTERNAL',
  NABIS_CREDIT_MEMO: 'NABIS_CREDIT_MEMO',
} as const;

export interface TransactionWithOrgName {
  /** The id */
  id: string;
  /** The created at */
  createdAt: string;
  /** The updated at */
  updatedAt: string;
  /** The deleted at */
  deletedAt?: string;
  /** The number */
  number: number;
  /** The brand org id */
  brandOrgId: string;
  /** The retailer org id */
  retailerOrgId: string;
  /** The paid by */
  paidBy: string;
  /** The rolled back at */
  rolledBackAt?: string;
  /** The original transaction id */
  originalTransactionId?: string;
  /** The previous transaction id */
  previousTransactionId?: string;
  /** The invoice id */
  invoiceId: string;
  /** The is extra balance */
  isExtraBalance: boolean;
  /** The amount */
  amount: number;
  /** The public notes */
  publicNotes: string;
  /** The admin notes */
  adminNotes: string;
  /** The name */
  name: string;
  /** The paid at */
  paidAt?: string;
  /** The applied at */
  appliedAt?: string;
  /** The remitted at */
  remittedAt?: string;
  /** The type */
  type: TransactionWithOrgNameType;
  /** The balance */
  balance: number;
  /** The from account id */
  fromAccountId?: string;
  /** The to account id */
  toAccountId?: string;
  /** The auto generated */
  autoGenerated: boolean;
  /** The location */
  location?: TransactionWithOrgNameLocation;
  /** The method */
  method?: TransactionWithOrgNameMethod;
  /** The collected nabis */
  collectedNabis: number;
  /** The collected external */
  collectedExternal: number;
  /** The write off nabis */
  writeOffNabis: number;
  /** The write off external */
  writeOffExternal: number;
  /** The credit memo */
  creditMemo: number;
  /** The discount */
  discount: number;
  /** The remitted collected nabis */
  remittedCollectedNabis: number;
  /** The remitted collected external */
  remittedCollectedExternal: number;
  /** The remitted write off nabis */
  remittedWriteOffNabis: number;
  /** The remitted write off external */
  remittedWriteOffExternal: number;
  /** The remitted credit memo */
  remittedCreditMemo: number;
  /** The remitted discount */
  remittedDiscount: number;
  /** The special remitted status */
  specialRemittedStatus: TransactionWithOrgNameSpecialRemittedStatus;
  /** The remittance report id */
  remittanceReportId?: string;
  /** The source rollback transaction id */
  sourceRollbackTransactionId?: string;
  /** The pending rollback deduction */
  pendingRollbackDeduction: number;
  /** The remitted rollback deduction */
  remittedRollbackDeduction: number;
  /** The nabis credit memo */
  nabisCreditMemo: number;
  /** The remitted nabis credit memo */
  remittedNabisCreditMemo: number;
  /** The origin company */
  originCompany: TransactionWithOrgNameOriginCompany;
  /** The unapplied reason */
  unappliedReason: TransactionWithOrgNameUnappliedReason;
  /** The org name */
  paidByOrgName: string | null;
}

/**
 * The order action of the invoice
 */
export type InvoiceWithCalculatedFinancialFieldsAndOrgNamesOrderAction =
  (typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesOrderAction)[keyof typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesOrderAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithCalculatedFinancialFieldsAndOrgNamesOrderAction = {
  DELIVERY_TO_RETAILER: 'DELIVERY_TO_RETAILER',
  DELIVERY_TO_BRAND: 'DELIVERY_TO_BRAND',
  DROPOFF_TO_NABIS: 'DROPOFF_TO_NABIS',
  PICKUP_FROM_BRAND: 'PICKUP_FROM_BRAND',
  PICKUP_FROM_NABIS: 'PICKUP_FROM_NABIS',
  RETURN_FROM_RETAILER: 'RETURN_FROM_RETAILER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  null: null,
} as const;

/**
 * The order status of the invoice
 */
export type InvoiceWithCalculatedFinancialFieldsAndOrgNamesOrderStatus =
  (typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesOrderStatus)[keyof typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesOrderStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithCalculatedFinancialFieldsAndOrgNamesOrderStatus = {
  UNSCHEDULED: 'UNSCHEDULED',
  SCHEDULED: 'SCHEDULED',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSFERRING: 'TRANSFERRING',
  DELIVERED: 'DELIVERED',
  DELIVERED_WITH_EDITS: 'DELIVERED_WITH_EDITS',
  DELAYED: 'DELAYED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
  ATTEMPTED: 'ATTEMPTED',
  null: null,
} as const;

/**
 * The Nabis entity of the invoice
 */
export type InvoiceWithCalculatedFinancialFieldsAndOrgNamesNabisEntity =
  (typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesNabisEntity)[keyof typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesNabisEntity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithCalculatedFinancialFieldsAndOrgNamesNabisEntity = {
  NABIS: 'NABIS',
  SIBAN: 'SIBAN',
} as const;

/**
 * The collection status of the invoice
 */
export type InvoiceWithCalculatedFinancialFieldsAndOrgNamesCollectionStatus =
  (typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesCollectionStatus)[keyof typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesCollectionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithCalculatedFinancialFieldsAndOrgNamesCollectionStatus = {
  UNFINISHED: 'UNFINISHED',
  FINISHED: 'FINISHED',
} as const;

/**
 * The paid to and paid by of the invoice
 */
export type InvoiceWithCalculatedFinancialFieldsAndOrgNamesSource =
  (typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesSource)[keyof typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithCalculatedFinancialFieldsAndOrgNamesSource = {
  BRAND: 'BRAND',
  RETAILER: 'RETAILER',
  NABIS: 'NABIS',
} as const;

/**
 * The group type of the invoice
 */
export type InvoiceWithCalculatedFinancialFieldsAndOrgNamesGroupType =
  (typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesGroupType)[keyof typeof InvoiceWithCalculatedFinancialFieldsAndOrgNamesGroupType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithCalculatedFinancialFieldsAndOrgNamesGroupType = {
  FEE: 'FEE',
  BASE: 'BASE',
  ORDER: 'ORDER',
} as const;

export interface InvoiceWithCalculatedFinancialFieldsAndOrgNames {
  /** The id of the invoice */
  id: string;
  /** The date the invoice was created */
  createdAt: string;
  /** The date the invoice was updated */
  updatedAt: string;
  /** The deleted at moment */
  deletedAt: string | null;
  /** The meta name of the invoice */
  metaName: string;
  /** The number of the invoice */
  number: number;
  /** The id of the invoice type */
  invoiceTypeId: string;
  /** The group type of the invoice */
  groupType: InvoiceWithCalculatedFinancialFieldsAndOrgNamesGroupType;
  /** The paid to and paid by of the invoice */
  source: InvoiceWithCalculatedFinancialFieldsAndOrgNamesSource;
  /** The id of the brand organization */
  brandOrgId: string | null;
  /** The id of the retailer organization */
  retailerOrgId: string | null;
  /** The number of the order */
  orderNumber: number | null;
  /** The id of the order */
  orderId: string | null;
  /** The id of the order fee */
  orderFeeId: string | null;
  /** The collection status of the invoice */
  collectionStatus: InvoiceWithCalculatedFinancialFieldsAndOrgNamesCollectionStatus;
  /** The due date of the invoice */
  dueDate: string;
  /** The net terms of the invoice */
  netTerms: number;
  /** The public notes of the invoice */
  publicNotes: string;
  /** The admin notes of the invoice */
  adminNotes: string;
  /** Whether the invoice is auto generated */
  autoGenerated: boolean;
  /** The paid to of the invoice */
  paidTo: string | null;
  /** The paid by of the invoice */
  paidBy: string | null;
  /** The subtotal of the invoice */
  subtotal: number;
  /** The collected Nabis of the invoice */
  collectedNabis: number;
  /** The collected external of the invoice */
  collectedExternal: number;
  /** The write off Nabis of the invoice */
  writeOffNabis: number;
  /** The write off external of the invoice */
  writeOffExternal: number;
  /** The credit memo of the invoice */
  creditMemo: number;
  /** The discount of the invoice */
  discount: number;
  /** The remitted collected Nabis of the invoice */
  remittedCollectedNabis: number;
  /** The remitted collected external of the invoice */
  remittedCollectedExternal: number;
  /** The remitted write off Nabis of the invoice */
  remittedWriteOffNabis: number;
  /** The remitted write off external of the invoice */
  remittedWriteOffExternal: number;
  /** The remitted credit memo of the invoice */
  remittedCreditMemo: number;
  /** The remitted discount of the invoice */
  remittedDiscount: number;
  /** Whether the invoice is special overdue */
  isSpecialOverdue: boolean;
  /** The expected retailer coverage of the invoice */
  expectedRetailerCoverage: number;
  /** The expected brand coverage of the invoice */
  expectedBrandCoverage: number;
  /** The expected Nabis coverage of the invoice */
  expectedNabisCoverage: number;
  /** The Nabis entity of the invoice */
  nabisEntity: InvoiceWithCalculatedFinancialFieldsAndOrgNamesNabisEntity;
  /** The deduction of the invoice */
  deduction: number;
  /** The remitted deduction of the invoice */
  remittedDeduction: number;
  /** Whether the fees over order total of the invoice */
  feesOverOrderTotal: boolean;
  /** The raw order total of the invoice */
  rawOrderTotal: number;
  /** The Nabis credit memo of the invoice */
  nabisCreditMemo: number;
  /** The remitted Nabis credit memo of the invoice */
  remittedNabisCreditMemo: number;
  /** Whether the invoice is enforced deductible */
  enforcedDeductible: boolean;
  /** The name of the invoice */
  name: string;
  /** The order status of the invoice */
  orderStatus: InvoiceWithCalculatedFinancialFieldsAndOrgNamesOrderStatus;
  /** The order action of the invoice */
  orderAction: InvoiceWithCalculatedFinancialFieldsAndOrgNamesOrderAction;
  /** The total collected of the invoice */
  totalCollected: number;
  /** The total remitted of the invoice */
  totalRemitted: number;
  /** The total balance of the invoice */
  totalBalance: number;
  /** The brand org name of the invoice */
  brandOrgName?: string | null;
  /** The retailer org name of the invoice */
  retailerOrgName?: string | null;
  /** The paid to name of the invoice */
  paidToName?: string | null;
  /** The paid by name of the invoice */
  paidByName?: string | null;
}

/**
 * The invoice.group_type. Value ORDER is associated with a Due to Retailer invoice and is not allowed for this operation.
 */
export type CreateManualInvoiceForOrgUIInputDTOInvoiceTypeGroupType =
  (typeof CreateManualInvoiceForOrgUIInputDTOInvoiceTypeGroupType)[keyof typeof CreateManualInvoiceForOrgUIInputDTOInvoiceTypeGroupType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateManualInvoiceForOrgUIInputDTOInvoiceTypeGroupType = {
  FEE: 'FEE',
  BASE: 'BASE',
  ORDER: 'ORDER',
} as const;

export type CreateManualInvoiceForOrgUIInputDTOState =
  (typeof CreateManualInvoiceForOrgUIInputDTOState)[keyof typeof CreateManualInvoiceForOrgUIInputDTOState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateManualInvoiceForOrgUIInputDTOState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface CreateManualInvoiceForOrgUIInputDTO {
  state?: CreateManualInvoiceForOrgUIInputDTOState;
  /** The paid to */
  paidTo: string;
  /** The paid by */
  paidBy: string;
  /** The invoice type id */
  invoiceTypeId: string;
  /** The invoice.group_type. Value ORDER is associated with a Due to Retailer invoice and is not allowed for this operation. */
  invoiceTypeGroupType: CreateManualInvoiceForOrgUIInputDTOInvoiceTypeGroupType;
  /** The due date */
  dueDate: string;
  /** The amount */
  amount: number;
  /** The public notes */
  publicNotes: string;
  /** The enforced deductible */
  enforcedDeductible?: boolean;
  /** Reference name that is used by accounting to visually match invoices to other information. This value is submitted by User when creating an invoice. */
  name: string;
}

/**
 * The invoice.group_type. Value ORDER is associated with a Due to Retailer invoice and is not allowed for this operation.
 */
export type CreateManualInvoiceForOrderUIInputDTOInvoiceTypeGroupType =
  (typeof CreateManualInvoiceForOrderUIInputDTOInvoiceTypeGroupType)[keyof typeof CreateManualInvoiceForOrderUIInputDTOInvoiceTypeGroupType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateManualInvoiceForOrderUIInputDTOInvoiceTypeGroupType = {
  FEE: 'FEE',
  BASE: 'BASE',
  ORDER: 'ORDER',
} as const;

export interface CreateManualInvoiceForOrderUIInputDTO {
  /** The order number */
  orderNumber: number;
  /** The invoice.group_type. Value ORDER is associated with a Due to Retailer invoice and is not allowed for this operation. */
  invoiceTypeGroupType: CreateManualInvoiceForOrderUIInputDTOInvoiceTypeGroupType;
  /** The invoice type id */
  invoiceTypeId: string;
  /** The invoice.sub_total. Value can not be less than zero. */
  amount: number;
  /** The public notes */
  publicNotes: string;
}

/**
 * The handled status of the invoice
 */
export type HandledInvoiceHandled = (typeof HandledInvoiceHandled)[keyof typeof HandledInvoiceHandled];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HandledInvoiceHandled = {
  Create: 'Create',
  Update: 'Update',
  Delete: 'Delete',
  NoChange: 'NoChange',
} as const;

export interface HandledInvoice {
  /** The invoice */
  invoice: Invoice;
  /** The overpaid of the invoice */
  overpaid: number;
  /** The overremitted of the invoice */
  overremitted: number;
  /** The handled status of the invoice */
  handled: HandledInvoiceHandled;
  /** The name of the invoice */
  name: string;
}

/**
 * The regular order invoices
 */
export type InvoiceCreateInvoicesFromOrderRegularOrderInvoices = HandledInvoice | null;

/**
 * The capital due from retailer invoice
 */
export type InvoiceCreateInvoicesFromOrderCapitalDueFromRetailerInvoice = HandledInvoice | null;

/**
 * The order total invoice
 */
export type InvoiceCreateInvoicesFromOrderOrderTotalInvoice = HandledInvoice | null;

/**
 * The advance invoice
 */
export type InvoiceCreateInvoicesFromOrderAdvanceInvoice = HandledInvoice | null;

/**
 * The surcharge invoice
 */
export type InvoiceCreateInvoicesFromOrderSurchargeInvoice = HandledInvoice | null;

/**
 * The due to processor invoice
 */
export type InvoiceCreateInvoicesFromOrderDueToBrandInvoice = HandledInvoice | null;

/**
 * The tax invoice
 */
export type InvoiceCreateInvoicesFromOrderTaxInvoice = HandledInvoice | null;

/**
 * The fulfillment fee invoice
 */
export type InvoiceCreateInvoicesFromOrderFulfillmentFeeInvoice = HandledInvoice | null;

export interface InvoiceCreateInvoicesFromOrder {
  /** The order fee invoices */
  orderFeeInvoices?: HandledInvoice[] | null;
  /** The fulfillment fee invoice */
  fulfillmentFeeInvoice?: InvoiceCreateInvoicesFromOrderFulfillmentFeeInvoice;
  /** The tax invoice */
  taxInvoice?: InvoiceCreateInvoicesFromOrderTaxInvoice;
  /** The due to processor invoice */
  dueToBrandInvoice?: InvoiceCreateInvoicesFromOrderDueToBrandInvoice;
  /** The surcharge invoice */
  surchargeInvoice?: InvoiceCreateInvoicesFromOrderSurchargeInvoice;
  /** The advance invoice */
  advanceInvoice?: InvoiceCreateInvoicesFromOrderAdvanceInvoice;
  /** The order total invoice */
  orderTotalInvoice?: InvoiceCreateInvoicesFromOrderOrderTotalInvoice;
  /** The capital due from retailer invoice */
  capitalDueFromRetailerInvoice?: InvoiceCreateInvoicesFromOrderCapitalDueFromRetailerInvoice;
  /** The regular order invoices */
  regularOrderInvoices?: InvoiceCreateInvoicesFromOrderRegularOrderInvoices;
}

export interface ArrayOfInvoiceCreateInvoicesFromOrder {
  /** The invoices */
  invoices: InvoiceCreateInvoicesFromOrder[];
}

/**
 * State to generate invoices for
 */
export type ManuallyGenerateOrderInvoicesDtoState =
  (typeof ManuallyGenerateOrderInvoicesDtoState)[keyof typeof ManuallyGenerateOrderInvoicesDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManuallyGenerateOrderInvoicesDtoState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface ManuallyGenerateOrderInvoicesDto {
  /** Array of order numbers to generate invoices for */
  orderNumbers: number[];
  /** State to generate invoices for */
  state: ManuallyGenerateOrderInvoicesDtoState;
}

export type MinimalOrganizationType = (typeof MinimalOrganizationType)[keyof typeof MinimalOrganizationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MinimalOrganizationType = {
  BRAND: 'BRAND',
  MANUFACTURER: 'MANUFACTURER',
  DISTRIBUTOR: 'DISTRIBUTOR',
  RETAILER: 'RETAILER',
  SALES: 'SALES',
} as const;

export interface MinimalOrganization {
  id: string;
  name: string;
  doingBusinessAs: string | null;
  type: MinimalOrganizationType;
}

export interface FindAllMinimalPayloadDTO {
  data: MinimalOrganization[];
}

export interface OrderByInput {
  /** The attribute to order by */
  attribute: string;
  /** The order to order by */
  order: string;
}

export interface PageInfo {
  /** The page number */
  page: number;
  /** The number of items per page */
  numItemsPerPage: number;
  /** The order to order by */
  orderBy: OrderByInput[];
  /** Whether there is a next page */
  hasNextPage: boolean | null;
}

export interface FetchInvoicePayloadDTOSingle {
  /** The invoice */
  invoice: InvoiceWithFinancesAndOrgNames;
  /** The invoice type */
  invoiceType: InvoiceType;
  /** The order invoice */
  orderInvoice?: Invoice;
}

export interface FetchInvoicesPayloadDTO {
  invoices: FetchInvoicePayloadDTOSingle[];
  /** The page info */
  pageInfo: PageInfo;
}

/**
 * The order action of the invoice
 */
export type InvoiceOrderAction = (typeof InvoiceOrderAction)[keyof typeof InvoiceOrderAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceOrderAction = {
  DELIVERY_TO_RETAILER: 'DELIVERY_TO_RETAILER',
  DELIVERY_TO_BRAND: 'DELIVERY_TO_BRAND',
  DROPOFF_TO_NABIS: 'DROPOFF_TO_NABIS',
  PICKUP_FROM_BRAND: 'PICKUP_FROM_BRAND',
  PICKUP_FROM_NABIS: 'PICKUP_FROM_NABIS',
  RETURN_FROM_RETAILER: 'RETURN_FROM_RETAILER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  null: null,
} as const;

/**
 * The order status of the invoice
 */
export type InvoiceOrderStatus = (typeof InvoiceOrderStatus)[keyof typeof InvoiceOrderStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceOrderStatus = {
  UNSCHEDULED: 'UNSCHEDULED',
  SCHEDULED: 'SCHEDULED',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSFERRING: 'TRANSFERRING',
  DELIVERED: 'DELIVERED',
  DELIVERED_WITH_EDITS: 'DELIVERED_WITH_EDITS',
  DELAYED: 'DELAYED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
  ATTEMPTED: 'ATTEMPTED',
  null: null,
} as const;

/**
 * The Nabis entity of the invoice
 */
export type InvoiceNabisEntity = (typeof InvoiceNabisEntity)[keyof typeof InvoiceNabisEntity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceNabisEntity = {
  NABIS: 'NABIS',
  SIBAN: 'SIBAN',
} as const;

/**
 * The collection status of the invoice
 */
export type InvoiceCollectionStatus = (typeof InvoiceCollectionStatus)[keyof typeof InvoiceCollectionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceCollectionStatus = {
  UNFINISHED: 'UNFINISHED',
  FINISHED: 'FINISHED',
} as const;

/**
 * The paid to and paid by of the invoice
 */
export type InvoiceSource = (typeof InvoiceSource)[keyof typeof InvoiceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceSource = {
  BRAND: 'BRAND',
  RETAILER: 'RETAILER',
  NABIS: 'NABIS',
} as const;

/**
 * The group type of the invoice
 */
export type InvoiceGroupType = (typeof InvoiceGroupType)[keyof typeof InvoiceGroupType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceGroupType = {
  FEE: 'FEE',
  BASE: 'BASE',
  ORDER: 'ORDER',
} as const;

export interface Invoice {
  /** The id of the invoice */
  id: string;
  /** The date the invoice was created */
  createdAt: string;
  /** The date the invoice was updated */
  updatedAt: string;
  /** The deleted at moment */
  deletedAt: string | null;
  /** The meta name of the invoice */
  metaName: string;
  /** The number of the invoice */
  number: number;
  /** The id of the invoice type */
  invoiceTypeId: string;
  /** The group type of the invoice */
  groupType: InvoiceGroupType;
  /** The paid to and paid by of the invoice */
  source: InvoiceSource;
  /** The id of the brand organization */
  brandOrgId: string | null;
  /** The id of the retailer organization */
  retailerOrgId: string | null;
  /** The number of the order */
  orderNumber: number | null;
  /** The id of the order */
  orderId: string | null;
  /** The id of the order fee */
  orderFeeId: string | null;
  /** The collection status of the invoice */
  collectionStatus: InvoiceCollectionStatus;
  /** The due date of the invoice */
  dueDate: string;
  /** The net terms of the invoice */
  netTerms: number;
  /** The public notes of the invoice */
  publicNotes: string;
  /** The admin notes of the invoice */
  adminNotes: string;
  /** Whether the invoice is auto generated */
  autoGenerated: boolean;
  /** The paid to of the invoice */
  paidTo: string | null;
  /** The paid by of the invoice */
  paidBy: string | null;
  /** The subtotal of the invoice */
  subtotal: number;
  /** The collected Nabis of the invoice */
  collectedNabis: number;
  /** The collected external of the invoice */
  collectedExternal: number;
  /** The write off Nabis of the invoice */
  writeOffNabis: number;
  /** The write off external of the invoice */
  writeOffExternal: number;
  /** The credit memo of the invoice */
  creditMemo: number;
  /** The discount of the invoice */
  discount: number;
  /** The remitted collected Nabis of the invoice */
  remittedCollectedNabis: number;
  /** The remitted collected external of the invoice */
  remittedCollectedExternal: number;
  /** The remitted write off Nabis of the invoice */
  remittedWriteOffNabis: number;
  /** The remitted write off external of the invoice */
  remittedWriteOffExternal: number;
  /** The remitted credit memo of the invoice */
  remittedCreditMemo: number;
  /** The remitted discount of the invoice */
  remittedDiscount: number;
  /** Whether the invoice is special overdue */
  isSpecialOverdue: boolean;
  /** The expected retailer coverage of the invoice */
  expectedRetailerCoverage: number;
  /** The expected brand coverage of the invoice */
  expectedBrandCoverage: number;
  /** The expected Nabis coverage of the invoice */
  expectedNabisCoverage: number;
  /** The Nabis entity of the invoice */
  nabisEntity: InvoiceNabisEntity;
  /** The deduction of the invoice */
  deduction: number;
  /** The remitted deduction of the invoice */
  remittedDeduction: number;
  /** Whether the fees over order total of the invoice */
  feesOverOrderTotal: boolean;
  /** The raw order total of the invoice */
  rawOrderTotal: number;
  /** The Nabis credit memo of the invoice */
  nabisCreditMemo: number;
  /** The remitted Nabis credit memo of the invoice */
  remittedNabisCreditMemo: number;
  /** Whether the invoice is enforced deductible */
  enforcedDeductible: boolean;
  /** The name of the invoice */
  name: string;
  /** The order status of the invoice */
  orderStatus: InvoiceOrderStatus;
  /** The order action of the invoice */
  orderAction: InvoiceOrderAction;
}

/**
 * The default group type of the invoice type
 */
export type InvoiceTypeDefaultGroupType =
  (typeof InvoiceTypeDefaultGroupType)[keyof typeof InvoiceTypeDefaultGroupType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceTypeDefaultGroupType = {
  FEE: 'FEE',
  BASE: 'BASE',
  ORDER: 'ORDER',
} as const;

export interface InvoiceType {
  /** The id of the invoice type */
  id: string;
  /** The date the invoice type was created */
  createdAt: string;
  /** The date the invoice type was updated */
  updatedAt: string;
  /** The deleted at moment */
  deletedAt: string | null;
  /** The default group type of the invoice type */
  defaultGroupType: InvoiceTypeDefaultGroupType;
  /** The name of the invoice type */
  name: string;
  /** The description of the invoice type */
  description: string;
  /** The default amount of the invoice type */
  defaultAmount: number;
  /** The default paid to of the invoice type */
  defaultPaidTo: string;
  /** The default paid by of the invoice type */
  defaultPaidBy: string;
}

export interface ArrayOfInvoiceTypes {
  /** The invoice types */
  invoiceTypes: InvoiceType[];
}

/**
 * The order action of the invoice
 */
export type InvoiceWithFinancesAndOrgNamesOrderAction =
  (typeof InvoiceWithFinancesAndOrgNamesOrderAction)[keyof typeof InvoiceWithFinancesAndOrgNamesOrderAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithFinancesAndOrgNamesOrderAction = {
  DELIVERY_TO_RETAILER: 'DELIVERY_TO_RETAILER',
  DELIVERY_TO_BRAND: 'DELIVERY_TO_BRAND',
  DROPOFF_TO_NABIS: 'DROPOFF_TO_NABIS',
  PICKUP_FROM_BRAND: 'PICKUP_FROM_BRAND',
  PICKUP_FROM_NABIS: 'PICKUP_FROM_NABIS',
  RETURN_FROM_RETAILER: 'RETURN_FROM_RETAILER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  null: null,
} as const;

/**
 * The order status of the invoice
 */
export type InvoiceWithFinancesAndOrgNamesOrderStatus =
  (typeof InvoiceWithFinancesAndOrgNamesOrderStatus)[keyof typeof InvoiceWithFinancesAndOrgNamesOrderStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithFinancesAndOrgNamesOrderStatus = {
  UNSCHEDULED: 'UNSCHEDULED',
  SCHEDULED: 'SCHEDULED',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSFERRING: 'TRANSFERRING',
  DELIVERED: 'DELIVERED',
  DELIVERED_WITH_EDITS: 'DELIVERED_WITH_EDITS',
  DELAYED: 'DELAYED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
  ATTEMPTED: 'ATTEMPTED',
  null: null,
} as const;

/**
 * The Nabis entity of the invoice
 */
export type InvoiceWithFinancesAndOrgNamesNabisEntity =
  (typeof InvoiceWithFinancesAndOrgNamesNabisEntity)[keyof typeof InvoiceWithFinancesAndOrgNamesNabisEntity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithFinancesAndOrgNamesNabisEntity = {
  NABIS: 'NABIS',
  SIBAN: 'SIBAN',
} as const;

/**
 * The collection status of the invoice
 */
export type InvoiceWithFinancesAndOrgNamesCollectionStatus =
  (typeof InvoiceWithFinancesAndOrgNamesCollectionStatus)[keyof typeof InvoiceWithFinancesAndOrgNamesCollectionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithFinancesAndOrgNamesCollectionStatus = {
  UNFINISHED: 'UNFINISHED',
  FINISHED: 'FINISHED',
} as const;

/**
 * The paid to and paid by of the invoice
 */
export type InvoiceWithFinancesAndOrgNamesSource =
  (typeof InvoiceWithFinancesAndOrgNamesSource)[keyof typeof InvoiceWithFinancesAndOrgNamesSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithFinancesAndOrgNamesSource = {
  BRAND: 'BRAND',
  RETAILER: 'RETAILER',
  NABIS: 'NABIS',
} as const;

/**
 * The group type of the invoice
 */
export type InvoiceWithFinancesAndOrgNamesGroupType =
  (typeof InvoiceWithFinancesAndOrgNamesGroupType)[keyof typeof InvoiceWithFinancesAndOrgNamesGroupType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceWithFinancesAndOrgNamesGroupType = {
  FEE: 'FEE',
  BASE: 'BASE',
  ORDER: 'ORDER',
} as const;

export interface InvoiceWithFinancesAndOrgNames {
  /** The id of the invoice */
  id: string;
  /** The date the invoice was created */
  createdAt: string;
  /** The date the invoice was updated */
  updatedAt: string;
  /** The deleted at moment */
  deletedAt: string | null;
  /** The meta name of the invoice */
  metaName: string;
  /** The number of the invoice */
  number: number;
  /** The id of the invoice type */
  invoiceTypeId: string;
  /** The group type of the invoice */
  groupType: InvoiceWithFinancesAndOrgNamesGroupType;
  /** The paid to and paid by of the invoice */
  source: InvoiceWithFinancesAndOrgNamesSource;
  /** The id of the brand organization */
  brandOrgId: string | null;
  /** The id of the retailer organization */
  retailerOrgId: string | null;
  /** The number of the order */
  orderNumber: number | null;
  /** The id of the order */
  orderId: string | null;
  /** The id of the order fee */
  orderFeeId: string | null;
  /** The collection status of the invoice */
  collectionStatus: InvoiceWithFinancesAndOrgNamesCollectionStatus;
  /** The due date of the invoice */
  dueDate: string;
  /** The net terms of the invoice */
  netTerms: number;
  /** The public notes of the invoice */
  publicNotes: string;
  /** The admin notes of the invoice */
  adminNotes: string;
  /** Whether the invoice is auto generated */
  autoGenerated: boolean;
  /** The paid to of the invoice */
  paidTo: string | null;
  /** The paid by of the invoice */
  paidBy: string | null;
  /** The subtotal of the invoice */
  subtotal: number;
  /** The collected Nabis of the invoice */
  collectedNabis: number;
  /** The collected external of the invoice */
  collectedExternal: number;
  /** The write off Nabis of the invoice */
  writeOffNabis: number;
  /** The write off external of the invoice */
  writeOffExternal: number;
  /** The credit memo of the invoice */
  creditMemo: number;
  /** The discount of the invoice */
  discount: number;
  /** The remitted collected Nabis of the invoice */
  remittedCollectedNabis: number;
  /** The remitted collected external of the invoice */
  remittedCollectedExternal: number;
  /** The remitted write off Nabis of the invoice */
  remittedWriteOffNabis: number;
  /** The remitted write off external of the invoice */
  remittedWriteOffExternal: number;
  /** The remitted credit memo of the invoice */
  remittedCreditMemo: number;
  /** The remitted discount of the invoice */
  remittedDiscount: number;
  /** Whether the invoice is special overdue */
  isSpecialOverdue: boolean;
  /** The expected retailer coverage of the invoice */
  expectedRetailerCoverage: number;
  /** The expected brand coverage of the invoice */
  expectedBrandCoverage: number;
  /** The expected Nabis coverage of the invoice */
  expectedNabisCoverage: number;
  /** The Nabis entity of the invoice */
  nabisEntity: InvoiceWithFinancesAndOrgNamesNabisEntity;
  /** The deduction of the invoice */
  deduction: number;
  /** The remitted deduction of the invoice */
  remittedDeduction: number;
  /** Whether the fees over order total of the invoice */
  feesOverOrderTotal: boolean;
  /** The raw order total of the invoice */
  rawOrderTotal: number;
  /** The Nabis credit memo of the invoice */
  nabisCreditMemo: number;
  /** The remitted Nabis credit memo of the invoice */
  remittedNabisCreditMemo: number;
  /** Whether the invoice is enforced deductible */
  enforcedDeductible: boolean;
  /** The name of the invoice */
  name: string;
  /** The order status of the invoice */
  orderStatus: InvoiceWithFinancesAndOrgNamesOrderStatus;
  /** The order action of the invoice */
  orderAction: InvoiceWithFinancesAndOrgNamesOrderAction;
  /** The total collected of the invoice */
  totalCollected: number;
  /** The total remitted of the invoice */
  totalRemitted: number;
  /** The total balance of the invoice */
  totalBalance: number;
  /** The paid to name of the invoice */
  paidToName: string | null;
  /** The paid by name of the invoice */
  paidByName: string | null;
  /** The brand org name of the invoice */
  brandOrgName: string | null;
  /** The retailer org name of the invoice */
  retailerOrgName: string | null;
}

export interface ItemImageEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  itemId: string;
  imageUrl: string;
  sequence: number;
}

export interface CreateItemImageDto {
  [key: string]: any;
}

/**
 * The data
 */
export type CustomJournalData = { [key: string]: any };

/**
 * The state
 */
export type CustomJournalState = (typeof CustomJournalState)[keyof typeof CustomJournalState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomJournalState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface CustomJournal {
  /** The id */
  id: string;
  /** The created at */
  createdAt: string;
  /** The updated at */
  updatedAt?: string;
  /** The deleted at */
  deletedAt?: string;
  /** The state */
  state: CustomJournalState;
  /** The notes */
  notes: string;
  /** The old custom date */
  oldCustomDate?: string;
  /** The new custom date */
  newCustomDate?: string;
  /** The order number */
  orderNumber?: number;
  /** The data */
  data: CustomJournalData;
  /** The change tag */
  changeTag: string;
  /** The reported count */
  reportedCount: number;
}

export interface FetchJournalsForDatesPayloadDTO {
  /** The journals */
  journals?: CustomJournal[];
}

export type CreateOrUpdateInvoicesDtoBaseGenerationTypesItem =
  (typeof CreateOrUpdateInvoicesDtoBaseGenerationTypesItem)[keyof typeof CreateOrUpdateInvoicesDtoBaseGenerationTypesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrUpdateInvoicesDtoBaseGenerationTypesItem = {
  a: 'a',
  b: 'b',
} as const;

export interface OverrideOptionsDto {
  class?: string;
}

export type CreateOrUpdateInvoicesDtoBaseOverrideOptions = OverrideOptionsDto | null;

export interface CreateOrUpdateInvoicesDtoBase {
  orderId: string;
  generationTypes: CreateOrUpdateInvoicesDtoBaseGenerationTypesItem[];
  overrideOptions?: CreateOrUpdateInvoicesDtoBaseOverrideOptions;
}

export type DeleteQuickbooksInvoicesByOrderIdAndGroupingDtoBaseGrouping =
  (typeof DeleteQuickbooksInvoicesByOrderIdAndGroupingDtoBaseGrouping)[keyof typeof DeleteQuickbooksInvoicesByOrderIdAndGroupingDtoBaseGrouping];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteQuickbooksInvoicesByOrderIdAndGroupingDtoBaseGrouping = {
  a: 'a',
  b: 'b',
} as const;

export interface DeleteQuickbooksInvoicesByOrderIdAndGroupingDtoBase {
  orderId: string;
  grouping: DeleteQuickbooksInvoicesByOrderIdAndGroupingDtoBaseGrouping;
}

export type SetRegenerateQuickbooksInvoicesByOrderIdDtoBaseGrouping =
  (typeof SetRegenerateQuickbooksInvoicesByOrderIdDtoBaseGrouping)[keyof typeof SetRegenerateQuickbooksInvoicesByOrderIdDtoBaseGrouping];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetRegenerateQuickbooksInvoicesByOrderIdDtoBaseGrouping = {
  a: 'a',
  b: 'b',
} as const;

export interface SetRegenerateQuickbooksInvoicesByOrderIdDtoBase {
  orderId: string;
  grouping: SetRegenerateQuickbooksInvoicesByOrderIdDtoBaseGrouping;
  regenerateInvoice: boolean;
}

export interface GetQuickbooksInvoicesForMultipleOrdersResponseRecordDto {
  orders: GetQuickbooksInvoicesForMultipleOrdersResponseSingleRecordDto[];
}

export interface LineFrontend {
  service: string;
  description: string;
  amount: string;
  brand: string;
  value: number;
}

export type QuickbooksInvoicePropertiesAsDtoClassGrouping =
  (typeof QuickbooksInvoicePropertiesAsDtoClassGrouping)[keyof typeof QuickbooksInvoicePropertiesAsDtoClassGrouping];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuickbooksInvoicePropertiesAsDtoClassGrouping = {
  a: 'a',
  b: 'b',
} as const;

export type QuickbooksInvoicePropertiesAsDtoClassCompany =
  (typeof QuickbooksInvoicePropertiesAsDtoClassCompany)[keyof typeof QuickbooksInvoicePropertiesAsDtoClassCompany];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuickbooksInvoicePropertiesAsDtoClassCompany = {
  NABIONE: 'NABIONE',
  NABITWO: 'NABITWO',
  NABITHREE: 'NABITHREE',
  NABIFOUR: 'NABIFOUR',
  NABIFIVE: 'NABIFIVE',
  SIBAN: 'SIBAN',
} as const;

export type QuickbooksInvoicePropertiesAsDtoClassState =
  (typeof QuickbooksInvoicePropertiesAsDtoClassState)[keyof typeof QuickbooksInvoicePropertiesAsDtoClassState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuickbooksInvoicePropertiesAsDtoClassState = {
  ALL: 'ALL',
  CA: 'CA',
  NY: 'NY',
} as const;

export interface QuickbooksInvoicePropertiesAsDtoClass {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  deletedAt: string | null;
  state: QuickbooksInvoicePropertiesAsDtoClassState;
  company: QuickbooksInvoicePropertiesAsDtoClassCompany;
  nabisOrderId: string | null;
  nabisOrderNumber: number | null;
  quickbooksInvoiceId: string;
  quickbooksInvoiceSyncToken: string;
  regenerateInvoice: boolean;
  grouping: QuickbooksInvoicePropertiesAsDtoClassGrouping;
}

export interface GetQuickbooksInvoicesForMultipleOrdersResponseSingleRecordDto {
  quickbooksInvoices: QuickbooksInvoicePropertiesAsDtoClass[];
  aTotal: number;
  bTotal: number;
  aLines: LineFrontend[];
  bLines: LineFrontend[];
  orderId: string;
}

export interface UpdateOrderNotesDto {
  /** brand of the order */
  orderId?: string;
  /** New delivery notes for an order */
  notes?: string;
  /** New internal notes for an order */
  internalNotes?: string;
  /** New brand manifest notes for an order */
  brandManifestNotes?: string;
  /** New nabis manifest notes for an order */
  nabisManifestNotes?: string;
  /** New admin notes for an order */
  adminNotes?: string;
}

/**
 * The new payment status
 */
export type UpdateOrderCollectionsDtoPaymentStatus =
  (typeof UpdateOrderCollectionsDtoPaymentStatus)[keyof typeof UpdateOrderCollectionsDtoPaymentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrderCollectionsDtoPaymentStatus = {
  UNPAID: 'UNPAID',
  COD_PAID: 'COD_PAID',
  NET_TERMS_PAID: 'NET_TERMS_PAID',
  REMITTED: 'REMITTED',
  SELF_COLLECTED: 'SELF_COLLECTED',
  PROCESSING: 'PROCESSING',
  PAYMENT_SENT: 'PAYMENT_SENT',
  WRITE_OFF: 'WRITE_OFF',
  THIRD_PARTY_COLLECTIONS: 'THIRD_PARTY_COLLECTIONS',
  PARTIAL_PAID: 'PARTIAL_PAID',
  DRIVER_PROCESSING: 'DRIVER_PROCESSING',
} as const;

export interface UpdateOrderCollectionsDto {
  /** The new collected amount */
  collected: number;
  /** The new payment status */
  paymentStatus: UpdateOrderCollectionsDtoPaymentStatus;
  /** brand of the order */
  orderId: string;
}

export interface UpdateOrderPricingDto {
  /** The new minimum flat fee */
  newFlatFee: number;
  /** The new base percentage to charge */
  newPercentage: number;
  /** brand of the order */
  orderId: string;
  /** Whether to waive inventory fees */
  shouldWaiveInventoryFees?: boolean;
}

export type AdminAccountingDetailedOrderState =
  (typeof AdminAccountingDetailedOrderState)[keyof typeof AdminAccountingDetailedOrderState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminAccountingDetailedOrderState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export type AdminAccountingDetailedOrderAction =
  (typeof AdminAccountingDetailedOrderAction)[keyof typeof AdminAccountingDetailedOrderAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminAccountingDetailedOrderAction = {
  DELIVERY_TO_RETAILER: 'DELIVERY_TO_RETAILER',
  DELIVERY_TO_BRAND: 'DELIVERY_TO_BRAND',
  DROPOFF_TO_NABIS: 'DROPOFF_TO_NABIS',
  PICKUP_FROM_BRAND: 'PICKUP_FROM_BRAND',
  PICKUP_FROM_NABIS: 'PICKUP_FROM_NABIS',
  RETURN_FROM_RETAILER: 'RETURN_FROM_RETAILER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
} as const;

export type AdminAccountingDetailedOrderPaymentTerms =
  (typeof AdminAccountingDetailedOrderPaymentTerms)[keyof typeof AdminAccountingDetailedOrderPaymentTerms];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminAccountingDetailedOrderPaymentTerms = {
  COD: 'COD',
  NET_7: 'NET_7',
  NET_10: 'NET_10',
  NET_15: 'NET_15',
  NET_30: 'NET_30',
} as const;

export type AdminAccountingDetailedOrderPaymentStatus =
  (typeof AdminAccountingDetailedOrderPaymentStatus)[keyof typeof AdminAccountingDetailedOrderPaymentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminAccountingDetailedOrderPaymentStatus = {
  UNPAID: 'UNPAID',
  COD_PAID: 'COD_PAID',
  NET_TERMS_PAID: 'NET_TERMS_PAID',
  REMITTED: 'REMITTED',
  SELF_COLLECTED: 'SELF_COLLECTED',
  PROCESSING: 'PROCESSING',
  PAYMENT_SENT: 'PAYMENT_SENT',
  WRITE_OFF: 'WRITE_OFF',
  THIRD_PARTY_COLLECTIONS: 'THIRD_PARTY_COLLECTIONS',
  PARTIAL_PAID: 'PARTIAL_PAID',
  DRIVER_PROCESSING: 'DRIVER_PROCESSING',
} as const;

/**
 * deprecated fee typing, used for the Gas Fee
 */
export type FeeFeeType = (typeof FeeFeeType)[keyof typeof FeeFeeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeeFeeType = {
  DISTRO: 'DISTRO',
  EXTRA: 'EXTRA',
} as const;

export interface Fee {
  id: string;
  /** name of the fee */
  name: string;
  /** description of the fee */
  description: string;
  /** default price of the fee */
  basePrice: number;
  /** deprecated fee typing, used for the Gas Fee */
  feeType: FeeFeeType;
  /** all fees that are automatically charged have this start date */
  autoChargeStartDate: string | null;
  /** automatically charged fees can end, given on this date */
  autoChargeEndDate: string | null;
  /** start of the fee applicable to be charged */
  startDate: string;
  /** when a fee may be retired */
  endDate: string | null;
}

export interface OrderFee {
  feeName: string;
  feePrice: number;
  feeNotes: string;
  orderFeeId: string;
  feeId: string;
}

export interface AdminAccountingDetailedOrder {
  orderNumber: number;
  paymentStatus: AdminAccountingDetailedOrderPaymentStatus;
  brandName: string;
  retailerName: string;
  subtotal: number;
  tax: number;
  creditMemo: number;
  taxInclusiveSubtotal: number;
  collected: number;
  remainingBalance: number;
  paymentTerms: AdminAccountingDetailedOrderPaymentTerms;
  factored: boolean;
  action: AdminAccountingDetailedOrderAction;
  createdAt: string;
  date: string;
  notes: string | null;
  brandManifestNotes: string | null;
  adminNotes: string | null;
  nabisManifestNotes: string | null;
  internalNotes: string | null;
  orderFees: OrderFee[];
  state: AdminAccountingDetailedOrderState;
  organizationId: string;
  orderId: string;
  brandUrlSlug: string;
  manifestS3Link: string;
  /** The fulfillment/distribution fee amount */
  fulfillmentFee: number;
  /** The minimum flat fee amount for the distribution fee */
  flatFee: number;
  /** The base percentage to be used for pricing calculations */
  percent: number;
  /** The default brand pricing flat fee amount */
  brandPricingFlatFee: number;
  /** The default brand pricing percentage */
  brandPricingPercent: number;
  /** The fees that are available to be charged */
  fees: Fee[];
  /** The discount amount applied to the order via line items */
  orderLineItemDiscountAmount: number;
  /** The order total amount */
  orderTotal: number;
}

export interface CsvResponseDto {
  /** Status message indicating the result of the request */
  message: string;
  /** HTTP status code for the response */
  status: number;
}

export interface AdminAccountingPageResponseDto {
  data: AdminAccountingOrder[];
  hasNextPage: boolean;
}

export type AdminAccountingOrderStatus = (typeof AdminAccountingOrderStatus)[keyof typeof AdminAccountingOrderStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminAccountingOrderStatus = {
  UNSCHEDULED: 'UNSCHEDULED',
  SCHEDULED: 'SCHEDULED',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSFERRING: 'TRANSFERRING',
  DELIVERED: 'DELIVERED',
  DELIVERED_WITH_EDITS: 'DELIVERED_WITH_EDITS',
  DELAYED: 'DELAYED',
  CANCELED: 'CANCELED',
  REJECTED: 'REJECTED',
  ATTEMPTED: 'ATTEMPTED',
} as const;

export type AdminAccountingOrderPaymentStatus =
  (typeof AdminAccountingOrderPaymentStatus)[keyof typeof AdminAccountingOrderPaymentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminAccountingOrderPaymentStatus = {
  UNPAID: 'UNPAID',
  COD_PAID: 'COD_PAID',
  NET_TERMS_PAID: 'NET_TERMS_PAID',
  REMITTED: 'REMITTED',
  SELF_COLLECTED: 'SELF_COLLECTED',
  PROCESSING: 'PROCESSING',
  PAYMENT_SENT: 'PAYMENT_SENT',
  WRITE_OFF: 'WRITE_OFF',
  THIRD_PARTY_COLLECTIONS: 'THIRD_PARTY_COLLECTIONS',
  PARTIAL_PAID: 'PARTIAL_PAID',
  DRIVER_PROCESSING: 'DRIVER_PROCESSING',
} as const;

export interface AdminAccountingOrder {
  orderNumber: number;
  paymentStatus: AdminAccountingOrderPaymentStatus;
  brandName: string;
  retailerName: string;
  collected: number;
  taxInclusiveSubtotal: number;
  status: AdminAccountingOrderStatus;
  orderId: string;
  retailerLicensedLocationId: string;
  brandId: string;
  subtotal: number;
  orderTotal: number;
}

export interface TableauJwtResponseDto {
  jwt: string;
}

export interface UpdateZipcodeDto {
  [key: string]: any;
}

export interface ZipcodeFindManyResponseDto {
  hasNextPage: boolean;
  data: ZipcodeWithDetails[];
}

export type ZipcodeWithDetailsPeriod = (typeof ZipcodeWithDetailsPeriod)[keyof typeof ZipcodeWithDetailsPeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZipcodeWithDetailsPeriod = {
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
  AS_NEEDED: 'AS_NEEDED',
} as const;

export type ZipcodeWithDetailsPickupDaysItem =
  (typeof ZipcodeWithDetailsPickupDaysItem)[keyof typeof ZipcodeWithDetailsPickupDaysItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZipcodeWithDetailsPickupDaysItem = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
} as const;

export type ZipcodeWithDetailsDeliveryDaysItem =
  (typeof ZipcodeWithDetailsDeliveryDaysItem)[keyof typeof ZipcodeWithDetailsDeliveryDaysItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZipcodeWithDetailsDeliveryDaysItem = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
} as const;

export type ZipcodeWithDetailsState = (typeof ZipcodeWithDetailsState)[keyof typeof ZipcodeWithDetailsState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZipcodeWithDetailsState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface ZipcodeWithDetails {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  zipcode: string;
  city: string;
  county: string;
  state: ZipcodeWithDetailsState;
  deliveryDays: ZipcodeWithDetailsDeliveryDaysItem[];
  pickupDays: ZipcodeWithDetailsPickupDaysItem[];
  period: ZipcodeWithDetailsPeriod;
  periodMultiplier: number;
  deletedAt?: string | null;
  deliveringWarehouseId: string | null;
  receivingWarehouseId: string | null;
  receivingWarehouseName: string;
  deliveringWarehouseName: string;
}

export type ZipcodeEntityPeriod = (typeof ZipcodeEntityPeriod)[keyof typeof ZipcodeEntityPeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZipcodeEntityPeriod = {
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
  AS_NEEDED: 'AS_NEEDED',
} as const;

export type ZipcodeEntityPickupDaysItem =
  (typeof ZipcodeEntityPickupDaysItem)[keyof typeof ZipcodeEntityPickupDaysItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZipcodeEntityPickupDaysItem = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
} as const;

export type ZipcodeEntityDeliveryDaysItem =
  (typeof ZipcodeEntityDeliveryDaysItem)[keyof typeof ZipcodeEntityDeliveryDaysItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZipcodeEntityDeliveryDaysItem = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
} as const;

export type ZipcodeEntityState = (typeof ZipcodeEntityState)[keyof typeof ZipcodeEntityState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZipcodeEntityState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface ZipcodeEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  zipcode: string;
  city: string;
  county: string;
  state: ZipcodeEntityState;
  deliveryDays: ZipcodeEntityDeliveryDaysItem[];
  pickupDays: ZipcodeEntityPickupDaysItem[];
  period: ZipcodeEntityPeriod;
  periodMultiplier: number;
  deletedAt?: string | null;
  deliveringWarehouseId: string | null;
  receivingWarehouseId: string | null;
}

export type CreateZipcodeDtoPeriod = (typeof CreateZipcodeDtoPeriod)[keyof typeof CreateZipcodeDtoPeriod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateZipcodeDtoPeriod = {
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  YEAR: 'YEAR',
  AS_NEEDED: 'AS_NEEDED',
} as const;

export type CreateZipcodeDtoPickupDaysItem =
  (typeof CreateZipcodeDtoPickupDaysItem)[keyof typeof CreateZipcodeDtoPickupDaysItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateZipcodeDtoPickupDaysItem = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
} as const;

export type CreateZipcodeDtoDeliveryDaysItem =
  (typeof CreateZipcodeDtoDeliveryDaysItem)[keyof typeof CreateZipcodeDtoDeliveryDaysItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateZipcodeDtoDeliveryDaysItem = {
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
} as const;

export type CreateZipcodeDtoState = (typeof CreateZipcodeDtoState)[keyof typeof CreateZipcodeDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateZipcodeDtoState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface CreateZipcodeDto {
  zipcode: string;
  city: string;
  county: string;
  state: CreateZipcodeDtoState;
  deliveryDays: CreateZipcodeDtoDeliveryDaysItem[];
  pickupDays: CreateZipcodeDtoPickupDaysItem[];
  period: CreateZipcodeDtoPeriod;
  periodMultiplier: number;
  deliveringWarehouseId: string;
  receivingWarehouseId: string;
}

export interface ItemVolumePricing {
  id: string;
  moq: number;
  pricePerUnit: number;
}

export interface ItemPricingDtoItem {
  id: string;
  standardPricePerUnit: number;
  volumePricing: ItemVolumePricing[];
}

export type ItemPricingDtoItems = { [key: string]: ItemPricingDtoItem };

export interface ItemPricingDto {
  items: ItemPricingDtoItems;
}

export interface AcceptUserInviteDto {
  hash: string;
  password: string;
  firstName: string;
  lastName: string;
}

export interface CreateUserInviteDto {
  email: string;
  roleIds: string[];
}

export interface GetStagingAreasResponseDto {
  hasNextPage: boolean;
  data: StagingAreaEntity[];
}

export interface ItemVolumePricingEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  itemId: string;
  moq: number;
  pricePerUnit: number;
  createdById: string;
  updatedById: string;
  deletedAt?: string;
}

export interface UpsertItemVolumePricingDto {
  id?: string;
  itemId: string;
  moq: number;
  pricePerUnit: number;
}

export interface MergeItemVolumePricingDto {
  rows: UpsertItemVolumePricingDto[];
}

export type UpdateItemDtoDefaultTaxExemptionType =
  (typeof UpdateItemDtoDefaultTaxExemptionType)[keyof typeof UpdateItemDtoDefaultTaxExemptionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateItemDtoDefaultTaxExemptionType = {
  ADULT_USE: 'ADULT_USE',
  MEDICAL: 'MEDICAL',
  null: null,
} as const;

export type UpdateItemDtoCannabisWeightPerUnitMeasurement =
  (typeof UpdateItemDtoCannabisWeightPerUnitMeasurement)[keyof typeof UpdateItemDtoCannabisWeightPerUnitMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateItemDtoCannabisWeightPerUnitMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
} as const;

export type UpdateItemDtoInventoryCategoryTagsItem =
  (typeof UpdateItemDtoInventoryCategoryTagsItem)[keyof typeof UpdateItemDtoInventoryCategoryTagsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateItemDtoInventoryCategoryTagsItem = {
  AIRGRAFT: 'AIRGRAFT',
  BALM: 'BALM',
  BOTANICAL: 'BOTANICAL',
  BROWNIE: 'BROWNIE',
  BUD: 'BUD',
  BUDDER: 'BUDDER',
  BUTANE_HASH_OIL: 'BUTANE_HASH_OIL',
  BUTTER: 'BUTTER',
  CAPSULE: 'CAPSULE',
  CARTRIDGE_510: 'CARTRIDGE_510',
  CHIPS: 'CHIPS',
  CHOCOLATE: 'CHOCOLATE',
  CO2_OIL: 'CO2_OIL',
  COFFEE: 'COFFEE',
  COLD_WATER_HASH: 'COLD_WATER_HASH',
  CONCENTRATE: 'CONCENTRATE',
  COOKIE: 'COOKIE',
  CREAM: 'CREAM',
  CRUMBLE: 'CRUMBLE',
  DART: 'DART',
  DIAMONDS: 'DIAMONDS',
  DISSOLVABLE_POWDER: 'DISSOLVABLE_POWDER',
  FROST: 'FROST',
  GREENHOUSE: 'GREENHOUSE',
  GUMMY: 'GUMMY',
  HARD_CANDY: 'HARD_CANDY',
  HASH: 'HASH',
  HONEY: 'HONEY',
  ICE_CREAM: 'ICE_CREAM',
  INDOOR: 'INDOOR',
  INFUSED_FLOWER: 'INFUSED_FLOWER',
  INFUSED_PRE_ROLLS: 'INFUSED_PRE_ROLLS',
  INHALER: 'INHALER',
  JUICE: 'JUICE',
  KIEF: 'KIEF',
  KIF: 'KIF',
  LEAFLETTES: 'LEAFLETTES',
  LIGHT_DEP: 'LIGHT_DEP',
  LIP_BALM: 'LIP_BALM',
  LIVE_RESIN: 'LIVE_RESIN',
  MARSHMALLOW: 'MARSHMALLOW',
  MINT: 'MINT',
  MIXED: 'MIXED',
  OTHER_BATTERY_TYPES: 'OTHER_BATTERY_TYPES',
  OTHER: 'OTHER',
  OUTDOOR: 'OUTDOOR',
  PACK: 'PACK',
  PATCH: 'PATCH',
  PAX: 'PAX',
  PEN: 'PEN',
  PILL: 'PILL',
  POPCORN: 'POPCORN',
  POPS: 'POPS',
  PRE_GROUND: 'PRE_GROUND',
  PRE_ROLLS: 'PRE_ROLLS',
  PROPRIETARY: 'PROPRIETARY',
  READY_TO_ROLL: 'READY_TO_ROLL',
  ROSIN: 'ROSIN',
  SALVE: 'SALVE',
  SAUCE: 'SAUCE',
  SELTZER: 'SELTZER',
  SHAKE: 'SHAKE',
  SHATTER: 'SHATTER',
  SHOT: 'SHOT',
  SINGLE: 'SINGLE',
  SODA: 'SODA',
  SOLVENTLESS: 'SOLVENTLESS',
  SPRAY: 'SPRAY',
  SUBLINGUAL: 'SUBLINGUAL',
  SUGAR: 'SUGAR',
  SUN_GROWN: 'SUN_GROWN',
  SUPPOSITORY: 'SUPPOSITORY',
  TABLETS: 'TABLETS',
  TAFFY: 'TAFFY',
  TEA: 'TEA',
  THREAD_510: 'THREAD_510',
  TINCTURES: 'TINCTURES',
  TRANSDERMAL: 'TRANSDERMAL',
  TRIM: 'TRIM',
  WATER: 'WATER',
  WAX: 'WAX',
  BAKED_GOOD: 'BAKED_GOOD',
  BATTERY: 'BATTERY',
  BEVERAGE: 'BEVERAGE',
  CANDY: 'CANDY',
  CARTRIDGE: 'CARTRIDGE',
  CRYSTALLINE: 'CRYSTALLINE',
  DISPOSABLE: 'DISPOSABLE',
  WHOLE_FLOWER: 'WHOLE_FLOWER',
  OIL: 'OIL',
} as const;

export type UpdateItemDtoUnitWeightMeasurement =
  (typeof UpdateItemDtoUnitWeightMeasurement)[keyof typeof UpdateItemDtoUnitWeightMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateItemDtoUnitWeightMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
  null: null,
} as const;

export type UpdateItemDtoWeightMeasurement =
  (typeof UpdateItemDtoWeightMeasurement)[keyof typeof UpdateItemDtoWeightMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateItemDtoWeightMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
} as const;

export type UpdateItemDtoStrainType = (typeof UpdateItemDtoStrainType)[keyof typeof UpdateItemDtoStrainType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateItemDtoStrainType = {
  OTHER: 'OTHER',
  SATIVA: 'SATIVA',
  INDICA: 'INDICA',
  HYBRID: 'HYBRID',
  SATIVA_DOMINANT: 'SATIVA_DOMINANT',
  INDICA_DOMINANT: 'INDICA_DOMINANT',
  null: null,
} as const;

export type UpdateItemDtoTagsItem = (typeof UpdateItemDtoTagsItem)[keyof typeof UpdateItemDtoTagsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateItemDtoTagsItem = {
  ACCESSORY: 'ACCESSORY',
  BALANCE: 'BALANCE',
  BEGINNER: 'BEGINNER',
  BLACK_OWNED: 'BLACK_OWNED',
  BLEND: 'BLEND',
  BUDGET: 'BUDGET',
  CREATIVE: 'CREATIVE',
  CULTIVATOR: 'CULTIVATOR',
  DESIGNER: 'DESIGNER',
  DISTILLATE_INFUSED: 'DISTILLATE_INFUSED',
  EFFECT_BASED: 'EFFECT_BASED',
  ENERGETIC: 'ENERGETIC',
  ENTHUSIAST: 'ENTHUSIAST',
  EUPHORIC: 'EUPHORIC',
  FAMILY_OWNED: 'FAMILY_OWNED',
  FEMALE_OWNED: 'FEMALE_OWNED',
  FIVE_TO_ONE_CBD_THC_RATIO: 'FIVE_TO_ONE_CBD_THC_RATIO',
  FOCUSED: 'FOCUSED',
  FROZEN: 'FROZEN',
  GIDDY: 'GIDDY',
  GLASS: 'GLASS',
  HAPPY: 'HAPPY',
  HASH_INFUSED: 'HASH_INFUSED',
  HERITAGE_AND_LEGACY_BRAND: 'HERITAGE_AND_LEGACY_BRAND',
  HUNDRED_PERCENT_BIODEGRADABLE: 'HUNDRED_PERCENT_BIODEGRADABLE',
  HUNGRY: 'HUNGRY',
  MASS_MARKET: 'MASS_MARKET',
  MEDICAL: 'MEDICAL',
  MID_MARKET: 'MID_MARKET',
  MINORITY_OWNED: 'MINORITY_OWNED',
  MYLAR_BAGS: 'MYLAR_BAGS',
  NANO_EMULSION_OR_FAST_ACTING: 'NANO_EMULSION_OR_FAST_ACTING',
  NON_CANNABIS: 'NON_CANNABIS',
  ONE_TO_ONE_CBD_THC_RATIO: 'ONE_TO_ONE_CBD_THC_RATIO',
  ONE_TO_TEN_CBD_THC_RATIO: 'ONE_TO_TEN_CBD_THC_RATIO',
  ONE_TO_TWO_CBD_THC_RATIO: 'ONE_TO_TWO_CBD_THC_RATIO',
  PAIN_RELIEF: 'PAIN_RELIEF',
  PLASTIC: 'PLASTIC',
  PRECISE_DOSING: 'PRECISE_DOSING',
  PREMIUM: 'PREMIUM',
  RECREATIONAL: 'RECREATIONAL',
  REFRIGERATED: 'REFRIGERATED',
  RELAXED: 'RELAXED',
  ROSIN_INFUSED: 'ROSIN_INFUSED',
  SHELF_STABLE: 'SHELF_STABLE',
  SLEEP_AID: 'SLEEP_AID',
  SLEEPY: 'SLEEPY',
  SOCIAL_EQUITY: 'SOCIAL_EQUITY',
  STRAIN_SPECIFIC: 'STRAIN_SPECIFIC',
  TALKATIVE: 'TALKATIVE',
  TEN_TO_ONE_CBD_THC_RATIO: 'TEN_TO_ONE_CBD_THC_RATIO',
  THREE_TO_ONE_CBD_THC_RATIO: 'THREE_TO_ONE_CBD_THC_RATIO',
  TWO_TO_ONE_CBD_THC_RATIO: 'TWO_TO_ONE_CBD_THC_RATIO',
  UPLIFTED: 'UPLIFTED',
} as const;

export type UpdateItemDtoInventoryUnitOfMeasure =
  (typeof UpdateItemDtoInventoryUnitOfMeasure)[keyof typeof UpdateItemDtoInventoryUnitOfMeasure];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateItemDtoInventoryUnitOfMeasure = {
  EACH: 'EACH',
  PACK: 'PACK',
  CASE: 'CASE',
  PALLET: 'PALLET',
} as const;

export type UpdateItemDtoInventoryCategory =
  (typeof UpdateItemDtoInventoryCategory)[keyof typeof UpdateItemDtoInventoryCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateItemDtoInventoryCategory = {
  AIRGRAFT: 'AIRGRAFT',
  BALM: 'BALM',
  BOTANICAL: 'BOTANICAL',
  BROWNIE: 'BROWNIE',
  BUD: 'BUD',
  BUDDER: 'BUDDER',
  BUTANE_HASH_OIL: 'BUTANE_HASH_OIL',
  BUTTER: 'BUTTER',
  CAPSULE: 'CAPSULE',
  CARTRIDGE_510: 'CARTRIDGE_510',
  CHIPS: 'CHIPS',
  CHOCOLATE: 'CHOCOLATE',
  CO2_OIL: 'CO2_OIL',
  COFFEE: 'COFFEE',
  COLD_WATER_HASH: 'COLD_WATER_HASH',
  CONCENTRATE: 'CONCENTRATE',
  COOKIE: 'COOKIE',
  CREAM: 'CREAM',
  CRUMBLE: 'CRUMBLE',
  DART: 'DART',
  DIAMONDS: 'DIAMONDS',
  DISSOLVABLE_POWDER: 'DISSOLVABLE_POWDER',
  FROST: 'FROST',
  GREENHOUSE: 'GREENHOUSE',
  GUMMY: 'GUMMY',
  HARD_CANDY: 'HARD_CANDY',
  HASH: 'HASH',
  HONEY: 'HONEY',
  ICE_CREAM: 'ICE_CREAM',
  INDOOR: 'INDOOR',
  INFUSED_FLOWER: 'INFUSED_FLOWER',
  INFUSED_PRE_ROLLS: 'INFUSED_PRE_ROLLS',
  INHALER: 'INHALER',
  JUICE: 'JUICE',
  KIEF: 'KIEF',
  KIF: 'KIF',
  LEAFLETTES: 'LEAFLETTES',
  LIGHT_DEP: 'LIGHT_DEP',
  LIP_BALM: 'LIP_BALM',
  LIVE_RESIN: 'LIVE_RESIN',
  MARSHMALLOW: 'MARSHMALLOW',
  MINT: 'MINT',
  MIXED: 'MIXED',
  OTHER_BATTERY_TYPES: 'OTHER_BATTERY_TYPES',
  OTHER: 'OTHER',
  OUTDOOR: 'OUTDOOR',
  PACK: 'PACK',
  PATCH: 'PATCH',
  PAX: 'PAX',
  PEN: 'PEN',
  PILL: 'PILL',
  POPCORN: 'POPCORN',
  POPS: 'POPS',
  PRE_GROUND: 'PRE_GROUND',
  PRE_ROLLS: 'PRE_ROLLS',
  PROPRIETARY: 'PROPRIETARY',
  READY_TO_ROLL: 'READY_TO_ROLL',
  ROSIN: 'ROSIN',
  SALVE: 'SALVE',
  SAUCE: 'SAUCE',
  SELTZER: 'SELTZER',
  SHAKE: 'SHAKE',
  SHATTER: 'SHATTER',
  SHOT: 'SHOT',
  SINGLE: 'SINGLE',
  SODA: 'SODA',
  SOLVENTLESS: 'SOLVENTLESS',
  SPRAY: 'SPRAY',
  SUBLINGUAL: 'SUBLINGUAL',
  SUGAR: 'SUGAR',
  SUN_GROWN: 'SUN_GROWN',
  SUPPOSITORY: 'SUPPOSITORY',
  TABLETS: 'TABLETS',
  TAFFY: 'TAFFY',
  TEA: 'TEA',
  THREAD_510: 'THREAD_510',
  TINCTURES: 'TINCTURES',
  TRANSDERMAL: 'TRANSDERMAL',
  TRIM: 'TRIM',
  WATER: 'WATER',
  WAX: 'WAX',
  BAKED_GOOD: 'BAKED_GOOD',
  BATTERY: 'BATTERY',
  BEVERAGE: 'BEVERAGE',
  CANDY: 'CANDY',
  CARTRIDGE: 'CARTRIDGE',
  CRYSTALLINE: 'CRYSTALLINE',
  DISPOSABLE: 'DISPOSABLE',
  WHOLE_FLOWER: 'WHOLE_FLOWER',
  OIL: 'OIL',
  null: null,
} as const;

export type UpdateItemDtoInventoryClass =
  (typeof UpdateItemDtoInventoryClass)[keyof typeof UpdateItemDtoInventoryClass];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateItemDtoInventoryClass = {
  CONCENTRATE: 'CONCENTRATE',
  EDIBLES: 'EDIBLES',
  FLOWER: 'FLOWER',
  PERSONAL_CARE: 'PERSONAL_CARE',
  PRE_ROLL: 'PRE_ROLL',
  VAPE: 'VAPE',
  ACCESSORIES: 'ACCESSORIES',
  null: null,
} as const;

export type UpdateItemDtoInventoryType = (typeof UpdateItemDtoInventoryType)[keyof typeof UpdateItemDtoInventoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateItemDtoInventoryType = {
  CANNABIS: 'CANNABIS',
  NON_CANNABIS: 'NON_CANNABIS',
} as const;

export interface UpdateItemDto {
  code?: string;
  inventoryType?: UpdateItemDtoInventoryType;
  inventoryClass?: UpdateItemDtoInventoryClass;
  inventoryCategory?: UpdateItemDtoInventoryCategory;
  unit?: string | null;
  pricePerUnit?: number;
  name?: string;
  inventoryUnitOfMeasure?: UpdateItemDtoInventoryUnitOfMeasure;
  quantityPerUnitOfMeasure?: number;
  tags?: UpdateItemDtoTagsItem[];
  strainType?: UpdateItemDtoStrainType;
  nonSampleItemId?: string | null;
  skuDetailsPdfLink?: string | null;
  janeProductId?: number | null;
  length?: number | null;
  width?: number | null;
  height?: number | null;
  weight?: number | null;
  weightMeasurement?: UpdateItemDtoWeightMeasurement;
  unitWeight?: number | null;
  unitWeightMeasurement?: UpdateItemDtoUnitWeightMeasurement;
  inventoryCategoryTags?: UpdateItemDtoInventoryCategoryTagsItem[];
  isArchived?: boolean;
  cannabisWeightPerUnit?: number;
  cannabisWeightPerUnitMeasurement?: UpdateItemDtoCannabisWeightPerUnitMeasurement;
  isMedical?: boolean;
  defaultTaxExemptionType?: UpdateItemDtoDefaultTaxExemptionType;
  description?: string | null;
  availableOnMarketplace?: boolean;
  marketplaceThcValue?: number;
  marketplaceThcUnit?: string;
  marketplaceSamplesEnabled?: boolean;
}

export interface GetItemsDetailsResponseDto {
  hasNextPage: boolean;
  data: ItemDetailResponseDto[];
}

export type ItemDetailResponseDtoDefaultTaxExemptionType =
  (typeof ItemDetailResponseDtoDefaultTaxExemptionType)[keyof typeof ItemDetailResponseDtoDefaultTaxExemptionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDetailResponseDtoDefaultTaxExemptionType = {
  ADULT_USE: 'ADULT_USE',
  MEDICAL: 'MEDICAL',
} as const;

export type ItemDetailResponseDtoCannabisWeightPerUnitMeasurement =
  (typeof ItemDetailResponseDtoCannabisWeightPerUnitMeasurement)[keyof typeof ItemDetailResponseDtoCannabisWeightPerUnitMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDetailResponseDtoCannabisWeightPerUnitMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
} as const;

export type ItemDetailResponseDtoInventoryCategoryTagsItem =
  (typeof ItemDetailResponseDtoInventoryCategoryTagsItem)[keyof typeof ItemDetailResponseDtoInventoryCategoryTagsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDetailResponseDtoInventoryCategoryTagsItem = {
  AIRGRAFT: 'AIRGRAFT',
  BALM: 'BALM',
  BOTANICAL: 'BOTANICAL',
  BROWNIE: 'BROWNIE',
  BUD: 'BUD',
  BUDDER: 'BUDDER',
  BUTANE_HASH_OIL: 'BUTANE_HASH_OIL',
  BUTTER: 'BUTTER',
  CAPSULE: 'CAPSULE',
  CARTRIDGE_510: 'CARTRIDGE_510',
  CHIPS: 'CHIPS',
  CHOCOLATE: 'CHOCOLATE',
  CO2_OIL: 'CO2_OIL',
  COFFEE: 'COFFEE',
  COLD_WATER_HASH: 'COLD_WATER_HASH',
  CONCENTRATE: 'CONCENTRATE',
  COOKIE: 'COOKIE',
  CREAM: 'CREAM',
  CRUMBLE: 'CRUMBLE',
  DART: 'DART',
  DIAMONDS: 'DIAMONDS',
  DISSOLVABLE_POWDER: 'DISSOLVABLE_POWDER',
  FROST: 'FROST',
  GREENHOUSE: 'GREENHOUSE',
  GUMMY: 'GUMMY',
  HARD_CANDY: 'HARD_CANDY',
  HASH: 'HASH',
  HONEY: 'HONEY',
  ICE_CREAM: 'ICE_CREAM',
  INDOOR: 'INDOOR',
  INFUSED_FLOWER: 'INFUSED_FLOWER',
  INFUSED_PRE_ROLLS: 'INFUSED_PRE_ROLLS',
  INHALER: 'INHALER',
  JUICE: 'JUICE',
  KIEF: 'KIEF',
  KIF: 'KIF',
  LEAFLETTES: 'LEAFLETTES',
  LIGHT_DEP: 'LIGHT_DEP',
  LIP_BALM: 'LIP_BALM',
  LIVE_RESIN: 'LIVE_RESIN',
  MARSHMALLOW: 'MARSHMALLOW',
  MINT: 'MINT',
  MIXED: 'MIXED',
  OTHER_BATTERY_TYPES: 'OTHER_BATTERY_TYPES',
  OTHER: 'OTHER',
  OUTDOOR: 'OUTDOOR',
  PACK: 'PACK',
  PATCH: 'PATCH',
  PAX: 'PAX',
  PEN: 'PEN',
  PILL: 'PILL',
  POPCORN: 'POPCORN',
  POPS: 'POPS',
  PRE_GROUND: 'PRE_GROUND',
  PRE_ROLLS: 'PRE_ROLLS',
  PROPRIETARY: 'PROPRIETARY',
  READY_TO_ROLL: 'READY_TO_ROLL',
  ROSIN: 'ROSIN',
  SALVE: 'SALVE',
  SAUCE: 'SAUCE',
  SELTZER: 'SELTZER',
  SHAKE: 'SHAKE',
  SHATTER: 'SHATTER',
  SHOT: 'SHOT',
  SINGLE: 'SINGLE',
  SODA: 'SODA',
  SOLVENTLESS: 'SOLVENTLESS',
  SPRAY: 'SPRAY',
  SUBLINGUAL: 'SUBLINGUAL',
  SUGAR: 'SUGAR',
  SUN_GROWN: 'SUN_GROWN',
  SUPPOSITORY: 'SUPPOSITORY',
  TABLETS: 'TABLETS',
  TAFFY: 'TAFFY',
  TEA: 'TEA',
  THREAD_510: 'THREAD_510',
  TINCTURES: 'TINCTURES',
  TRANSDERMAL: 'TRANSDERMAL',
  TRIM: 'TRIM',
  WATER: 'WATER',
  WAX: 'WAX',
  BAKED_GOOD: 'BAKED_GOOD',
  BATTERY: 'BATTERY',
  BEVERAGE: 'BEVERAGE',
  CANDY: 'CANDY',
  CARTRIDGE: 'CARTRIDGE',
  CRYSTALLINE: 'CRYSTALLINE',
  DISPOSABLE: 'DISPOSABLE',
  WHOLE_FLOWER: 'WHOLE_FLOWER',
  OIL: 'OIL',
} as const;

export type ItemDetailResponseDtoUnitWeightMeasurement =
  (typeof ItemDetailResponseDtoUnitWeightMeasurement)[keyof typeof ItemDetailResponseDtoUnitWeightMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDetailResponseDtoUnitWeightMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
  null: null,
} as const;

export type ItemDetailResponseDtoWeightMeasurement =
  (typeof ItemDetailResponseDtoWeightMeasurement)[keyof typeof ItemDetailResponseDtoWeightMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDetailResponseDtoWeightMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
  null: null,
} as const;

export type ItemDetailResponseDtoStrainType =
  (typeof ItemDetailResponseDtoStrainType)[keyof typeof ItemDetailResponseDtoStrainType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDetailResponseDtoStrainType = {
  OTHER: 'OTHER',
  SATIVA: 'SATIVA',
  INDICA: 'INDICA',
  HYBRID: 'HYBRID',
  SATIVA_DOMINANT: 'SATIVA_DOMINANT',
  INDICA_DOMINANT: 'INDICA_DOMINANT',
  null: null,
} as const;

export type ItemDetailResponseDtoTagsItem =
  (typeof ItemDetailResponseDtoTagsItem)[keyof typeof ItemDetailResponseDtoTagsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDetailResponseDtoTagsItem = {
  ACCESSORY: 'ACCESSORY',
  BALANCE: 'BALANCE',
  BEGINNER: 'BEGINNER',
  BLACK_OWNED: 'BLACK_OWNED',
  BLEND: 'BLEND',
  BUDGET: 'BUDGET',
  CREATIVE: 'CREATIVE',
  CULTIVATOR: 'CULTIVATOR',
  DESIGNER: 'DESIGNER',
  DISTILLATE_INFUSED: 'DISTILLATE_INFUSED',
  EFFECT_BASED: 'EFFECT_BASED',
  ENERGETIC: 'ENERGETIC',
  ENTHUSIAST: 'ENTHUSIAST',
  EUPHORIC: 'EUPHORIC',
  FAMILY_OWNED: 'FAMILY_OWNED',
  FEMALE_OWNED: 'FEMALE_OWNED',
  FIVE_TO_ONE_CBD_THC_RATIO: 'FIVE_TO_ONE_CBD_THC_RATIO',
  FOCUSED: 'FOCUSED',
  FROZEN: 'FROZEN',
  GIDDY: 'GIDDY',
  GLASS: 'GLASS',
  HAPPY: 'HAPPY',
  HASH_INFUSED: 'HASH_INFUSED',
  HERITAGE_AND_LEGACY_BRAND: 'HERITAGE_AND_LEGACY_BRAND',
  HUNDRED_PERCENT_BIODEGRADABLE: 'HUNDRED_PERCENT_BIODEGRADABLE',
  HUNGRY: 'HUNGRY',
  MASS_MARKET: 'MASS_MARKET',
  MEDICAL: 'MEDICAL',
  MID_MARKET: 'MID_MARKET',
  MINORITY_OWNED: 'MINORITY_OWNED',
  MYLAR_BAGS: 'MYLAR_BAGS',
  NANO_EMULSION_OR_FAST_ACTING: 'NANO_EMULSION_OR_FAST_ACTING',
  NON_CANNABIS: 'NON_CANNABIS',
  ONE_TO_ONE_CBD_THC_RATIO: 'ONE_TO_ONE_CBD_THC_RATIO',
  ONE_TO_TEN_CBD_THC_RATIO: 'ONE_TO_TEN_CBD_THC_RATIO',
  ONE_TO_TWO_CBD_THC_RATIO: 'ONE_TO_TWO_CBD_THC_RATIO',
  PAIN_RELIEF: 'PAIN_RELIEF',
  PLASTIC: 'PLASTIC',
  PRECISE_DOSING: 'PRECISE_DOSING',
  PREMIUM: 'PREMIUM',
  RECREATIONAL: 'RECREATIONAL',
  REFRIGERATED: 'REFRIGERATED',
  RELAXED: 'RELAXED',
  ROSIN_INFUSED: 'ROSIN_INFUSED',
  SHELF_STABLE: 'SHELF_STABLE',
  SLEEP_AID: 'SLEEP_AID',
  SLEEPY: 'SLEEPY',
  SOCIAL_EQUITY: 'SOCIAL_EQUITY',
  STRAIN_SPECIFIC: 'STRAIN_SPECIFIC',
  TALKATIVE: 'TALKATIVE',
  TEN_TO_ONE_CBD_THC_RATIO: 'TEN_TO_ONE_CBD_THC_RATIO',
  THREE_TO_ONE_CBD_THC_RATIO: 'THREE_TO_ONE_CBD_THC_RATIO',
  TWO_TO_ONE_CBD_THC_RATIO: 'TWO_TO_ONE_CBD_THC_RATIO',
  UPLIFTED: 'UPLIFTED',
} as const;

export type ItemDetailResponseDtoInventoryUnitOfMeasure =
  (typeof ItemDetailResponseDtoInventoryUnitOfMeasure)[keyof typeof ItemDetailResponseDtoInventoryUnitOfMeasure];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDetailResponseDtoInventoryUnitOfMeasure = {
  EACH: 'EACH',
  PACK: 'PACK',
  CASE: 'CASE',
  PALLET: 'PALLET',
} as const;

export type ItemDetailResponseDtoInventoryCategory =
  (typeof ItemDetailResponseDtoInventoryCategory)[keyof typeof ItemDetailResponseDtoInventoryCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDetailResponseDtoInventoryCategory = {
  AIRGRAFT: 'AIRGRAFT',
  BALM: 'BALM',
  BOTANICAL: 'BOTANICAL',
  BROWNIE: 'BROWNIE',
  BUD: 'BUD',
  BUDDER: 'BUDDER',
  BUTANE_HASH_OIL: 'BUTANE_HASH_OIL',
  BUTTER: 'BUTTER',
  CAPSULE: 'CAPSULE',
  CARTRIDGE_510: 'CARTRIDGE_510',
  CHIPS: 'CHIPS',
  CHOCOLATE: 'CHOCOLATE',
  CO2_OIL: 'CO2_OIL',
  COFFEE: 'COFFEE',
  COLD_WATER_HASH: 'COLD_WATER_HASH',
  CONCENTRATE: 'CONCENTRATE',
  COOKIE: 'COOKIE',
  CREAM: 'CREAM',
  CRUMBLE: 'CRUMBLE',
  DART: 'DART',
  DIAMONDS: 'DIAMONDS',
  DISSOLVABLE_POWDER: 'DISSOLVABLE_POWDER',
  FROST: 'FROST',
  GREENHOUSE: 'GREENHOUSE',
  GUMMY: 'GUMMY',
  HARD_CANDY: 'HARD_CANDY',
  HASH: 'HASH',
  HONEY: 'HONEY',
  ICE_CREAM: 'ICE_CREAM',
  INDOOR: 'INDOOR',
  INFUSED_FLOWER: 'INFUSED_FLOWER',
  INFUSED_PRE_ROLLS: 'INFUSED_PRE_ROLLS',
  INHALER: 'INHALER',
  JUICE: 'JUICE',
  KIEF: 'KIEF',
  KIF: 'KIF',
  LEAFLETTES: 'LEAFLETTES',
  LIGHT_DEP: 'LIGHT_DEP',
  LIP_BALM: 'LIP_BALM',
  LIVE_RESIN: 'LIVE_RESIN',
  MARSHMALLOW: 'MARSHMALLOW',
  MINT: 'MINT',
  MIXED: 'MIXED',
  OTHER_BATTERY_TYPES: 'OTHER_BATTERY_TYPES',
  OTHER: 'OTHER',
  OUTDOOR: 'OUTDOOR',
  PACK: 'PACK',
  PATCH: 'PATCH',
  PAX: 'PAX',
  PEN: 'PEN',
  PILL: 'PILL',
  POPCORN: 'POPCORN',
  POPS: 'POPS',
  PRE_GROUND: 'PRE_GROUND',
  PRE_ROLLS: 'PRE_ROLLS',
  PROPRIETARY: 'PROPRIETARY',
  READY_TO_ROLL: 'READY_TO_ROLL',
  ROSIN: 'ROSIN',
  SALVE: 'SALVE',
  SAUCE: 'SAUCE',
  SELTZER: 'SELTZER',
  SHAKE: 'SHAKE',
  SHATTER: 'SHATTER',
  SHOT: 'SHOT',
  SINGLE: 'SINGLE',
  SODA: 'SODA',
  SOLVENTLESS: 'SOLVENTLESS',
  SPRAY: 'SPRAY',
  SUBLINGUAL: 'SUBLINGUAL',
  SUGAR: 'SUGAR',
  SUN_GROWN: 'SUN_GROWN',
  SUPPOSITORY: 'SUPPOSITORY',
  TABLETS: 'TABLETS',
  TAFFY: 'TAFFY',
  TEA: 'TEA',
  THREAD_510: 'THREAD_510',
  TINCTURES: 'TINCTURES',
  TRANSDERMAL: 'TRANSDERMAL',
  TRIM: 'TRIM',
  WATER: 'WATER',
  WAX: 'WAX',
  BAKED_GOOD: 'BAKED_GOOD',
  BATTERY: 'BATTERY',
  BEVERAGE: 'BEVERAGE',
  CANDY: 'CANDY',
  CARTRIDGE: 'CARTRIDGE',
  CRYSTALLINE: 'CRYSTALLINE',
  DISPOSABLE: 'DISPOSABLE',
  WHOLE_FLOWER: 'WHOLE_FLOWER',
  OIL: 'OIL',
} as const;

export type ItemDetailResponseDtoInventoryClass =
  (typeof ItemDetailResponseDtoInventoryClass)[keyof typeof ItemDetailResponseDtoInventoryClass];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDetailResponseDtoInventoryClass = {
  CONCENTRATE: 'CONCENTRATE',
  EDIBLES: 'EDIBLES',
  FLOWER: 'FLOWER',
  PERSONAL_CARE: 'PERSONAL_CARE',
  PRE_ROLL: 'PRE_ROLL',
  VAPE: 'VAPE',
  ACCESSORIES: 'ACCESSORIES',
} as const;

export type ItemDetailResponseDtoInventoryType =
  (typeof ItemDetailResponseDtoInventoryType)[keyof typeof ItemDetailResponseDtoInventoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDetailResponseDtoInventoryType = {
  CANNABIS: 'CANNABIS',
  NON_CANNABIS: 'NON_CANNABIS',
} as const;

export interface ItemBatchDto {
  id: string;
  batchCode: string;
  batchExpiryDate: string;
}

export interface ItemDetailResponseDto {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  code: string;
  organizationId: string;
  inventoryType: ItemDetailResponseDtoInventoryType;
  inventoryClass: ItemDetailResponseDtoInventoryClass;
  inventoryCategory: ItemDetailResponseDtoInventoryCategory;
  unit: string;
  pricePerUnit: number;
  name: string;
  deletedAt: string | null;
  inventoryUnitOfMeasure: ItemDetailResponseDtoInventoryUnitOfMeasure;
  quantityPerUnitOfMeasure: number;
  tags: ItemDetailResponseDtoTagsItem[];
  strainType: ItemDetailResponseDtoStrainType;
  nonSampleItemId: string | null;
  skuDetailsPdfLink: string | null;
  janeProductId: number | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  weightMeasurement: ItemDetailResponseDtoWeightMeasurement;
  unitWeight: number | null;
  unitWeightMeasurement: ItemDetailResponseDtoUnitWeightMeasurement;
  inventoryCategoryTags: ItemDetailResponseDtoInventoryCategoryTagsItem[];
  cannabisWeightPerUnit: number;
  cannabisWeightPerUnitMeasurement: ItemDetailResponseDtoCannabisWeightPerUnitMeasurement;
  isMedical: boolean;
  defaultTaxExemptionType: ItemDetailResponseDtoDefaultTaxExemptionType;
  /** User who created the record */
  createdById: string;
  description: string | null;
  availableOnMarketplace: boolean;
  marketplaceThcValue: number;
  marketplaceThcUnit: string;
  marketplaceSamplesEnabled: boolean;
  licenseId: string;
  licenseNickname: string;
  itemBatches: ItemBatchDto[];
  brandMarketplaceEnabled: boolean;
}

export interface ItemFindManyResponseDto {
  hasNextPage: boolean;
  data: EnrichedItemEntity[];
}

export type CreateItemDtoDefaultTaxExemptionType =
  (typeof CreateItemDtoDefaultTaxExemptionType)[keyof typeof CreateItemDtoDefaultTaxExemptionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateItemDtoDefaultTaxExemptionType = {
  ADULT_USE: 'ADULT_USE',
  MEDICAL: 'MEDICAL',
  null: null,
} as const;

export type CreateItemDtoCannabisWeightPerUnitMeasurement =
  (typeof CreateItemDtoCannabisWeightPerUnitMeasurement)[keyof typeof CreateItemDtoCannabisWeightPerUnitMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateItemDtoCannabisWeightPerUnitMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
} as const;

export type CreateItemDtoInventoryCategoryTagsItem =
  (typeof CreateItemDtoInventoryCategoryTagsItem)[keyof typeof CreateItemDtoInventoryCategoryTagsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateItemDtoInventoryCategoryTagsItem = {
  AIRGRAFT: 'AIRGRAFT',
  BALM: 'BALM',
  BOTANICAL: 'BOTANICAL',
  BROWNIE: 'BROWNIE',
  BUD: 'BUD',
  BUDDER: 'BUDDER',
  BUTANE_HASH_OIL: 'BUTANE_HASH_OIL',
  BUTTER: 'BUTTER',
  CAPSULE: 'CAPSULE',
  CARTRIDGE_510: 'CARTRIDGE_510',
  CHIPS: 'CHIPS',
  CHOCOLATE: 'CHOCOLATE',
  CO2_OIL: 'CO2_OIL',
  COFFEE: 'COFFEE',
  COLD_WATER_HASH: 'COLD_WATER_HASH',
  CONCENTRATE: 'CONCENTRATE',
  COOKIE: 'COOKIE',
  CREAM: 'CREAM',
  CRUMBLE: 'CRUMBLE',
  DART: 'DART',
  DIAMONDS: 'DIAMONDS',
  DISSOLVABLE_POWDER: 'DISSOLVABLE_POWDER',
  FROST: 'FROST',
  GREENHOUSE: 'GREENHOUSE',
  GUMMY: 'GUMMY',
  HARD_CANDY: 'HARD_CANDY',
  HASH: 'HASH',
  HONEY: 'HONEY',
  ICE_CREAM: 'ICE_CREAM',
  INDOOR: 'INDOOR',
  INFUSED_FLOWER: 'INFUSED_FLOWER',
  INFUSED_PRE_ROLLS: 'INFUSED_PRE_ROLLS',
  INHALER: 'INHALER',
  JUICE: 'JUICE',
  KIEF: 'KIEF',
  KIF: 'KIF',
  LEAFLETTES: 'LEAFLETTES',
  LIGHT_DEP: 'LIGHT_DEP',
  LIP_BALM: 'LIP_BALM',
  LIVE_RESIN: 'LIVE_RESIN',
  MARSHMALLOW: 'MARSHMALLOW',
  MINT: 'MINT',
  MIXED: 'MIXED',
  OTHER_BATTERY_TYPES: 'OTHER_BATTERY_TYPES',
  OTHER: 'OTHER',
  OUTDOOR: 'OUTDOOR',
  PACK: 'PACK',
  PATCH: 'PATCH',
  PAX: 'PAX',
  PEN: 'PEN',
  PILL: 'PILL',
  POPCORN: 'POPCORN',
  POPS: 'POPS',
  PRE_GROUND: 'PRE_GROUND',
  PRE_ROLLS: 'PRE_ROLLS',
  PROPRIETARY: 'PROPRIETARY',
  READY_TO_ROLL: 'READY_TO_ROLL',
  ROSIN: 'ROSIN',
  SALVE: 'SALVE',
  SAUCE: 'SAUCE',
  SELTZER: 'SELTZER',
  SHAKE: 'SHAKE',
  SHATTER: 'SHATTER',
  SHOT: 'SHOT',
  SINGLE: 'SINGLE',
  SODA: 'SODA',
  SOLVENTLESS: 'SOLVENTLESS',
  SPRAY: 'SPRAY',
  SUBLINGUAL: 'SUBLINGUAL',
  SUGAR: 'SUGAR',
  SUN_GROWN: 'SUN_GROWN',
  SUPPOSITORY: 'SUPPOSITORY',
  TABLETS: 'TABLETS',
  TAFFY: 'TAFFY',
  TEA: 'TEA',
  THREAD_510: 'THREAD_510',
  TINCTURES: 'TINCTURES',
  TRANSDERMAL: 'TRANSDERMAL',
  TRIM: 'TRIM',
  WATER: 'WATER',
  WAX: 'WAX',
  BAKED_GOOD: 'BAKED_GOOD',
  BATTERY: 'BATTERY',
  BEVERAGE: 'BEVERAGE',
  CANDY: 'CANDY',
  CARTRIDGE: 'CARTRIDGE',
  CRYSTALLINE: 'CRYSTALLINE',
  DISPOSABLE: 'DISPOSABLE',
  WHOLE_FLOWER: 'WHOLE_FLOWER',
  OIL: 'OIL',
} as const;

export type CreateItemDtoUnitWeightMeasurement =
  (typeof CreateItemDtoUnitWeightMeasurement)[keyof typeof CreateItemDtoUnitWeightMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateItemDtoUnitWeightMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
  null: null,
} as const;

export type CreateItemDtoWeightMeasurement =
  (typeof CreateItemDtoWeightMeasurement)[keyof typeof CreateItemDtoWeightMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateItemDtoWeightMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
} as const;

export type CreateItemDtoStrainType = (typeof CreateItemDtoStrainType)[keyof typeof CreateItemDtoStrainType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateItemDtoStrainType = {
  OTHER: 'OTHER',
  SATIVA: 'SATIVA',
  INDICA: 'INDICA',
  HYBRID: 'HYBRID',
  SATIVA_DOMINANT: 'SATIVA_DOMINANT',
  INDICA_DOMINANT: 'INDICA_DOMINANT',
  null: null,
} as const;

export type CreateItemDtoTagsItem = (typeof CreateItemDtoTagsItem)[keyof typeof CreateItemDtoTagsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateItemDtoTagsItem = {
  ACCESSORY: 'ACCESSORY',
  BALANCE: 'BALANCE',
  BEGINNER: 'BEGINNER',
  BLACK_OWNED: 'BLACK_OWNED',
  BLEND: 'BLEND',
  BUDGET: 'BUDGET',
  CREATIVE: 'CREATIVE',
  CULTIVATOR: 'CULTIVATOR',
  DESIGNER: 'DESIGNER',
  DISTILLATE_INFUSED: 'DISTILLATE_INFUSED',
  EFFECT_BASED: 'EFFECT_BASED',
  ENERGETIC: 'ENERGETIC',
  ENTHUSIAST: 'ENTHUSIAST',
  EUPHORIC: 'EUPHORIC',
  FAMILY_OWNED: 'FAMILY_OWNED',
  FEMALE_OWNED: 'FEMALE_OWNED',
  FIVE_TO_ONE_CBD_THC_RATIO: 'FIVE_TO_ONE_CBD_THC_RATIO',
  FOCUSED: 'FOCUSED',
  FROZEN: 'FROZEN',
  GIDDY: 'GIDDY',
  GLASS: 'GLASS',
  HAPPY: 'HAPPY',
  HASH_INFUSED: 'HASH_INFUSED',
  HERITAGE_AND_LEGACY_BRAND: 'HERITAGE_AND_LEGACY_BRAND',
  HUNDRED_PERCENT_BIODEGRADABLE: 'HUNDRED_PERCENT_BIODEGRADABLE',
  HUNGRY: 'HUNGRY',
  MASS_MARKET: 'MASS_MARKET',
  MEDICAL: 'MEDICAL',
  MID_MARKET: 'MID_MARKET',
  MINORITY_OWNED: 'MINORITY_OWNED',
  MYLAR_BAGS: 'MYLAR_BAGS',
  NANO_EMULSION_OR_FAST_ACTING: 'NANO_EMULSION_OR_FAST_ACTING',
  NON_CANNABIS: 'NON_CANNABIS',
  ONE_TO_ONE_CBD_THC_RATIO: 'ONE_TO_ONE_CBD_THC_RATIO',
  ONE_TO_TEN_CBD_THC_RATIO: 'ONE_TO_TEN_CBD_THC_RATIO',
  ONE_TO_TWO_CBD_THC_RATIO: 'ONE_TO_TWO_CBD_THC_RATIO',
  PAIN_RELIEF: 'PAIN_RELIEF',
  PLASTIC: 'PLASTIC',
  PRECISE_DOSING: 'PRECISE_DOSING',
  PREMIUM: 'PREMIUM',
  RECREATIONAL: 'RECREATIONAL',
  REFRIGERATED: 'REFRIGERATED',
  RELAXED: 'RELAXED',
  ROSIN_INFUSED: 'ROSIN_INFUSED',
  SHELF_STABLE: 'SHELF_STABLE',
  SLEEP_AID: 'SLEEP_AID',
  SLEEPY: 'SLEEPY',
  SOCIAL_EQUITY: 'SOCIAL_EQUITY',
  STRAIN_SPECIFIC: 'STRAIN_SPECIFIC',
  TALKATIVE: 'TALKATIVE',
  TEN_TO_ONE_CBD_THC_RATIO: 'TEN_TO_ONE_CBD_THC_RATIO',
  THREE_TO_ONE_CBD_THC_RATIO: 'THREE_TO_ONE_CBD_THC_RATIO',
  TWO_TO_ONE_CBD_THC_RATIO: 'TWO_TO_ONE_CBD_THC_RATIO',
  UPLIFTED: 'UPLIFTED',
} as const;

export type CreateItemDtoInventoryUnitOfMeasure =
  (typeof CreateItemDtoInventoryUnitOfMeasure)[keyof typeof CreateItemDtoInventoryUnitOfMeasure];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateItemDtoInventoryUnitOfMeasure = {
  EACH: 'EACH',
  PACK: 'PACK',
  CASE: 'CASE',
  PALLET: 'PALLET',
} as const;

export type CreateItemDtoInventoryCategory =
  (typeof CreateItemDtoInventoryCategory)[keyof typeof CreateItemDtoInventoryCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateItemDtoInventoryCategory = {
  AIRGRAFT: 'AIRGRAFT',
  BALM: 'BALM',
  BOTANICAL: 'BOTANICAL',
  BROWNIE: 'BROWNIE',
  BUD: 'BUD',
  BUDDER: 'BUDDER',
  BUTANE_HASH_OIL: 'BUTANE_HASH_OIL',
  BUTTER: 'BUTTER',
  CAPSULE: 'CAPSULE',
  CARTRIDGE_510: 'CARTRIDGE_510',
  CHIPS: 'CHIPS',
  CHOCOLATE: 'CHOCOLATE',
  CO2_OIL: 'CO2_OIL',
  COFFEE: 'COFFEE',
  COLD_WATER_HASH: 'COLD_WATER_HASH',
  CONCENTRATE: 'CONCENTRATE',
  COOKIE: 'COOKIE',
  CREAM: 'CREAM',
  CRUMBLE: 'CRUMBLE',
  DART: 'DART',
  DIAMONDS: 'DIAMONDS',
  DISSOLVABLE_POWDER: 'DISSOLVABLE_POWDER',
  FROST: 'FROST',
  GREENHOUSE: 'GREENHOUSE',
  GUMMY: 'GUMMY',
  HARD_CANDY: 'HARD_CANDY',
  HASH: 'HASH',
  HONEY: 'HONEY',
  ICE_CREAM: 'ICE_CREAM',
  INDOOR: 'INDOOR',
  INFUSED_FLOWER: 'INFUSED_FLOWER',
  INFUSED_PRE_ROLLS: 'INFUSED_PRE_ROLLS',
  INHALER: 'INHALER',
  JUICE: 'JUICE',
  KIEF: 'KIEF',
  KIF: 'KIF',
  LEAFLETTES: 'LEAFLETTES',
  LIGHT_DEP: 'LIGHT_DEP',
  LIP_BALM: 'LIP_BALM',
  LIVE_RESIN: 'LIVE_RESIN',
  MARSHMALLOW: 'MARSHMALLOW',
  MINT: 'MINT',
  MIXED: 'MIXED',
  OTHER_BATTERY_TYPES: 'OTHER_BATTERY_TYPES',
  OTHER: 'OTHER',
  OUTDOOR: 'OUTDOOR',
  PACK: 'PACK',
  PATCH: 'PATCH',
  PAX: 'PAX',
  PEN: 'PEN',
  PILL: 'PILL',
  POPCORN: 'POPCORN',
  POPS: 'POPS',
  PRE_GROUND: 'PRE_GROUND',
  PRE_ROLLS: 'PRE_ROLLS',
  PROPRIETARY: 'PROPRIETARY',
  READY_TO_ROLL: 'READY_TO_ROLL',
  ROSIN: 'ROSIN',
  SALVE: 'SALVE',
  SAUCE: 'SAUCE',
  SELTZER: 'SELTZER',
  SHAKE: 'SHAKE',
  SHATTER: 'SHATTER',
  SHOT: 'SHOT',
  SINGLE: 'SINGLE',
  SODA: 'SODA',
  SOLVENTLESS: 'SOLVENTLESS',
  SPRAY: 'SPRAY',
  SUBLINGUAL: 'SUBLINGUAL',
  SUGAR: 'SUGAR',
  SUN_GROWN: 'SUN_GROWN',
  SUPPOSITORY: 'SUPPOSITORY',
  TABLETS: 'TABLETS',
  TAFFY: 'TAFFY',
  TEA: 'TEA',
  THREAD_510: 'THREAD_510',
  TINCTURES: 'TINCTURES',
  TRANSDERMAL: 'TRANSDERMAL',
  TRIM: 'TRIM',
  WATER: 'WATER',
  WAX: 'WAX',
  BAKED_GOOD: 'BAKED_GOOD',
  BATTERY: 'BATTERY',
  BEVERAGE: 'BEVERAGE',
  CANDY: 'CANDY',
  CARTRIDGE: 'CARTRIDGE',
  CRYSTALLINE: 'CRYSTALLINE',
  DISPOSABLE: 'DISPOSABLE',
  WHOLE_FLOWER: 'WHOLE_FLOWER',
  OIL: 'OIL',
  null: null,
} as const;

export type CreateItemDtoInventoryClass =
  (typeof CreateItemDtoInventoryClass)[keyof typeof CreateItemDtoInventoryClass];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateItemDtoInventoryClass = {
  CONCENTRATE: 'CONCENTRATE',
  EDIBLES: 'EDIBLES',
  FLOWER: 'FLOWER',
  PERSONAL_CARE: 'PERSONAL_CARE',
  PRE_ROLL: 'PRE_ROLL',
  VAPE: 'VAPE',
  ACCESSORIES: 'ACCESSORIES',
  null: null,
} as const;

export type CreateItemDtoInventoryType = (typeof CreateItemDtoInventoryType)[keyof typeof CreateItemDtoInventoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateItemDtoInventoryType = {
  CANNABIS: 'CANNABIS',
  NON_CANNABIS: 'NON_CANNABIS',
} as const;

export interface CreateItemDto {
  code: string;
  inventoryType: CreateItemDtoInventoryType;
  inventoryClass?: CreateItemDtoInventoryClass;
  inventoryCategory?: CreateItemDtoInventoryCategory;
  unit?: string | null;
  pricePerUnit: number;
  name: string;
  inventoryUnitOfMeasure: CreateItemDtoInventoryUnitOfMeasure;
  quantityPerUnitOfMeasure: number;
  tags?: CreateItemDtoTagsItem[];
  strainType?: CreateItemDtoStrainType;
  nonSampleItemId?: string | null;
  skuDetailsPdfLink?: string | null;
  janeProductId?: number | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  weightMeasurement: CreateItemDtoWeightMeasurement;
  unitWeight?: number | null;
  unitWeightMeasurement?: CreateItemDtoUnitWeightMeasurement;
  inventoryCategoryTags?: CreateItemDtoInventoryCategoryTagsItem[];
  isArchived: boolean;
  cannabisWeightPerUnit: number;
  cannabisWeightPerUnitMeasurement: CreateItemDtoCannabisWeightPerUnitMeasurement;
  isMedical: boolean;
  defaultTaxExemptionType?: CreateItemDtoDefaultTaxExemptionType;
  description?: string | null;
  availableOnMarketplace?: boolean;
  marketplaceThcValue: number;
  marketplaceThcUnit: string;
  marketplaceSamplesEnabled?: boolean;
}

export interface HealthCheckResponseDto {
  ok: boolean;
}

export interface RolesRemoveFeatureResponseDto {
  success: boolean;
}

export interface UpdateRoleDto {
  name?: string;
  displayName?: string;
  roleType?: string;
  description?: string;
  id: string;
}

export type RoleEntityRoleType = (typeof RoleEntityRoleType)[keyof typeof RoleEntityRoleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleEntityRoleType = {
  NABIS: 'NABIS',
  ORGANIZATION: 'ORGANIZATION',
} as const;

export interface RoleEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  name: string;
  displayName: string;
  description: string | null;
  roleType: RoleEntityRoleType;
}

export interface CreateRoleDto {
  name: string;
  displayName: string;
  roleType: string;
  description: string;
}

export interface RolesRemoveRoleFeatureResponseDto {
  success: boolean;
}

export interface Feature {
  featureCreatedAt: string;
  featureDisplayName: string;
  featureId: string;
  featureName: string;
  featureUpdatedAt: string | null;
}

export interface RolesFindAllRoleFeatureResponseDto {
  features: Feature[];
  roleCreatedAt: string;
  roleDescription: string;
  roleDisplayName: string;
  roleId: string;
  roleName: string;
  roleType: string;
  orgType: string;
  roleUpdatedAt: string | null;
}

export interface RoleFeatureEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  featureId: string;
  roleId: string;
}

export interface CreateRoleFeatureDto {
  roleId: string;
  featureId: string;
}

export interface PatchOrderFeeDto {
  /** Unique identifier for the order fee record to be patched */
  id: string;
  /** Unique identifier for the fee type associated with the order fee */
  feeId?: string;
  /** Unique identifier for the order associated with the fee */
  orderId?: string;
  /** Updated fee price, if applicable */
  feePrice?: number;
  /** Optional notes associated with the fee update */
  feeNotes?: string;
  /** Unique identifier for the user making the update */
  userId: string;
}

export interface CreateOrderFeeDto {
  /** Unique identifier for the fee */
  feeId: string;
  /** The price of the fee */
  feePrice: number;
  /** Unique identifier for the order associated with the fee */
  orderId: string;
  /** Unique identifier for the user associated with this action */
  userId: string;
  /** Optional notes associated with the fee */
  feeNotes?: string;
}

export interface UpsertTableauAnalyticsDto {
  /** If the organization has access to analytics */
  hasTableauAnalytics: boolean;
  /** The email of the licensed user */
  tableauLicensedEmail: string;
}

export interface UpsertSelfCollectedExciseTaxDto {
  /** Indicates whether the organization is self collecting excise tax and remitting to Nabis */
  selfCollectedExciseTax: boolean;
}

export interface UpsertSelfCollecedDto {
  /** The ID of the user toggling the self-collected setting */
  userId: string;
  /** Indicates whether the organization is self-collected */
  selfCollected: boolean;
}

export interface OrganizationSettingsEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  /** Organization associated with organization settings */
  organizationId: string;
  /** Distinguishes organizations that self-collect AR instead of Nabis collecting it */
  selfCollected: boolean;
  /** Distinguishes organizations that self-collect excise taxes and remit collections to Nabis. */
  selfCollectedExciseTax: boolean;
  /** If the organization has access to Tableau analytics */
  hasTableauAnalytics: boolean;
  /** The Tableau viewer license to associate with the organization */
  tableauLicensedEmail: string;
  /** User who created the record */
  createdById: string;
  /** User who updated the record */
  updatedById: string;
}

export interface OrganizationContactUpdateDto {
  /** Phone number for the contact */
  phoneNumber?: string;
  /** Email address for the contact */
  email?: string;
  /** First name of the contact */
  firstName?: string;
  /** Last name of the contact */
  lastName?: string;
  /** Type of org contact. Options: AUTHORIZED_FINANCIAL_CONTACT,AUTHORIZED_TAX_CONTACT */
  contactType?: string;
  /** The ID of the user updating the organization contact record */
  userId: string;
}

export interface OrganizationContactCreateDto {
  /** Phone number for the contact */
  phoneNumber: string;
  /** Email address for the contact */
  email: string;
  /** First name of the contact */
  firstName: string;
  /** Last name of the contact */
  lastName: string;
  /** Type of org contact. Options: AUTHORIZED_FINANCIAL_CONTACT,AUTHORIZED_TAX_CONTACT */
  contactType: string;
  /** ID of the user creating the contact */
  userId: string;
}

export interface OrganizationContactEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  /** Phone number for the contact */
  phoneNumber: string;
  /** Email address for the contact */
  email: string;
  /** First name of the contact */
  firstName: string;
  /** Last name of the contact */
  lastName: string;
  /** Type of org contact  */
  contactType: string;
  /** ID of the user who created the contact */
  createdById: string;
  /** ID of the user who last updated the contact */
  updatedById: string;
  /** ID of the organization this contact belongs to */
  organizationId: string;
}

export interface OrganizationRemittanceInformationUpdateDto {
  /** Indicates if ACH is enabled */
  achEnabled?: boolean;
  /** Indicates if checks are enabled */
  checkEnabled?: boolean;
  /** Bank name */
  bankName?: string;
  /** Full bank account number */
  bankAccountNumber?: string;
  /** Full bank routing number */
  bankRoutingNumber?: string;
  /** Type of bank account. Options: CHECKING,SAVINGS */
  bankAccountType?: string;
  /** Account holder name needed for ACH transactions */
  accountHolderName?: string;
  /** Email for checks */
  checkEmail?: string;
  /** Check addressee */
  checkAddressee?: string;
  /** Street address */
  checkStreet?: string;
  /** Secondary street address (optional) */
  checkStreet2?: string;
  /** City */
  checkCity?: string;
  /** State in the US. Options: AL,AK,AZ,AR,CA,CO,CT,DE,FL,GA,HI,ID,IL,IN,IA,KS,KY,LA,ME,MD,MA,MI,MN,MS,MO,MT,NE,NV,NH,NJ,NM,NY,NC,ND,OH,OK,OR,PA,RI,SC,SD,TN,TX,UT,VT,VA,WA,WV,WI,WY */
  checkState?: string;
  /** ZIP Code */
  checkZipCode?: string;
  /** Excise tax street address */
  exciseTaxStreet?: string;
  /** Excise tax secondary street address */
  exciseTaxStreet2?: string;
  /** Excise tax city */
  exciseTaxCity?: string;
  /** Excise tax state in the US. Options: AL,AK,AZ,AR,CA,CO,CT,DE,FL,GA,HI,ID,IL,IN,IA,KS,KY,LA,ME,MD,MA,MI,MN,MS,MO,MT,NE,NV,NH,NJ,NM,NY,NC,ND,OH,OK,OR,PA,RI,SC,SD,TN,TX,UT,VT,VA,WA,WV,WI,WY */
  exciseTaxState?: string;
  /** Excise tax ZIP Code */
  exciseTaxZipCode?: string;
  /** Excise tax country */
  exciseTaxCountry?: string;
}

export interface OrganizationRemittanceInformationCreateDto {
  /** Indicates if ACH is enabled */
  achEnabled: boolean;
  /** Indicates if accepting checks is enabled */
  checkEnabled: boolean;
  /** Bank name */
  bankName?: string;
  /** Full bank account number */
  bankAccountNumber?: string;
  /** Full bank routing number */
  bankRoutingNumber?: string;
  /** Type of bank account. Options: CHECKING,SAVINGS */
  bankAccountType?: string;
  /** Account holder name needed for ACH transactions */
  accountHolderName?: string;
  /** Email for checks */
  checkEmail: string;
  /** Who checks are written to */
  checkAddressee?: string;
  /** Street address */
  checkStreet?: string;
  /** Secondary street address (optional) */
  checkStreet2?: string;
  /** City */
  checkCity?: string;
  /** State in the United States of America. Options: AL,AK,AZ,AR,CA,CO,CT,DE,FL,GA,HI,ID,IL,IN,IA,KS,KY,LA,ME,MD,MA,MI,MN,MS,MO,MT,NE,NV,NH,NJ,NM,NY,NC,ND,OH,OK,OR,PA,RI,SC,SD,TN,TX,UT,VT,VA,WA,WV,WI,WY */
  checkState?: string;
  /** ZIP Code */
  checkZipCode?: string;
  /** Excise tax street address */
  exciseTaxStreet?: string;
  /** Excise tax secondary street address */
  exciseTaxStreet2?: string;
  /** Excise tax city */
  exciseTaxCity?: string;
  /** Excise tax state in the US. Options: AL,AK,AZ,AR,CA,CO,CT,DE,FL,GA,HI,ID,IL,IN,IA,KS,KY,LA,ME,MD,MA,MI,MN,MS,MO,MT,NE,NV,NH,NJ,NM,NY,NC,ND,OH,OK,OR,PA,RI,SC,SD,TN,TX,UT,VT,VA,WA,WV,WI,WY */
  exciseTaxState?: string;
  /** Excise tax ZIP Code */
  exciseTaxZipCode?: string;
  /** Excise tax country */
  exciseTaxCountry?: string;
}

export interface OrganizationRemittanceInformationEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  /** Who checks are written to */
  checkAddressee: string;
  /** Bank name */
  bankName: string;
  /** Sometimes needed for ACH transactions */
  accountHolderName: string;
  /** Bank account suffix */
  bankAccountSuffix: string;
  /** Bank routing suffix */
  bankRoutingSuffix: string;
  /** Bank account type */
  bankAccountType: string;
  /** Token for retrieving sensitive banking information */
  token: string;
  /** Indicates if ACH is enabled */
  achEnabled: boolean;
  /** Indicates if checks are enabled */
  checkEnabled: boolean;
  /** ID of the associated organization */
  organizationId: string;
  /** Street address */
  checkStreet: string;
  /** Secondary street address */
  checkStreet2: string;
  /** City */
  checkCity: string;
  /** State */
  checkState: string;
  /** ZIP code */
  checkZipCode: string;
  /** Email contact for check-related questions */
  checkEmail: string;
  /** Country */
  checkCountry: string;
  /** Excise tax street address */
  exciseTaxStreet: string;
  /** Excise tax secondary street address */
  exciseTaxStreet2: string;
  /** Excise tax city */
  exciseTaxCity: string;
  /** Excise tax state */
  exciseTaxState: string;
  /** Excise tax ZIP code */
  exciseTaxZipCode: string;
  /** Excise tax country */
  exciseTaxCountry: string;
  /** User who created the record */
  createdById: string;
  /** User who last updated the record */
  updatedById: string;
}

export interface OrderAndTaskDto {
  taskId: string;
  orderId: string;
  error: string;
}

export interface OrdersWithTasksResponseDto {
  orderAndTaskIds: OrderAndTaskDto[];
}

export interface UploadOrdersToOnfleetRequestDto {
  orderIds: string[];
}

export interface FeatureFlagFindOneResponseDto {
  /** Indicates if the feature flag is enabled */
  featureFlagEnabled: boolean;
}

export type FeatureFlag = (typeof FeatureFlag)[keyof typeof FeatureFlag];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FeatureFlag = {
  'email-sku-csv-with-quantities': 'email-sku-csv-with-quantities',
  'v-2-order-form': 'v-2-order-form',
  'internal-transfers-in-ny': 'internal-transfers-in-ny',
  'brand-marketplace-settings': 'brand-marketplace-settings',
  'ai-assistant': 'ai-assistant',
  'ny-drafts': 'ny-drafts',
  'organization-selector': 'organization-selector',
  'ny-must-pay': 'ny-must-pay',
} as const;

export interface UpdateItemBatchDto {
  itemId?: string;
  batchId?: string;
  licenseId?: string;
  infoplusId?: number | null;
  isArchived?: boolean;
}

export interface ItemBatchEntityWithCodes {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  itemId: string;
  batchId: string;
  deletedAt?: string;
  infoplusId?: number;
  licenseId: string;
  createdById?: string;
  updatedById?: string;
  itemCode: string;
  batchCode: string;
}

export interface GetItemBatchesDetailsResponseDto {
  hasNextPage: boolean;
  data: ItemBatchDetailResponseDto[];
}

export type ItemBatchDetailResponseDtoInventoryClass =
  (typeof ItemBatchDetailResponseDtoInventoryClass)[keyof typeof ItemBatchDetailResponseDtoInventoryClass];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemBatchDetailResponseDtoInventoryClass = {
  CONCENTRATE: 'CONCENTRATE',
  EDIBLES: 'EDIBLES',
  FLOWER: 'FLOWER',
  PERSONAL_CARE: 'PERSONAL_CARE',
  PRE_ROLL: 'PRE_ROLL',
  VAPE: 'VAPE',
  ACCESSORIES: 'ACCESSORIES',
} as const;

export type ItemBatchDetailResponseDtoCannabisWeightPerUnitMeasurement =
  (typeof ItemBatchDetailResponseDtoCannabisWeightPerUnitMeasurement)[keyof typeof ItemBatchDetailResponseDtoCannabisWeightPerUnitMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemBatchDetailResponseDtoCannabisWeightPerUnitMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
} as const;

export type ItemBatchDetailResponseDtoItemInventoryType =
  (typeof ItemBatchDetailResponseDtoItemInventoryType)[keyof typeof ItemBatchDetailResponseDtoItemInventoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemBatchDetailResponseDtoItemInventoryType = {
  CANNABIS: 'CANNABIS',
  NON_CANNABIS: 'NON_CANNABIS',
} as const;

export interface ItemBatchDetailResponseDto {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  itemId: string;
  batchId: string;
  deletedAt?: string;
  infoplusId?: number;
  licenseId: string;
  createdById?: string;
  updatedById?: string;
  itemCode: string;
  itemName: string;
  itemInventoryType: ItemBatchDetailResponseDtoItemInventoryType;
  batchCode: string;
  batchExpirationDate: string;
  batchLicenseNickname: string;
  licenseNickname: string;
  calculatedAvailableQuantity: number;
  unallocatableQuantity: number;
  itemPricePerUnit: number;
  calculatedThcPercentage: number;
  calculatedThcWeight: number;
  cannabisWeightPerUnit: number;
  cannabisWeightPerUnitMeasurement: ItemBatchDetailResponseDtoCannabisWeightPerUnitMeasurement;
  inventoryClass: ItemBatchDetailResponseDtoInventoryClass;
  potencyTax: number;
  itemIsMedical: boolean;
  applicableTaxes: ApplicableTaxes;
  marketplaceThcValue: number;
  marketplaceThcUnit: string;
}

export interface EnrichedItemBatchResponse {
  item: EnrichedItemEntity;
  itemBatch: ItemBatchEntity;
  batch: BatchEntity;
  calculatedAvailableQuantity: number;
}

export interface GetItemBatchesResponseDto {
  hasNextPage: boolean;
  data: EnrichedItemBatchResponse[];
}

export interface CreateItemBatchDto {
  itemId: string;
  batchId: string;
  licenseId: string;
  infoplusId?: number | null;
  isArchived: boolean;
}

export interface GetManyInventoryDto {
  itemBatchIds: string[];
}

export interface InventoryApiDataResponseDto {
  id: string;
  skuBatchId: string;
  skuId: string;
  warehouseId: string;
  infoplusId: number;
  createdAt: string;
  updatedAt: string;
  quantityPerUnitOfMeasure: number;
  calculatedAvailableQuantity: number;
  calculatedTotalQuantity: number;
  weeksOnHand: number;
  trailing4WeeksSalesAvg: number;
  avgWeeklyVolume: number;
  availableQuantity: number;
  damagedQuantity: number;
  inFulfillmentProcessQuantity: number;
  onHandQuantity: number;
  openOrderQuantity: number;
  openPoQuantity: number;
  orderableQuantity: number;
  unallocatableQuantity: number;
  unavailableQuantity: number;
  packedQuantity: number;
}

export interface CreateInventoryDto {
  itemBatchId: string;
  itemId: string;
  warehouseId: string;
  quantityPerUnitOfMeasure: number;
}

export interface DateDetail {
  isAvailable: boolean;
  date: string;
  month: string;
  year: string;
}

export type DatePickerResponseDtoFirstAvailableDate = DateDetail | null;

export interface DatePickerResponseDto {
  allowAllDates: boolean;
  dates: DateDetail[];
  firstAvailableDate?: DatePickerResponseDtoFirstAvailableDate;
}

export type CreateLicensedLocationContactPreferredContactMethod =
  (typeof CreateLicensedLocationContactPreferredContactMethod)[keyof typeof CreateLicensedLocationContactPreferredContactMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateLicensedLocationContactPreferredContactMethod = {
  PHONE: 'PHONE',
  EMAIL: 'EMAIL',
  TEXT: 'TEXT',
} as const;

export type CreateLicensedLocationContactContactType =
  (typeof CreateLicensedLocationContactContactType)[keyof typeof CreateLicensedLocationContactContactType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateLicensedLocationContactContactType = {
  ORDER: 'ORDER',
} as const;

export interface CreateLicensedLocationContact {
  firstName: string;
  lastName: string;
  title?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  contactType: CreateLicensedLocationContactContactType;
  preferredContactMethod: CreateLicensedLocationContactPreferredContactMethod;
  licensedLocationId: string;
}

export type UpdateLicenseDtoType = (typeof UpdateLicenseDtoType)[keyof typeof UpdateLicenseDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateLicenseDtoType = {
  RETAILER: 'RETAILER',
  RETAILER_NONSTOREFRONT: 'RETAILER_NONSTOREFRONT',
  DISTRIBUTOR: 'DISTRIBUTOR',
  DISTRIBUTOR_TRANSPORT_ONLY: 'DISTRIBUTOR_TRANSPORT_ONLY',
  MICROBUSINESS: 'MICROBUSINESS',
  TESTING_LABORATORY: 'TESTING_LABORATORY',
  TESTING: 'TESTING',
  CANNABIS_EVENTS: 'CANNABIS_EVENTS',
  MANUFACTURER: 'MANUFACTURER',
  CULTIVATOR: 'CULTIVATOR',
} as const;

export type UpdateLicenseDtoCategory = (typeof UpdateLicenseDtoCategory)[keyof typeof UpdateLicenseDtoCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateLicenseDtoCategory = {
  ADULT_USE: 'ADULT_USE',
  MEDICINAL: 'MEDICINAL',
  COMBINED: 'COMBINED',
} as const;

export interface UpdateLicenseDto {
  nickname?: string;
  category?: UpdateLicenseDtoCategory;
  type?: UpdateLicenseDtoType;
  licenseNumber?: string;
  legalEntityName?: string;
  issuanceDate?: string | null;
  expirationDate?: string | null;
  contactName?: string;
  contactPhone?: string;
  adminNotes?: string | null;
  contactEmail?: string | null;
  organizationId?: string | null;
  licensedLocationId?: string | null;
}

export interface GetLicensesResponseDto {
  hasNextPage: boolean;
  data: LicenseEntity[];
}

export type UpdateWarehouseDtoState = (typeof UpdateWarehouseDtoState)[keyof typeof UpdateWarehouseDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateWarehouseDtoState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface UpdateWarehouseDto {
  licenseId?: string;
  infoplusId?: number;
  region?: string;
  isProduction?: boolean;
  name?: string;
  isInUseByOps?: boolean;
  address1?: string;
  address2?: string | null;
  city?: string;
  state?: UpdateWarehouseDtoState;
  zip?: string;
  lat?: number | null;
  lng?: number | null;
}

export interface WarehouseFindManyResponseDto {
  hasNextPage: boolean;
  data: WarehouseEntity[];
}

export type CreateWarehouseDtoState = (typeof CreateWarehouseDtoState)[keyof typeof CreateWarehouseDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateWarehouseDtoState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface CreateWarehouseDto {
  licenseId: string;
  infoplusId: number;
  region: string;
  isProduction: boolean;
  name: string;
  isInUseByOps: boolean;
  address1: string;
  address2?: string | null;
  city: string;
  state: CreateWarehouseDtoState;
  zip: string;
  lat?: number | null;
  lng?: number | null;
}

export type ShipmentWithDetailsOrganizationState =
  (typeof ShipmentWithDetailsOrganizationState)[keyof typeof ShipmentWithDetailsOrganizationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentWithDetailsOrganizationState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export type ShipmentWithDetailsOrderInventoryStatus =
  (typeof ShipmentWithDetailsOrderInventoryStatus)[keyof typeof ShipmentWithDetailsOrderInventoryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentWithDetailsOrderInventoryStatus = {
  ORDERED: 'ORDERED',
  FULFILLED: 'FULFILLED',
  PACKED: 'PACKED',
} as const;

export type ShipmentWithDetailsOrderStatus =
  (typeof ShipmentWithDetailsOrderStatus)[keyof typeof ShipmentWithDetailsOrderStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentWithDetailsOrderStatus = {
  UNSCHEDULED: 'UNSCHEDULED',
  SCHEDULED: 'SCHEDULED',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSFERRING: 'TRANSFERRING',
  DELIVERED: 'DELIVERED',
  DELIVERED_WITH_EDITS: 'DELIVERED_WITH_EDITS',
  DELAYED: 'DELAYED',
  CANCELED: 'CANCELED',
  REJECTED: 'REJECTED',
  ATTEMPTED: 'ATTEMPTED',
} as const;

export type ShipmentWithDetailsOrderAction =
  (typeof ShipmentWithDetailsOrderAction)[keyof typeof ShipmentWithDetailsOrderAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentWithDetailsOrderAction = {
  DELIVERY_TO_RETAILER: 'DELIVERY_TO_RETAILER',
  DELIVERY_TO_BRAND: 'DELIVERY_TO_BRAND',
  DROPOFF_TO_NABIS: 'DROPOFF_TO_NABIS',
  PICKUP_FROM_BRAND: 'PICKUP_FROM_BRAND',
  PICKUP_FROM_NABIS: 'PICKUP_FROM_NABIS',
  RETURN_FROM_RETAILER: 'RETURN_FROM_RETAILER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
} as const;

export type ShipmentWithDetailsStatus = (typeof ShipmentWithDetailsStatus)[keyof typeof ShipmentWithDetailsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentWithDetailsStatus = {
  CREATED: 'CREATED',
  TRANSFER_CANCELED: 'TRANSFER_CANCELED',
  TRANSFER_COMPLETE: 'TRANSFER_COMPLETE',
  TRANSFER_DELAYED: 'TRANSFER_DELAYED',
  TRANSFERRING: 'TRANSFERRING',
} as const;

export type ShipmentWithDetailsShipmentType =
  (typeof ShipmentWithDetailsShipmentType)[keyof typeof ShipmentWithDetailsShipmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentWithDetailsShipmentType = {
  RETURN: 'RETURN',
  DEFAULT: 'DEFAULT',
} as const;

export interface ShipmentWithDetails {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  originLicensedLocationId: string;
  destinationLicensedLocationId: string;
  stagingAreaId: string;
  shipmentType: ShipmentWithDetailsShipmentType;
  status: ShipmentWithDetailsStatus;
  unloaderId: string;
  loaderId: string;
  vehicleId: string;
  driverId: string;
  previousShipmentId: string;
  nextShipmentId: string;
  receiveDate: string;
  shipmentIndex: number;
  isPrinted: boolean;
  isStaged: boolean;
  isPicked: boolean;
  isShipped: boolean;
  orderAction: ShipmentWithDetailsOrderAction;
  orderNumber: number;
  orderStatus: ShipmentWithDetailsOrderStatus;
  orderInventoryStatus: ShipmentWithDetailsOrderInventoryStatus;
  organizationId: string;
  organizationName: string;
  organizationState: ShipmentWithDetailsOrganizationState;
  licensedLocationId: string;
  licensedLocationName: string;
  destinationLicensedLocationName: string;
  originLicensedLocationName: string;
  infoplusOrderId: number | null;
  infoplusAsnId: number | null;
  driverFirstName: string | null;
  driverLastName: string | null;
  stagingAreaName: string | null;
  vehicleName: string | null;
}

export type CreateShipmentDtoStatus = (typeof CreateShipmentDtoStatus)[keyof typeof CreateShipmentDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateShipmentDtoStatus = {
  CREATED: 'CREATED',
  TRANSFER_CANCELED: 'TRANSFER_CANCELED',
  TRANSFER_COMPLETE: 'TRANSFER_COMPLETE',
  TRANSFER_DELAYED: 'TRANSFER_DELAYED',
  TRANSFERRING: 'TRANSFERRING',
} as const;

export type CreateShipmentDtoShipmentType =
  (typeof CreateShipmentDtoShipmentType)[keyof typeof CreateShipmentDtoShipmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateShipmentDtoShipmentType = {
  RETURN: 'RETURN',
  DEFAULT: 'DEFAULT',
} as const;

export interface CreateShipmentDto {
  orderId: string;
  originLicensedLocationId: string;
  destinationLicensedLocationId: string;
  stagingAreaId: string;
  shipmentType: CreateShipmentDtoShipmentType;
  status: CreateShipmentDtoStatus;
  isUnloaded: boolean;
  unloaderId: string;
  isLoaded: boolean;
  loaderId: string;
  isShipped: boolean;
  isPrinted: boolean;
  vehicleId: string;
  driverId: string;
  previousShipmentId: string;
  nextShipmentId: string;
  receiveDate: string;
  shipmentIndex: number;
}

export type ShipmentEntityStatus = (typeof ShipmentEntityStatus)[keyof typeof ShipmentEntityStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentEntityStatus = {
  CREATED: 'CREATED',
  TRANSFER_CANCELED: 'TRANSFER_CANCELED',
  TRANSFER_COMPLETE: 'TRANSFER_COMPLETE',
  TRANSFER_DELAYED: 'TRANSFER_DELAYED',
  TRANSFERRING: 'TRANSFERRING',
} as const;

export type ShipmentEntityShipmentType = (typeof ShipmentEntityShipmentType)[keyof typeof ShipmentEntityShipmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentEntityShipmentType = {
  RETURN: 'RETURN',
  DEFAULT: 'DEFAULT',
} as const;

export interface ShipmentEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  originLicensedLocationId: string;
  destinationLicensedLocationId: string;
  stagingAreaId: string;
  shipmentType: ShipmentEntityShipmentType;
  status: ShipmentEntityStatus;
  unloaderId: string;
  loaderId: string;
  vehicleId: string;
  driverId: string;
  previousShipmentId: string;
  nextShipmentId: string;
  receiveDate: string;
  shipmentIndex: number;
  isPrinted: boolean;
  isStaged: boolean;
  isPicked: boolean;
  isShipped: boolean;
}

export type UpdateShipmentDtoStatus = (typeof UpdateShipmentDtoStatus)[keyof typeof UpdateShipmentDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateShipmentDtoStatus = {
  CREATED: 'CREATED',
  TRANSFER_CANCELED: 'TRANSFER_CANCELED',
  TRANSFER_COMPLETE: 'TRANSFER_COMPLETE',
  TRANSFER_DELAYED: 'TRANSFER_DELAYED',
  TRANSFERRING: 'TRANSFERRING',
} as const;

export interface UpdateShipmentDto {
  stagingAreaId?: string | null;
  status?: UpdateShipmentDtoStatus;
  unloaderId?: string | null;
  loaderId?: string | null;
  vehicleId?: string | null;
  driverId?: string | null;
  receiveDate?: string;
  shipmentIndex?: number;
  isPrinted?: boolean;
  isStaged?: boolean;
}

export type UpdateDriverDtoLicenseIssuingState =
  (typeof UpdateDriverDtoLicenseIssuingState)[keyof typeof UpdateDriverDtoLicenseIssuingState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDriverDtoLicenseIssuingState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export type UpdateDriverDtoOnfleetWorkerId = { [key: string]: any };

export interface UpdateDriverDto {
  driversLicense: string;
  onfleetWorkerId?: UpdateDriverDtoOnfleetWorkerId;
  id: string;
  licenseIssuingState?: UpdateDriverDtoLicenseIssuingState;
  driverAppPassword?: string | null;
}

export interface GetAllDriversResponse {
  id: string;
  userId: string;
  driversLicense: string;
  licenseIssuingState: string | null;
  onfleetWorkerId: string | null;
  deletedAt: string | null;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface GetDriversResponseDto {
  hasNextPage: boolean;
  data: GetAllDriversResponse[];
}

export type DriverEntityLicenseIssuingState =
  (typeof DriverEntityLicenseIssuingState)[keyof typeof DriverEntityLicenseIssuingState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DriverEntityLicenseIssuingState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface DriverEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  driversLicense: string;
  userId: string;
  onfleetWorkerId?: string | null;
  deletedAt: string | null;
  licenseIssuingState: DriverEntityLicenseIssuingState;
  driverAppPassword: string | null;
}

export type CreateDriverDtoLicenseIssuingState =
  (typeof CreateDriverDtoLicenseIssuingState)[keyof typeof CreateDriverDtoLicenseIssuingState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDriverDtoLicenseIssuingState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface CreateDriverDto {
  driversLicense: string;
  email: string;
  licenseIssuingState: CreateDriverDtoLicenseIssuingState;
  driverAppPassword?: string;
}

export interface UpdateVehicleDto {
  licensePlate?: string;
  name?: string;
  make?: string;
  model?: string;
  year?: number;
  id: string;
}

export interface GetVehiclesResponseDto {
  hasNextPage: boolean;
  data: VehicleEntity[];
}

export interface CreateVehicleDto {
  licensePlate: string;
  name?: string;
  make?: string;
  model?: string;
  year?: number;
}

export interface RetailerContactDto {
  firstName: string;
  lastName: string;
  title: string;
  phoneNumber: string;
  email: string;
  contactType: string;
  preferredContactMethod: string;
  id: string;
}

export interface CreateOrdersResponseDto {
  ids: string[];
}

export interface CreateOrdersDto {
  orders: CreateOrderWithOrgIdDto[];
}

/**
 * Indicates source of the order, e.g., Marketplace, Order Form, Sales Order Form
 */
export type CreateOrderWithOrgIdDtoSource =
  (typeof CreateOrderWithOrgIdDtoSource)[keyof typeof CreateOrderWithOrgIdDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderWithOrgIdDtoSource = {
  MARKETPLACE_ORDER: 'MARKETPLACE_ORDER',
  BRAND_ORDER: 'BRAND_ORDER',
  SALES_ORDER: 'SALES_ORDER',
} as const;

export type CreateOrderWithOrgIdDtoPaymentMethod =
  (typeof CreateOrderWithOrgIdDtoPaymentMethod)[keyof typeof CreateOrderWithOrgIdDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderWithOrgIdDtoPaymentMethod = {
  CASH: 'CASH',
  CHECK: 'CHECK',
  EFT: 'EFT',
  OTHER: 'OTHER',
  null: null,
} as const;

/**
 * Only applies to `Delivery to Retailer` orders
 */
export type CreateOrderWithOrgIdDtoPaymentTerms =
  (typeof CreateOrderWithOrgIdDtoPaymentTerms)[keyof typeof CreateOrderWithOrgIdDtoPaymentTerms];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderWithOrgIdDtoPaymentTerms = {
  COD: 'COD',
  NET_7: 'NET_7',
  NET_10: 'NET_10',
  NET_15: 'NET_15',
  NET_30: 'NET_30',
} as const;

export type CreateOrderWithOrgIdDtoAction =
  (typeof CreateOrderWithOrgIdDtoAction)[keyof typeof CreateOrderWithOrgIdDtoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderWithOrgIdDtoAction = {
  DELIVERY_TO_RETAILER: 'DELIVERY_TO_RETAILER',
  DELIVERY_TO_BRAND: 'DELIVERY_TO_BRAND',
  DROPOFF_TO_NABIS: 'DROPOFF_TO_NABIS',
  PICKUP_FROM_BRAND: 'PICKUP_FROM_BRAND',
  PICKUP_FROM_NABIS: 'PICKUP_FROM_NABIS',
  RETURN_FROM_RETAILER: 'RETURN_FROM_RETAILER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
} as const;

export type CreateOrderWithOrgIdDtoTimezone =
  (typeof CreateOrderWithOrgIdDtoTimezone)[keyof typeof CreateOrderWithOrgIdDtoTimezone];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderWithOrgIdDtoTimezone = {
  'America/Anchorage': 'America/Anchorage',
  'America/Phoenix': 'America/Phoenix',
  'America/Chicago': 'America/Chicago',
  'America/New_York': 'America/New_York',
  'Pacific/Honolulu': 'Pacific/Honolulu',
  'America/Denver': 'America/Denver',
  'America/Los_Angeles': 'America/Los_Angeles',
  'Etc/UTC': 'Etc/UTC',
  null: null,
} as const;

export interface CreateOrderWithOrgIdDto {
  irn: string | null;
  deliveryDate: string;
  deliveryInstruction?: string;
  assignedSalesRepId?: string | null;
  timezone?: CreateOrderWithOrgIdDtoTimezone;
  action: CreateOrderWithOrgIdDtoAction;
  licensedLocationId: string;
  orderLicensedLocationContactIds: string[];
  orderRetailerContactIds?: string[];
  orderCreditMemoIds: string[];
  /** Only applies to `Delivery to Retailer` orders */
  paymentTerms?: CreateOrderWithOrgIdDtoPaymentTerms;
  paymentMethod?: CreateOrderWithOrgIdDtoPaymentMethod;
  licenseId: string;
  notes: string | null;
  lineItems: CreateOrderLineItemDto[];
  /** Source warehouse ID */
  warehouseId?: string;
  /** Require overdue balances prior to delivery */
  mustPayPriorBalance?: boolean;
  /** Indicates source of the order, e.g., Marketplace, Order Form, Sales Order Form */
  source?: CreateOrderWithOrgIdDtoSource;
  organizationId: string;
}

export interface OrderFullViewResponseDto {
  data: FullOrderFetchResponseDto[];
  count: number;
  total: number;
  page: number;
  pageCount: number;
}

export type FullOrderViewEntityWarehouse = WarehouseEntity | null;

export type FullOrderViewEntityStagingArea = StagingAreaEntity | null;

export type FullOrderViewEntityAssignee = UserEntity | null;

export type FullOrderViewEntityCreator = UserEntity | null;

export type FullOrderViewEntityPaymentTerms =
  (typeof FullOrderViewEntityPaymentTerms)[keyof typeof FullOrderViewEntityPaymentTerms];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullOrderViewEntityPaymentTerms = {
  COD: 'COD',
  NET_7: 'NET_7',
  NET_10: 'NET_10',
  NET_15: 'NET_15',
  NET_30: 'NET_30',
} as const;

export type FullOrderViewEntityFulfillability =
  (typeof FullOrderViewEntityFulfillability)[keyof typeof FullOrderViewEntityFulfillability];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullOrderViewEntityFulfillability = {
  FULFILLABLE: 'FULFILLABLE',
  PARTIALLY_FULFILLABLE: 'PARTIALLY_FULFILLABLE',
  NOT_FULFILLABLE: 'NOT_FULFILLABLE',
  MANUAL: 'MANUAL',
  null: null,
} as const;

export type FullOrderViewEntityReferrer =
  (typeof FullOrderViewEntityReferrer)[keyof typeof FullOrderViewEntityReferrer];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullOrderViewEntityReferrer = {
  BRAND: 'BRAND',
  RETAILER: 'RETAILER',
  SALES: 'SALES',
  MANUFACTURER: 'MANUFACTURER',
} as const;

export type FullOrderViewEntityAsnInventoryStatus =
  (typeof FullOrderViewEntityAsnInventoryStatus)[keyof typeof FullOrderViewEntityAsnInventoryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullOrderViewEntityAsnInventoryStatus = {
  ORDERED: 'ORDERED',
  SHELVED: 'SHELVED',
  null: null,
} as const;

export type FullOrderViewEntityOrderInventoryStatus =
  (typeof FullOrderViewEntityOrderInventoryStatus)[keyof typeof FullOrderViewEntityOrderInventoryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullOrderViewEntityOrderInventoryStatus = {
  ORDERED: 'ORDERED',
  FULFILLED: 'FULFILLED',
  PACKED: 'PACKED',
  null: null,
} as const;

export type FullOrderViewEntityAction = (typeof FullOrderViewEntityAction)[keyof typeof FullOrderViewEntityAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullOrderViewEntityAction = {
  DELIVERY_TO_RETAILER: 'DELIVERY_TO_RETAILER',
  DELIVERY_TO_BRAND: 'DELIVERY_TO_BRAND',
  DROPOFF_TO_NABIS: 'DROPOFF_TO_NABIS',
  PICKUP_FROM_BRAND: 'PICKUP_FROM_BRAND',
  PICKUP_FROM_NABIS: 'PICKUP_FROM_NABIS',
  RETURN_FROM_RETAILER: 'RETURN_FROM_RETAILER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
} as const;

export type FullOrderViewEntitySource = (typeof FullOrderViewEntitySource)[keyof typeof FullOrderViewEntitySource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullOrderViewEntitySource = {
  MARKETPLACE_ORDER: 'MARKETPLACE_ORDER',
  BRAND_ORDER: 'BRAND_ORDER',
  SALES_ORDER: 'SALES_ORDER',
} as const;

export type FullOrderViewEntityStatus = (typeof FullOrderViewEntityStatus)[keyof typeof FullOrderViewEntityStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FullOrderViewEntityStatus = {
  UNSCHEDULED: 'UNSCHEDULED',
  SCHEDULED: 'SCHEDULED',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSFERRING: 'TRANSFERRING',
  DELIVERED: 'DELIVERED',
  DELIVERED_WITH_EDITS: 'DELIVERED_WITH_EDITS',
  DELAYED: 'DELAYED',
  CANCELED: 'CANCELED',
  REJECTED: 'REJECTED',
  ATTEMPTED: 'ATTEMPTED',
} as const;

export interface FullOrderViewEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  name: string | null;
  organizationId: string;
  orderNumber: number;
  licensedLocationId: string;
  licenseId: string;
  warehouseId: string;
  creatorId: string;
  updatedById: string;
  status: FullOrderViewEntityStatus;
  source: FullOrderViewEntitySource;
  action: FullOrderViewEntityAction;
  irn: string | null;
  assigneeId: string | null;
  isIntaken: boolean;
  isOuttaken: boolean;
  isExcluded: boolean;
  isEdited: boolean;
  infoplusOrderId: number | null;
  infoplusAsnId: number | null;
  infoplusReturnAsnId: number | null;
  orderInventoryStatus: FullOrderViewEntityOrderInventoryStatus;
  asnInventoryStatus: FullOrderViewEntityAsnInventoryStatus;
  isReceived: boolean;
  referrer: FullOrderViewEntityReferrer;
  isSampleDemo: boolean;
  pickers: string[] | null;
  fulfillability: FullOrderViewEntityFulfillability;
  isStaged: boolean;
  isPrinted: boolean;
  stagingAreaId: string | null;
  manufacturerOrganizationId: string;
  processingAt: string | null;
  isPending: boolean;
  deletedAt: string | null;
  parentId: string | null;
  paymentTerms: FullOrderViewEntityPaymentTerms;
  deliveryDate: string;
  licensedLocationName: string | null;
  paymentStatus: string | null;
  total: number | null;
  driverName: string | null;
  vehicleName: string | null;
  orderProperties: OrderEntity;
  creator: FullOrderViewEntityCreator;
  assignee: FullOrderViewEntityAssignee;
  stagingArea: FullOrderViewEntityStagingArea;
  warehouse: FullOrderViewEntityWarehouse;
  organization: OrganizationEntity;
  license: LicenseEntity;
  licensedLocation: LicensedLocationEntity;
  orderLineItem: OrderLineItemEntity[];
  orderConfirmation: OrderConfirmationEntity;
  orderDelivery: OrderDeliveryEntity;
  orderNotes: OrderNotesEntity;
  orderOnfleet: OrderOnfleetEntity;
  orderFinancial: OrderFinancialEntity;
  orderFiles: OrderFilesEntity;
  orderContacts: OrderContactEntity[];
  orderCreditMemos: OrderCreditMemoEntity[];
  creditMemoAmount: number;
  orderLineItemDiscountAmount: number;
  invoice: InvoiceEntity[];
  serviceMessages: GetOrderMessageResponseDto[];
}

export type OrderLineItemEntitySampleType =
  (typeof OrderLineItemEntitySampleType)[keyof typeof OrderLineItemEntitySampleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderLineItemEntitySampleType = {
  TRADE_SAMPLE: 'TRADE_SAMPLE',
  DONATION: 'DONATION',
  DISPLAY_SAMPLE: 'DISPLAY_SAMPLE',
  null: null,
} as const;

export interface OrderLineItemEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  quantity: number;
  pricePerUnit: number;
  taxInclusivePrice?: number;
  itemPricePerUnit: number;
  code: string;
  name: string;
  unit: string;
  orderId: string;
  createdById: string | null;
  updatedById: string | null;
  itemId: string;
  isSample: boolean;
  oversold: boolean;
  itemBatchId: string;
  batchId: string;
  discount: number;
  taggedAt: number;
  taggerId: string;
  overrideQuantityPerUnitOfMeasure: boolean;
  lineItemManifestNotes: string | null;
  sampleType: OrderLineItemEntitySampleType;
  taxAmount: number;
  itemVolumePricingId: string;
  sequenceNumber: number;
  appliedTaxId: string;
}

export interface GetManyFullOrderViewEntityResponseDto {
  data: FullOrderViewEntity[];
  count: number;
  total: number;
  page: number;
  pageCount: number;
}

export type ChangelogEntryDtoViewableByRoleNamesItem =
  (typeof ChangelogEntryDtoViewableByRoleNamesItem)[keyof typeof ChangelogEntryDtoViewableByRoleNamesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangelogEntryDtoViewableByRoleNamesItem = {
  NABIS_DASHBOARD_ADMIN: 'NABIS_DASHBOARD_ADMIN',
  NABIS_ADMIN: 'NABIS_ADMIN',
  ORG_ADMIN: 'ORG_ADMIN',
  AYRLOOM_ADMIN: 'AYRLOOM_ADMIN',
  TABLEAU_ANALYTICS_USER: 'TABLEAU_ANALYTICS_USER',
  ACCOUNTING_USER: 'ACCOUNTING_USER',
  CAN_MANAGE_USER: 'CAN_MANAGE_USER',
} as const;

export type ChangelogEntryDtoActionInternal =
  (typeof ChangelogEntryDtoActionInternal)[keyof typeof ChangelogEntryDtoActionInternal];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangelogEntryDtoActionInternal = {
  INSERT: 'INSERT',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;

export interface ChangelogEntryDto {
  description: string;
  humanReadableUpdator: string;
  updatedById: string;
  humanReadableOldValue: string;
  humanReadableNewValue: string;
  updatedAt: string;
  actionInternal: ChangelogEntryDtoActionInternal;
  resourceId: string;
  resourceType: string;
  columnName: string;
  viewableByRoleNames: ChangelogEntryDtoViewableByRoleNamesItem[];
}

export interface ChangelogResponseDto {
  data: ChangelogEntryDto[];
}

export interface DeleteOrderResponseDto {
  id: string;
  orderNumber: number;
}

export interface PatchOrderResponseDto {
  id: string;
  orderNumber: number;
}

export type PatchOrderDtoPaymentStatus = (typeof PatchOrderDtoPaymentStatus)[keyof typeof PatchOrderDtoPaymentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchOrderDtoPaymentStatus = {
  UNPAID: 'UNPAID',
  COD_PAID: 'COD_PAID',
  NET_TERMS_PAID: 'NET_TERMS_PAID',
  REMITTED: 'REMITTED',
  SELF_COLLECTED: 'SELF_COLLECTED',
  PROCESSING: 'PROCESSING',
  PAYMENT_SENT: 'PAYMENT_SENT',
  WRITE_OFF: 'WRITE_OFF',
  THIRD_PARTY_COLLECTIONS: 'THIRD_PARTY_COLLECTIONS',
  PARTIAL_PAID: 'PARTIAL_PAID',
  DRIVER_PROCESSING: 'DRIVER_PROCESSING',
  null: null,
} as const;

export type PatchOrderDtoPaymentMethod = (typeof PatchOrderDtoPaymentMethod)[keyof typeof PatchOrderDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchOrderDtoPaymentMethod = {
  CASH: 'CASH',
  CHECK: 'CHECK',
  EFT: 'EFT',
  OTHER: 'OTHER',
  null: null,
} as const;

export type PatchOrderDtoIssueReason = (typeof PatchOrderDtoIssueReason)[keyof typeof PatchOrderDtoIssueReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchOrderDtoIssueReason = {
  NABIS_MISPACK: 'NABIS_MISPACK',
  PARTIAL_REJECTION_OF_CORRECT_ITEMS: 'PARTIAL_REJECTION_OF_CORRECT_ITEMS',
  BRAND_MANUFACTURING_ERROR: 'BRAND_MANUFACTURING_ERROR',
  RETAILER_MISCOMMUNICATION: 'RETAILER_MISCOMMUNICATION',
  BRAND_MISCOMMUNICATION: 'BRAND_MISCOMMUNICATION',
  BRAND_REQUESTED_CHANGE: 'BRAND_REQUESTED_CHANGE',
  BRAND_FAULT: 'BRAND_FAULT',
  RETAILER_PAYMENT_NOT_READY: 'RETAILER_PAYMENT_NOT_READY',
  RETAILER_WILL_NOT_ACCEPT_PAYMENT_TERMS: 'RETAILER_WILL_NOT_ACCEPT_PAYMENT_TERMS',
  NABIS_INVENTORY_SHORTAGE: 'NABIS_INVENTORY_SHORTAGE',
  NABIS_MISSED_TIME_WINDOW: 'NABIS_MISSED_TIME_WINDOW',
  NABIS_SCHEDULING_ERROR: 'NABIS_SCHEDULING_ERROR',
  NABIS_COA_ERROR: 'NABIS_COA_ERROR',
  NABIS_LICENSE_ERROR: 'NABIS_LICENSE_ERROR',
  NABIS_ADDRESS_ERROR: 'NABIS_ADDRESS_ERROR',
  RETAILER_REQUESTS_DELAY: 'RETAILER_REQUESTS_DELAY',
  BRAND_REQUESTS_DELAY: 'BRAND_REQUESTS_DELAY',
  PENDING_INVENTORY_RESOLUTION: 'PENDING_INVENTORY_RESOLUTION',
  NABIS_CAPACITY_DELAY: 'NABIS_CAPACITY_DELAY',
  null: null,
} as const;

export type PatchOrderDtoStatus = (typeof PatchOrderDtoStatus)[keyof typeof PatchOrderDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchOrderDtoStatus = {
  UNSCHEDULED: 'UNSCHEDULED',
  SCHEDULED: 'SCHEDULED',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSFERRING: 'TRANSFERRING',
  DELIVERED: 'DELIVERED',
  DELIVERED_WITH_EDITS: 'DELIVERED_WITH_EDITS',
  DELAYED: 'DELAYED',
  CANCELED: 'CANCELED',
  REJECTED: 'REJECTED',
  ATTEMPTED: 'ATTEMPTED',
  null: null,
} as const;

export interface RejectedLineItemDto {
  lineItemId: string;
  rejectedQuantity: number;
}

export interface PatchOrderDto {
  assigneeId?: string | null;
  status?: PatchOrderDtoStatus;
  rejectedLineItems?: RejectedLineItemDto[] | null;
  issueReason?: PatchOrderDtoIssueReason;
  paymentMethod?: PatchOrderDtoPaymentMethod;
  paymentStatus?: PatchOrderDtoPaymentStatus;
  orderLicensedLocationContactIds?: string[] | null;
  orderRetailerContactIds?: string[] | null;
  orderCreditMemoIds?: string[] | null;
  collected?: number | null;
  driverId?: string | null;
  vehicleId?: string | null;
  stagingAreaId?: string | null;
  isPrinted?: boolean | null;
  isStaged?: boolean | null;
  isReceived?: boolean | null;
  isOuttaken?: boolean | null;
  isIntaken?: boolean | null;
  isExcluded?: boolean | null;
  pickers?: string[] | null;
  /** New delivery notes for an order */
  notes?: string;
  /** New internal notes for an order */
  internalNotes?: string;
  /** New brand manifest notes for an order */
  brandManifestNotes?: string;
  /** New nabis manifest notes for an order */
  nabisManifestNotes?: string;
  /** New admin notes for an order */
  adminNotes?: string;
  /** when rejecting an order if this property is true a rejection fee is applied */
  applyRejectionFee?: boolean | null;
}

export interface UpdateOrderResponseDto {
  id: string;
  orderNumber: number;
}

/**
 * Indicates source of the order, e.g., Marketplace, Order Form, Sales Order Form
 */
export type UpdateOrderDtoSource = (typeof UpdateOrderDtoSource)[keyof typeof UpdateOrderDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrderDtoSource = {
  MARKETPLACE_ORDER: 'MARKETPLACE_ORDER',
  BRAND_ORDER: 'BRAND_ORDER',
  SALES_ORDER: 'SALES_ORDER',
} as const;

export type UpdateOrderDtoPaymentMethod =
  (typeof UpdateOrderDtoPaymentMethod)[keyof typeof UpdateOrderDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrderDtoPaymentMethod = {
  CASH: 'CASH',
  CHECK: 'CHECK',
  EFT: 'EFT',
  OTHER: 'OTHER',
  null: null,
} as const;

/**
 * Only applies to `Delivery to Retailer` orders
 */
export type UpdateOrderDtoPaymentTerms = (typeof UpdateOrderDtoPaymentTerms)[keyof typeof UpdateOrderDtoPaymentTerms];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrderDtoPaymentTerms = {
  COD: 'COD',
  NET_7: 'NET_7',
  NET_10: 'NET_10',
  NET_15: 'NET_15',
  NET_30: 'NET_30',
} as const;

export type UpdateOrderDtoAction = (typeof UpdateOrderDtoAction)[keyof typeof UpdateOrderDtoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrderDtoAction = {
  DELIVERY_TO_RETAILER: 'DELIVERY_TO_RETAILER',
  DELIVERY_TO_BRAND: 'DELIVERY_TO_BRAND',
  DROPOFF_TO_NABIS: 'DROPOFF_TO_NABIS',
  PICKUP_FROM_BRAND: 'PICKUP_FROM_BRAND',
  PICKUP_FROM_NABIS: 'PICKUP_FROM_NABIS',
  RETURN_FROM_RETAILER: 'RETURN_FROM_RETAILER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
} as const;

export type UpdateOrderDtoTimezone = (typeof UpdateOrderDtoTimezone)[keyof typeof UpdateOrderDtoTimezone];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrderDtoTimezone = {
  'America/Anchorage': 'America/Anchorage',
  'America/Phoenix': 'America/Phoenix',
  'America/Chicago': 'America/Chicago',
  'America/New_York': 'America/New_York',
  'Pacific/Honolulu': 'Pacific/Honolulu',
  'America/Denver': 'America/Denver',
  'America/Los_Angeles': 'America/Los_Angeles',
  'Etc/UTC': 'Etc/UTC',
  null: null,
} as const;

export interface UpdateOrderLineItemDto {
  code: string;
  name: string;
  unit: string;
  quantity: number;
  pricePerUnit: number;
  itemBatchId: string;
  overrideQuantityPerUnitOfMeasure: boolean;
  discount: number;
  lineItemManifestNotes: string | null;
  isSample: boolean;
  itemVolumePricingId: string | null;
  appliedTaxId?: string | null;
  id?: string;
  taxInclusivePrice?: number | null;
}

export interface UpdateOrderDto {
  irn: string | null;
  deliveryDate: string;
  deliveryInstruction?: string;
  assignedSalesRepId?: string | null;
  timezone?: UpdateOrderDtoTimezone;
  action: UpdateOrderDtoAction;
  licensedLocationId: string;
  orderLicensedLocationContactIds: string[];
  orderRetailerContactIds?: string[];
  orderCreditMemoIds: string[];
  /** Only applies to `Delivery to Retailer` orders */
  paymentTerms?: UpdateOrderDtoPaymentTerms;
  paymentMethod?: UpdateOrderDtoPaymentMethod;
  licenseId: string;
  notes: string | null;
  /** Source warehouse ID */
  warehouseId?: string;
  /** Require overdue balances prior to delivery */
  mustPayPriorBalance?: boolean;
  /** Indicates source of the order, e.g., Marketplace, Order Form, Sales Order Form */
  source?: UpdateOrderDtoSource;
  lineItems: UpdateOrderLineItemDto[];
  deletedLineItemIds: string[];
}

export type EnrichedFullOrderFetchResponseDtoStagingArea = StagingAreaEntity | null;

export type EnrichedFullOrderFetchResponseDtoWarehouse = WarehouseEntity | null;

export type EnrichedFullOrderFetchResponseDtoAssignee = UserEntity | null;

export type EnrichedFullOrderFetchResponseDtoCreator = UserEntity | null;

export interface EnrichedFullOrderFetchResponseDto {
  orderProperties: OrderEntity;
  creator: EnrichedFullOrderFetchResponseDtoCreator;
  assignee: EnrichedFullOrderFetchResponseDtoAssignee;
  warehouse: EnrichedFullOrderFetchResponseDtoWarehouse;
  licensedLocation: ExtendedLicensedLocationEntity;
  licensedLocationRestrictions: LicensedLocationRestrictionEntity[];
  organization: OrganizationEntity;
  license: LicenseEntity;
  orderConfirmation: OrderConfirmationEntity;
  orderDelivery: ExtendedOrderDeliveryEntity;
  orderNotes: OrderNotesEntity;
  orderRetailerContacts?: string[];
  orderOnfleet: OrderOnfleetEntity;
  orderFinancial: OrderFinancialEntity;
  orderFiles: OrderFilesEntity;
  orderContacts: OrderContactEntity[];
  orderCreditMemos: OrderCreditMemoEntity[];
  creditMemoAmount: number;
  orderLineItemDiscountAmount: number;
  invoice: InvoiceEntity[];
  stagingArea: EnrichedFullOrderFetchResponseDtoStagingArea;
  serviceMessages: GetOrderMessageResponseDto[];
  orderLineItem: EnrichedExtendedOrderLineItemEntity[];
}

export type EnrichedExtendedOrderLineItemEntitySampleType =
  (typeof EnrichedExtendedOrderLineItemEntitySampleType)[keyof typeof EnrichedExtendedOrderLineItemEntitySampleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedExtendedOrderLineItemEntitySampleType = {
  TRADE_SAMPLE: 'TRADE_SAMPLE',
  DONATION: 'DONATION',
  DISPLAY_SAMPLE: 'DISPLAY_SAMPLE',
  null: null,
} as const;

export interface EnrichedExtendedOrderLineItemEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  quantity: number;
  pricePerUnit: number;
  taxInclusivePrice?: number;
  itemPricePerUnit: number;
  code: string;
  name: string;
  unit: string;
  orderId: string;
  createdById: string | null;
  updatedById: string | null;
  itemId: string;
  isSample: boolean;
  oversold: boolean;
  itemBatchId: string;
  batchId: string;
  discount: number;
  taggedAt: number;
  taggerId: string;
  overrideQuantityPerUnitOfMeasure: boolean;
  lineItemManifestNotes: string | null;
  sampleType: EnrichedExtendedOrderLineItemEntitySampleType;
  taxAmount: number;
  itemVolumePricingId: string;
  sequenceNumber: number;
  appliedTaxId: string;
  batch: BatchEntity;
  itemBatch: EnrichedItemBatchEntity;
  item: EnrichedItemEntity;
}

export type EnrichedItemEntityTaxExemptionTypesItem =
  (typeof EnrichedItemEntityTaxExemptionTypesItem)[keyof typeof EnrichedItemEntityTaxExemptionTypesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityTaxExemptionTypesItem = {
  ADULT_USE: 'ADULT_USE',
  MEDICAL: 'MEDICAL',
} as const;

export type EnrichedItemEntityDefaultTaxExemptionType =
  (typeof EnrichedItemEntityDefaultTaxExemptionType)[keyof typeof EnrichedItemEntityDefaultTaxExemptionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityDefaultTaxExemptionType = {
  ADULT_USE: 'ADULT_USE',
  MEDICAL: 'MEDICAL',
} as const;

export type EnrichedItemEntityCannabisWeightPerUnitMeasurement =
  (typeof EnrichedItemEntityCannabisWeightPerUnitMeasurement)[keyof typeof EnrichedItemEntityCannabisWeightPerUnitMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityCannabisWeightPerUnitMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
} as const;

export type EnrichedItemEntityInventoryCategoryTagsItem =
  (typeof EnrichedItemEntityInventoryCategoryTagsItem)[keyof typeof EnrichedItemEntityInventoryCategoryTagsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityInventoryCategoryTagsItem = {
  AIRGRAFT: 'AIRGRAFT',
  BALM: 'BALM',
  BOTANICAL: 'BOTANICAL',
  BROWNIE: 'BROWNIE',
  BUD: 'BUD',
  BUDDER: 'BUDDER',
  BUTANE_HASH_OIL: 'BUTANE_HASH_OIL',
  BUTTER: 'BUTTER',
  CAPSULE: 'CAPSULE',
  CARTRIDGE_510: 'CARTRIDGE_510',
  CHIPS: 'CHIPS',
  CHOCOLATE: 'CHOCOLATE',
  CO2_OIL: 'CO2_OIL',
  COFFEE: 'COFFEE',
  COLD_WATER_HASH: 'COLD_WATER_HASH',
  CONCENTRATE: 'CONCENTRATE',
  COOKIE: 'COOKIE',
  CREAM: 'CREAM',
  CRUMBLE: 'CRUMBLE',
  DART: 'DART',
  DIAMONDS: 'DIAMONDS',
  DISSOLVABLE_POWDER: 'DISSOLVABLE_POWDER',
  FROST: 'FROST',
  GREENHOUSE: 'GREENHOUSE',
  GUMMY: 'GUMMY',
  HARD_CANDY: 'HARD_CANDY',
  HASH: 'HASH',
  HONEY: 'HONEY',
  ICE_CREAM: 'ICE_CREAM',
  INDOOR: 'INDOOR',
  INFUSED_FLOWER: 'INFUSED_FLOWER',
  INFUSED_PRE_ROLLS: 'INFUSED_PRE_ROLLS',
  INHALER: 'INHALER',
  JUICE: 'JUICE',
  KIEF: 'KIEF',
  KIF: 'KIF',
  LEAFLETTES: 'LEAFLETTES',
  LIGHT_DEP: 'LIGHT_DEP',
  LIP_BALM: 'LIP_BALM',
  LIVE_RESIN: 'LIVE_RESIN',
  MARSHMALLOW: 'MARSHMALLOW',
  MINT: 'MINT',
  MIXED: 'MIXED',
  OTHER_BATTERY_TYPES: 'OTHER_BATTERY_TYPES',
  OTHER: 'OTHER',
  OUTDOOR: 'OUTDOOR',
  PACK: 'PACK',
  PATCH: 'PATCH',
  PAX: 'PAX',
  PEN: 'PEN',
  PILL: 'PILL',
  POPCORN: 'POPCORN',
  POPS: 'POPS',
  PRE_GROUND: 'PRE_GROUND',
  PRE_ROLLS: 'PRE_ROLLS',
  PROPRIETARY: 'PROPRIETARY',
  READY_TO_ROLL: 'READY_TO_ROLL',
  ROSIN: 'ROSIN',
  SALVE: 'SALVE',
  SAUCE: 'SAUCE',
  SELTZER: 'SELTZER',
  SHAKE: 'SHAKE',
  SHATTER: 'SHATTER',
  SHOT: 'SHOT',
  SINGLE: 'SINGLE',
  SODA: 'SODA',
  SOLVENTLESS: 'SOLVENTLESS',
  SPRAY: 'SPRAY',
  SUBLINGUAL: 'SUBLINGUAL',
  SUGAR: 'SUGAR',
  SUN_GROWN: 'SUN_GROWN',
  SUPPOSITORY: 'SUPPOSITORY',
  TABLETS: 'TABLETS',
  TAFFY: 'TAFFY',
  TEA: 'TEA',
  THREAD_510: 'THREAD_510',
  TINCTURES: 'TINCTURES',
  TRANSDERMAL: 'TRANSDERMAL',
  TRIM: 'TRIM',
  WATER: 'WATER',
  WAX: 'WAX',
  BAKED_GOOD: 'BAKED_GOOD',
  BATTERY: 'BATTERY',
  BEVERAGE: 'BEVERAGE',
  CANDY: 'CANDY',
  CARTRIDGE: 'CARTRIDGE',
  CRYSTALLINE: 'CRYSTALLINE',
  DISPOSABLE: 'DISPOSABLE',
  WHOLE_FLOWER: 'WHOLE_FLOWER',
  OIL: 'OIL',
} as const;

export type EnrichedItemEntityUnitWeightMeasurement =
  (typeof EnrichedItemEntityUnitWeightMeasurement)[keyof typeof EnrichedItemEntityUnitWeightMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityUnitWeightMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
  null: null,
} as const;

export type EnrichedItemEntityWeightMeasurement =
  (typeof EnrichedItemEntityWeightMeasurement)[keyof typeof EnrichedItemEntityWeightMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityWeightMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
  null: null,
} as const;

export type EnrichedItemEntityStrainType =
  (typeof EnrichedItemEntityStrainType)[keyof typeof EnrichedItemEntityStrainType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityStrainType = {
  OTHER: 'OTHER',
  SATIVA: 'SATIVA',
  INDICA: 'INDICA',
  HYBRID: 'HYBRID',
  SATIVA_DOMINANT: 'SATIVA_DOMINANT',
  INDICA_DOMINANT: 'INDICA_DOMINANT',
  null: null,
} as const;

export type EnrichedItemEntityTagsItem = (typeof EnrichedItemEntityTagsItem)[keyof typeof EnrichedItemEntityTagsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityTagsItem = {
  ACCESSORY: 'ACCESSORY',
  BALANCE: 'BALANCE',
  BEGINNER: 'BEGINNER',
  BLACK_OWNED: 'BLACK_OWNED',
  BLEND: 'BLEND',
  BUDGET: 'BUDGET',
  CREATIVE: 'CREATIVE',
  CULTIVATOR: 'CULTIVATOR',
  DESIGNER: 'DESIGNER',
  DISTILLATE_INFUSED: 'DISTILLATE_INFUSED',
  EFFECT_BASED: 'EFFECT_BASED',
  ENERGETIC: 'ENERGETIC',
  ENTHUSIAST: 'ENTHUSIAST',
  EUPHORIC: 'EUPHORIC',
  FAMILY_OWNED: 'FAMILY_OWNED',
  FEMALE_OWNED: 'FEMALE_OWNED',
  FIVE_TO_ONE_CBD_THC_RATIO: 'FIVE_TO_ONE_CBD_THC_RATIO',
  FOCUSED: 'FOCUSED',
  FROZEN: 'FROZEN',
  GIDDY: 'GIDDY',
  GLASS: 'GLASS',
  HAPPY: 'HAPPY',
  HASH_INFUSED: 'HASH_INFUSED',
  HERITAGE_AND_LEGACY_BRAND: 'HERITAGE_AND_LEGACY_BRAND',
  HUNDRED_PERCENT_BIODEGRADABLE: 'HUNDRED_PERCENT_BIODEGRADABLE',
  HUNGRY: 'HUNGRY',
  MASS_MARKET: 'MASS_MARKET',
  MEDICAL: 'MEDICAL',
  MID_MARKET: 'MID_MARKET',
  MINORITY_OWNED: 'MINORITY_OWNED',
  MYLAR_BAGS: 'MYLAR_BAGS',
  NANO_EMULSION_OR_FAST_ACTING: 'NANO_EMULSION_OR_FAST_ACTING',
  NON_CANNABIS: 'NON_CANNABIS',
  ONE_TO_ONE_CBD_THC_RATIO: 'ONE_TO_ONE_CBD_THC_RATIO',
  ONE_TO_TEN_CBD_THC_RATIO: 'ONE_TO_TEN_CBD_THC_RATIO',
  ONE_TO_TWO_CBD_THC_RATIO: 'ONE_TO_TWO_CBD_THC_RATIO',
  PAIN_RELIEF: 'PAIN_RELIEF',
  PLASTIC: 'PLASTIC',
  PRECISE_DOSING: 'PRECISE_DOSING',
  PREMIUM: 'PREMIUM',
  RECREATIONAL: 'RECREATIONAL',
  REFRIGERATED: 'REFRIGERATED',
  RELAXED: 'RELAXED',
  ROSIN_INFUSED: 'ROSIN_INFUSED',
  SHELF_STABLE: 'SHELF_STABLE',
  SLEEP_AID: 'SLEEP_AID',
  SLEEPY: 'SLEEPY',
  SOCIAL_EQUITY: 'SOCIAL_EQUITY',
  STRAIN_SPECIFIC: 'STRAIN_SPECIFIC',
  TALKATIVE: 'TALKATIVE',
  TEN_TO_ONE_CBD_THC_RATIO: 'TEN_TO_ONE_CBD_THC_RATIO',
  THREE_TO_ONE_CBD_THC_RATIO: 'THREE_TO_ONE_CBD_THC_RATIO',
  TWO_TO_ONE_CBD_THC_RATIO: 'TWO_TO_ONE_CBD_THC_RATIO',
  UPLIFTED: 'UPLIFTED',
} as const;

export type EnrichedItemEntityInventoryUnitOfMeasure =
  (typeof EnrichedItemEntityInventoryUnitOfMeasure)[keyof typeof EnrichedItemEntityInventoryUnitOfMeasure];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityInventoryUnitOfMeasure = {
  EACH: 'EACH',
  PACK: 'PACK',
  CASE: 'CASE',
  PALLET: 'PALLET',
} as const;

export type EnrichedItemEntityInventoryCategory =
  (typeof EnrichedItemEntityInventoryCategory)[keyof typeof EnrichedItemEntityInventoryCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityInventoryCategory = {
  AIRGRAFT: 'AIRGRAFT',
  BALM: 'BALM',
  BOTANICAL: 'BOTANICAL',
  BROWNIE: 'BROWNIE',
  BUD: 'BUD',
  BUDDER: 'BUDDER',
  BUTANE_HASH_OIL: 'BUTANE_HASH_OIL',
  BUTTER: 'BUTTER',
  CAPSULE: 'CAPSULE',
  CARTRIDGE_510: 'CARTRIDGE_510',
  CHIPS: 'CHIPS',
  CHOCOLATE: 'CHOCOLATE',
  CO2_OIL: 'CO2_OIL',
  COFFEE: 'COFFEE',
  COLD_WATER_HASH: 'COLD_WATER_HASH',
  CONCENTRATE: 'CONCENTRATE',
  COOKIE: 'COOKIE',
  CREAM: 'CREAM',
  CRUMBLE: 'CRUMBLE',
  DART: 'DART',
  DIAMONDS: 'DIAMONDS',
  DISSOLVABLE_POWDER: 'DISSOLVABLE_POWDER',
  FROST: 'FROST',
  GREENHOUSE: 'GREENHOUSE',
  GUMMY: 'GUMMY',
  HARD_CANDY: 'HARD_CANDY',
  HASH: 'HASH',
  HONEY: 'HONEY',
  ICE_CREAM: 'ICE_CREAM',
  INDOOR: 'INDOOR',
  INFUSED_FLOWER: 'INFUSED_FLOWER',
  INFUSED_PRE_ROLLS: 'INFUSED_PRE_ROLLS',
  INHALER: 'INHALER',
  JUICE: 'JUICE',
  KIEF: 'KIEF',
  KIF: 'KIF',
  LEAFLETTES: 'LEAFLETTES',
  LIGHT_DEP: 'LIGHT_DEP',
  LIP_BALM: 'LIP_BALM',
  LIVE_RESIN: 'LIVE_RESIN',
  MARSHMALLOW: 'MARSHMALLOW',
  MINT: 'MINT',
  MIXED: 'MIXED',
  OTHER_BATTERY_TYPES: 'OTHER_BATTERY_TYPES',
  OTHER: 'OTHER',
  OUTDOOR: 'OUTDOOR',
  PACK: 'PACK',
  PATCH: 'PATCH',
  PAX: 'PAX',
  PEN: 'PEN',
  PILL: 'PILL',
  POPCORN: 'POPCORN',
  POPS: 'POPS',
  PRE_GROUND: 'PRE_GROUND',
  PRE_ROLLS: 'PRE_ROLLS',
  PROPRIETARY: 'PROPRIETARY',
  READY_TO_ROLL: 'READY_TO_ROLL',
  ROSIN: 'ROSIN',
  SALVE: 'SALVE',
  SAUCE: 'SAUCE',
  SELTZER: 'SELTZER',
  SHAKE: 'SHAKE',
  SHATTER: 'SHATTER',
  SHOT: 'SHOT',
  SINGLE: 'SINGLE',
  SODA: 'SODA',
  SOLVENTLESS: 'SOLVENTLESS',
  SPRAY: 'SPRAY',
  SUBLINGUAL: 'SUBLINGUAL',
  SUGAR: 'SUGAR',
  SUN_GROWN: 'SUN_GROWN',
  SUPPOSITORY: 'SUPPOSITORY',
  TABLETS: 'TABLETS',
  TAFFY: 'TAFFY',
  TEA: 'TEA',
  THREAD_510: 'THREAD_510',
  TINCTURES: 'TINCTURES',
  TRANSDERMAL: 'TRANSDERMAL',
  TRIM: 'TRIM',
  WATER: 'WATER',
  WAX: 'WAX',
  BAKED_GOOD: 'BAKED_GOOD',
  BATTERY: 'BATTERY',
  BEVERAGE: 'BEVERAGE',
  CANDY: 'CANDY',
  CARTRIDGE: 'CARTRIDGE',
  CRYSTALLINE: 'CRYSTALLINE',
  DISPOSABLE: 'DISPOSABLE',
  WHOLE_FLOWER: 'WHOLE_FLOWER',
  OIL: 'OIL',
} as const;

export type EnrichedItemEntityInventoryClass =
  (typeof EnrichedItemEntityInventoryClass)[keyof typeof EnrichedItemEntityInventoryClass];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityInventoryClass = {
  CONCENTRATE: 'CONCENTRATE',
  EDIBLES: 'EDIBLES',
  FLOWER: 'FLOWER',
  PERSONAL_CARE: 'PERSONAL_CARE',
  PRE_ROLL: 'PRE_ROLL',
  VAPE: 'VAPE',
  ACCESSORIES: 'ACCESSORIES',
} as const;

export type EnrichedItemEntityInventoryType =
  (typeof EnrichedItemEntityInventoryType)[keyof typeof EnrichedItemEntityInventoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemEntityInventoryType = {
  CANNABIS: 'CANNABIS',
  NON_CANNABIS: 'NON_CANNABIS',
} as const;

export interface EnrichedItemEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  code: string;
  organizationId: string;
  inventoryType: EnrichedItemEntityInventoryType;
  inventoryClass: EnrichedItemEntityInventoryClass;
  inventoryCategory: EnrichedItemEntityInventoryCategory;
  unit: string;
  pricePerUnit: number;
  name: string;
  deletedAt: string | null;
  inventoryUnitOfMeasure: EnrichedItemEntityInventoryUnitOfMeasure;
  quantityPerUnitOfMeasure: number;
  tags: EnrichedItemEntityTagsItem[];
  strainType: EnrichedItemEntityStrainType;
  nonSampleItemId: string | null;
  skuDetailsPdfLink: string | null;
  janeProductId: number | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  weightMeasurement: EnrichedItemEntityWeightMeasurement;
  unitWeight: number | null;
  unitWeightMeasurement: EnrichedItemEntityUnitWeightMeasurement;
  inventoryCategoryTags: EnrichedItemEntityInventoryCategoryTagsItem[];
  cannabisWeightPerUnit: number;
  cannabisWeightPerUnitMeasurement: EnrichedItemEntityCannabisWeightPerUnitMeasurement;
  isMedical: boolean;
  defaultTaxExemptionType: EnrichedItemEntityDefaultTaxExemptionType;
  /** User who created the record */
  createdById: string;
  description: string | null;
  availableOnMarketplace: boolean;
  marketplaceThcValue: number;
  marketplaceThcUnit: string;
  marketplaceSamplesEnabled: boolean;
  applicableTaxes: ApplicableTaxes;
  taxExemptionTypes: EnrichedItemEntityTaxExemptionTypesItem[];
}

export type EnrichedItemBatchEntityTaxExemptionTypesItem =
  (typeof EnrichedItemBatchEntityTaxExemptionTypesItem)[keyof typeof EnrichedItemBatchEntityTaxExemptionTypesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemBatchEntityTaxExemptionTypesItem = {
  ADULT_USE: 'ADULT_USE',
  MEDICAL: 'MEDICAL',
} as const;

export type EnrichedItemBatchEntityInventoryClass =
  (typeof EnrichedItemBatchEntityInventoryClass)[keyof typeof EnrichedItemBatchEntityInventoryClass];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemBatchEntityInventoryClass = {
  CONCENTRATE: 'CONCENTRATE',
  EDIBLES: 'EDIBLES',
  FLOWER: 'FLOWER',
  PERSONAL_CARE: 'PERSONAL_CARE',
  PRE_ROLL: 'PRE_ROLL',
  VAPE: 'VAPE',
  ACCESSORIES: 'ACCESSORIES',
} as const;

export type EnrichedItemBatchEntityCannabisWeightPerUnitMeasurement =
  (typeof EnrichedItemBatchEntityCannabisWeightPerUnitMeasurement)[keyof typeof EnrichedItemBatchEntityCannabisWeightPerUnitMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrichedItemBatchEntityCannabisWeightPerUnitMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
} as const;

export interface EnrichedItemBatchEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  itemId: string;
  batchId: string;
  deletedAt?: string;
  infoplusId?: number;
  licenseId: string;
  createdById?: string;
  updatedById?: string;
  calculatedAvailableQuantity: number;
  unallocatableQuantity: number;
  itemPricePerUnit: number;
  calculatedThcPercentage: number;
  calculatedThcWeight: number;
  cannabisWeightPerUnit: number;
  cannabisWeightPerUnitMeasurement: EnrichedItemBatchEntityCannabisWeightPerUnitMeasurement;
  inventoryClass: EnrichedItemBatchEntityInventoryClass;
  potencyTax: number;
  isMedical: boolean;
  applicableTaxes: ApplicableTaxes;
  taxExemptionTypes: EnrichedItemBatchEntityTaxExemptionTypesItem[];
}

export type ApplicableTaxesExemptions = { [key: string]: TaxDefinition };

export type TaxDefinitionExemptionType = (typeof TaxDefinitionExemptionType)[keyof typeof TaxDefinitionExemptionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaxDefinitionExemptionType = {
  ADULT_USE: 'ADULT_USE',
  MEDICAL: 'MEDICAL',
} as const;

export type TaxDefinitionTaxType = (typeof TaxDefinitionTaxType)[keyof typeof TaxDefinitionTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaxDefinitionTaxType = {
  EXCISE: 'EXCISE',
  POTENCY: 'POTENCY',
} as const;

export interface PotencyTaxInventoryClassMapping {
  ACCESSORIES: number;
  CONCENTRATE: number;
  EDIBLES: number;
  FLOWER: number;
  PERSONAL_CARE: number;
  PRE_ROLL: number;
  VAPE: number;
}

export interface TaxDefinition {
  id: string;
  name: string;
  taxType: TaxDefinitionTaxType;
  exemptionType?: TaxDefinitionExemptionType;
  startedAt: string;
  endedAt?: string;
  rate?: number;
  inventoryClassMapping?: PotencyTaxInventoryClassMapping;
}

export interface ApplicableTaxes {
  tax: TaxDefinition;
  exemptions: ApplicableTaxesExemptions;
}

export type OrderDeliveryEntityIssueReason =
  (typeof OrderDeliveryEntityIssueReason)[keyof typeof OrderDeliveryEntityIssueReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderDeliveryEntityIssueReason = {
  NABIS_MISPACK: 'NABIS_MISPACK',
  PARTIAL_REJECTION_OF_CORRECT_ITEMS: 'PARTIAL_REJECTION_OF_CORRECT_ITEMS',
  BRAND_MANUFACTURING_ERROR: 'BRAND_MANUFACTURING_ERROR',
  RETAILER_MISCOMMUNICATION: 'RETAILER_MISCOMMUNICATION',
  BRAND_MISCOMMUNICATION: 'BRAND_MISCOMMUNICATION',
  BRAND_REQUESTED_CHANGE: 'BRAND_REQUESTED_CHANGE',
  BRAND_FAULT: 'BRAND_FAULT',
  RETAILER_PAYMENT_NOT_READY: 'RETAILER_PAYMENT_NOT_READY',
  RETAILER_WILL_NOT_ACCEPT_PAYMENT_TERMS: 'RETAILER_WILL_NOT_ACCEPT_PAYMENT_TERMS',
  NABIS_INVENTORY_SHORTAGE: 'NABIS_INVENTORY_SHORTAGE',
  NABIS_MISSED_TIME_WINDOW: 'NABIS_MISSED_TIME_WINDOW',
  NABIS_SCHEDULING_ERROR: 'NABIS_SCHEDULING_ERROR',
  NABIS_COA_ERROR: 'NABIS_COA_ERROR',
  NABIS_LICENSE_ERROR: 'NABIS_LICENSE_ERROR',
  NABIS_ADDRESS_ERROR: 'NABIS_ADDRESS_ERROR',
  RETAILER_REQUESTS_DELAY: 'RETAILER_REQUESTS_DELAY',
  BRAND_REQUESTS_DELAY: 'BRAND_REQUESTS_DELAY',
  PENDING_INVENTORY_RESOLUTION: 'PENDING_INVENTORY_RESOLUTION',
  NABIS_CAPACITY_DELAY: 'NABIS_CAPACITY_DELAY',
  null: null,
} as const;

export interface OrderDeliveryEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  updatedById: string | null;
  driverId: string | null;
  vehicleId: string | null;
  deliveryDate: string;
  driverReportedStatus: OrderDeliveryEntityDriverReportedStatus;
  driverConfirmedAt: string | null;
  estimatedArrivalTimeBefore: string | null;
  estimatedArrivalTimeAfter: string | null;
  timeWindow: string | null;
  deliveryInstruction: string | null;
  issueReason?: OrderDeliveryEntityIssueReason;
  latestOrderDeliveryAttemptId: string | null;
}

export interface BalancesOrder {
  orderProperties: OrderEntity;
  licensedLocation: LicensedLocationEntity;
  orderDelivery: OrderDeliveryEntity;
  orderFinancial: OrderFinancialEntity;
  invoice: InvoiceEntity;
  creditMemoAmount: number;
  orderLineItemDiscountAmount: number;
  orderLineItemOriginalAmount: number;
  daysOverdue: number;
  wholesaleTotal: number;
  totalBalanceDue: number;
}

export interface BalancesResponseDto {
  data: BalancesOrder[];
  hasNextPage: boolean;
}

export type OrderDeliveryEntityDriverReportedStatus =
  (typeof OrderDeliveryEntityDriverReportedStatus)[keyof typeof OrderDeliveryEntityDriverReportedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderDeliveryEntityDriverReportedStatus = {
  DELIVERED: 'DELIVERED',
  DELIVERED_WITH_EDITS: 'DELIVERED_WITH_EDITS',
  REJECTED: 'REJECTED',
  REQUEST_FOR_RESCHEDULE: 'REQUEST_FOR_RESCHEDULE',
  null: null,
} as const;

export interface OrderFindAllResponseDto {
  data: FullOrderFetchResponseDto[];
  hasNextPage: boolean;
}

export type FullOrderFetchResponseDtoStagingArea = StagingAreaEntity | null;

export type FullOrderFetchResponseDtoWarehouse = WarehouseEntity | null;

export type FullOrderFetchResponseDtoAssignee = UserEntity | null;

export type FullOrderFetchResponseDtoCreator = UserEntity | null;

export interface StagingAreaEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  name: string;
  creatorId: string;
  warehouseId: string;
  deletedAt: string | null;
}

export interface InvoiceEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  collected: number;
  dueDate: string;
}

export interface OrderContactEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  licensedLocationContactId: string;
  deletedAt: string | null;
}

export type OrderFinancialEntityPaymentStatus =
  (typeof OrderFinancialEntityPaymentStatus)[keyof typeof OrderFinancialEntityPaymentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderFinancialEntityPaymentStatus = {
  UNPAID: 'UNPAID',
  COD_PAID: 'COD_PAID',
  NET_TERMS_PAID: 'NET_TERMS_PAID',
  REMITTED: 'REMITTED',
  SELF_COLLECTED: 'SELF_COLLECTED',
  PROCESSING: 'PROCESSING',
  PAYMENT_SENT: 'PAYMENT_SENT',
  WRITE_OFF: 'WRITE_OFF',
  THIRD_PARTY_COLLECTIONS: 'THIRD_PARTY_COLLECTIONS',
  PARTIAL_PAID: 'PARTIAL_PAID',
  DRIVER_PROCESSING: 'DRIVER_PROCESSING',
} as const;

export type OrderFinancialEntityPaymentTermsRequestStatus =
  (typeof OrderFinancialEntityPaymentTermsRequestStatus)[keyof typeof OrderFinancialEntityPaymentTermsRequestStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderFinancialEntityPaymentTermsRequestStatus = {
  REQUESTED: 'REQUESTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  null: null,
} as const;

export type OrderFinancialEntityPaymentTerms =
  (typeof OrderFinancialEntityPaymentTerms)[keyof typeof OrderFinancialEntityPaymentTerms];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderFinancialEntityPaymentTerms = {
  COD: 'COD',
  NET_7: 'NET_7',
  NET_10: 'NET_10',
  NET_15: 'NET_15',
  NET_30: 'NET_30',
  null: null,
} as const;

export type OrderFinancialEntityPaymentMethod =
  (typeof OrderFinancialEntityPaymentMethod)[keyof typeof OrderFinancialEntityPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderFinancialEntityPaymentMethod = {
  CASH: 'CASH',
  CHECK: 'CHECK',
  EFT: 'EFT',
  OTHER: 'OTHER',
} as const;

export interface OrderFinancialEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  updatedById: string | null;
  subtotal: number;
  paymentMethod: OrderFinancialEntityPaymentMethod;
  paymentTerms: OrderFinancialEntityPaymentTerms;
  paymentTermsRequestStatus: OrderFinancialEntityPaymentTermsRequestStatus;
  paymentStatus: OrderFinancialEntityPaymentStatus;
  taxAmount: number;
  appliedTaxId: string | null;
  taxInclusivePricing: boolean;
  taxInclusiveSubtotal: number;
  paidAt: string | null;
  mustPayPriorBalance: boolean;
}

export type OrderOnfleetEntityTaskOld = { [key: string]: any };

export interface OnfleetTask {
  shortId: string;
}

export interface OrderOnfleetEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  taskOld: OrderOnfleetEntityTaskOld;
  taskUpdatedAt: string | null;
  taskId: string | null;
  task: OnfleetTask;
}

export interface OrderNotesEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  updatedById: string | null;
  notes: string | null;
  adminNotes: string | null;
  internalNotes: string | null;
  retailerNotes: string | null;
  brandManifestNotes: string | null;
  nabisManifestNotes: string | null;
  retailerManifestNotes: string | null;
}

export type ExtendedOrderDeliveryEntityVehicle = VehicleEntity | null;

export type ExtendedOrderDeliveryEntityDriver = ExtendedDriverEntity | null;

export type ExtendedOrderDeliveryEntityIssueReason =
  (typeof ExtendedOrderDeliveryEntityIssueReason)[keyof typeof ExtendedOrderDeliveryEntityIssueReason];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtendedOrderDeliveryEntityIssueReason = {
  NABIS_MISPACK: 'NABIS_MISPACK',
  PARTIAL_REJECTION_OF_CORRECT_ITEMS: 'PARTIAL_REJECTION_OF_CORRECT_ITEMS',
  BRAND_MANUFACTURING_ERROR: 'BRAND_MANUFACTURING_ERROR',
  RETAILER_MISCOMMUNICATION: 'RETAILER_MISCOMMUNICATION',
  BRAND_MISCOMMUNICATION: 'BRAND_MISCOMMUNICATION',
  BRAND_REQUESTED_CHANGE: 'BRAND_REQUESTED_CHANGE',
  BRAND_FAULT: 'BRAND_FAULT',
  RETAILER_PAYMENT_NOT_READY: 'RETAILER_PAYMENT_NOT_READY',
  RETAILER_WILL_NOT_ACCEPT_PAYMENT_TERMS: 'RETAILER_WILL_NOT_ACCEPT_PAYMENT_TERMS',
  NABIS_INVENTORY_SHORTAGE: 'NABIS_INVENTORY_SHORTAGE',
  NABIS_MISSED_TIME_WINDOW: 'NABIS_MISSED_TIME_WINDOW',
  NABIS_SCHEDULING_ERROR: 'NABIS_SCHEDULING_ERROR',
  NABIS_COA_ERROR: 'NABIS_COA_ERROR',
  NABIS_LICENSE_ERROR: 'NABIS_LICENSE_ERROR',
  NABIS_ADDRESS_ERROR: 'NABIS_ADDRESS_ERROR',
  RETAILER_REQUESTS_DELAY: 'RETAILER_REQUESTS_DELAY',
  BRAND_REQUESTS_DELAY: 'BRAND_REQUESTS_DELAY',
  PENDING_INVENTORY_RESOLUTION: 'PENDING_INVENTORY_RESOLUTION',
  NABIS_CAPACITY_DELAY: 'NABIS_CAPACITY_DELAY',
  null: null,
} as const;

export type ExtendedOrderDeliveryEntityDriverReportedStatus =
  (typeof ExtendedOrderDeliveryEntityDriverReportedStatus)[keyof typeof ExtendedOrderDeliveryEntityDriverReportedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtendedOrderDeliveryEntityDriverReportedStatus = {
  DELIVERED: 'DELIVERED',
  DELIVERED_WITH_EDITS: 'DELIVERED_WITH_EDITS',
  REJECTED: 'REJECTED',
  REQUEST_FOR_RESCHEDULE: 'REQUEST_FOR_RESCHEDULE',
  null: null,
} as const;

export interface ExtendedOrderDeliveryEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  updatedById: string | null;
  driverId: string | null;
  vehicleId: string | null;
  deliveryDate: string;
  driverReportedStatus: ExtendedOrderDeliveryEntityDriverReportedStatus;
  driverConfirmedAt: string | null;
  estimatedArrivalTimeBefore: string | null;
  estimatedArrivalTimeAfter: string | null;
  timeWindow: string | null;
  deliveryInstruction: string | null;
  issueReason?: ExtendedOrderDeliveryEntityIssueReason;
  latestOrderDeliveryAttemptId: string | null;
  driver: ExtendedOrderDeliveryEntityDriver;
  vehicle: ExtendedOrderDeliveryEntityVehicle;
}

export interface VehicleEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  licensePlate: string;
  name?: string;
  make?: string;
  model?: string;
  year?: number;
  deletedAt?: string;
}

export type ExtendedDriverEntityLicenseIssuingState =
  (typeof ExtendedDriverEntityLicenseIssuingState)[keyof typeof ExtendedDriverEntityLicenseIssuingState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtendedDriverEntityLicenseIssuingState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface ExtendedDriverEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  driversLicense: string;
  userId: string;
  onfleetWorkerId?: string | null;
  deletedAt: string | null;
  licenseIssuingState: ExtendedDriverEntityLicenseIssuingState;
  driverAppPassword: string | null;
  user: UserEntity;
}

export type OrderConfirmationEntityConfirmationTrail =
  (typeof OrderConfirmationEntityConfirmationTrail)[keyof typeof OrderConfirmationEntityConfirmationTrail];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderConfirmationEntityConfirmationTrail = {
  VOICEMAIL_SUCCESS: 'VOICEMAIL_SUCCESS',
  PHONE_SUCCESS: 'PHONE_SUCCESS',
  PHONE_FAILURE: 'PHONE_FAILURE',
  EMAIL_SUCCESS: 'EMAIL_SUCCESS',
  EMAIL_FAILURE: 'EMAIL_FAILURE',
  SMS_SUCCESS: 'SMS_SUCCESS',
  null: null,
} as const;

export type OrderConfirmationEntityConfirmationStatus =
  (typeof OrderConfirmationEntityConfirmationStatus)[keyof typeof OrderConfirmationEntityConfirmationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderConfirmationEntityConfirmationStatus = {
  NOT_CONTACTED: 'NOT_CONTACTED',
  UNCONFIRMED: 'UNCONFIRMED',
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
} as const;

export interface OrderConfirmationEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  confirmationStatus: OrderConfirmationEntityConfirmationStatus;
  pocName: string;
  confirmationTrail: OrderConfirmationEntityConfirmationTrail;
  notes: string | null;
  isEmailSent: boolean;
  isInboundEmailSent: boolean;
  retailerConfirmLinkId: string | null;
}

export type ExtendedOrderLineItemEntitySampleType =
  (typeof ExtendedOrderLineItemEntitySampleType)[keyof typeof ExtendedOrderLineItemEntitySampleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtendedOrderLineItemEntitySampleType = {
  TRADE_SAMPLE: 'TRADE_SAMPLE',
  DONATION: 'DONATION',
  DISPLAY_SAMPLE: 'DISPLAY_SAMPLE',
  null: null,
} as const;

export interface ExtendedOrderLineItemEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  quantity: number;
  pricePerUnit: number;
  taxInclusivePrice?: number;
  itemPricePerUnit: number;
  code: string;
  name: string;
  unit: string;
  orderId: string;
  createdById: string | null;
  updatedById: string | null;
  itemId: string;
  isSample: boolean;
  oversold: boolean;
  itemBatchId: string;
  batchId: string;
  discount: number;
  taggedAt: number;
  taggerId: string;
  overrideQuantityPerUnitOfMeasure: boolean;
  lineItemManifestNotes: string | null;
  sampleType: ExtendedOrderLineItemEntitySampleType;
  taxAmount: number;
  itemVolumePricingId: string;
  sequenceNumber: number;
  appliedTaxId: string;
  itemBatch: ItemBatchEntity;
  item: ItemEntity;
  batch: BatchEntity;
}

export interface FullOrderFetchResponseDto {
  orderProperties: OrderEntity;
  creator: FullOrderFetchResponseDtoCreator;
  assignee: FullOrderFetchResponseDtoAssignee;
  warehouse: FullOrderFetchResponseDtoWarehouse;
  licensedLocation: ExtendedLicensedLocationEntity;
  licensedLocationRestrictions: LicensedLocationRestrictionEntity[];
  organization: OrganizationEntity;
  license: LicenseEntity;
  orderLineItem: ExtendedOrderLineItemEntity[];
  orderConfirmation: OrderConfirmationEntity;
  orderDelivery: ExtendedOrderDeliveryEntity;
  orderNotes: OrderNotesEntity;
  orderRetailerContacts?: string[];
  orderOnfleet: OrderOnfleetEntity;
  orderFinancial: OrderFinancialEntity;
  orderFiles: OrderFilesEntity;
  orderContacts: OrderContactEntity[];
  orderCreditMemos: OrderCreditMemoEntity[];
  creditMemoAmount: number;
  orderLineItemDiscountAmount: number;
  invoice: InvoiceEntity[];
  stagingArea: FullOrderFetchResponseDtoStagingArea;
  serviceMessages: GetOrderMessageResponseDto[];
}

export type ItemEntityDefaultTaxExemptionType =
  (typeof ItemEntityDefaultTaxExemptionType)[keyof typeof ItemEntityDefaultTaxExemptionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemEntityDefaultTaxExemptionType = {
  ADULT_USE: 'ADULT_USE',
  MEDICAL: 'MEDICAL',
} as const;

export type ItemEntityCannabisWeightPerUnitMeasurement =
  (typeof ItemEntityCannabisWeightPerUnitMeasurement)[keyof typeof ItemEntityCannabisWeightPerUnitMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemEntityCannabisWeightPerUnitMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
} as const;

export type ItemEntityInventoryCategoryTagsItem =
  (typeof ItemEntityInventoryCategoryTagsItem)[keyof typeof ItemEntityInventoryCategoryTagsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemEntityInventoryCategoryTagsItem = {
  AIRGRAFT: 'AIRGRAFT',
  BALM: 'BALM',
  BOTANICAL: 'BOTANICAL',
  BROWNIE: 'BROWNIE',
  BUD: 'BUD',
  BUDDER: 'BUDDER',
  BUTANE_HASH_OIL: 'BUTANE_HASH_OIL',
  BUTTER: 'BUTTER',
  CAPSULE: 'CAPSULE',
  CARTRIDGE_510: 'CARTRIDGE_510',
  CHIPS: 'CHIPS',
  CHOCOLATE: 'CHOCOLATE',
  CO2_OIL: 'CO2_OIL',
  COFFEE: 'COFFEE',
  COLD_WATER_HASH: 'COLD_WATER_HASH',
  CONCENTRATE: 'CONCENTRATE',
  COOKIE: 'COOKIE',
  CREAM: 'CREAM',
  CRUMBLE: 'CRUMBLE',
  DART: 'DART',
  DIAMONDS: 'DIAMONDS',
  DISSOLVABLE_POWDER: 'DISSOLVABLE_POWDER',
  FROST: 'FROST',
  GREENHOUSE: 'GREENHOUSE',
  GUMMY: 'GUMMY',
  HARD_CANDY: 'HARD_CANDY',
  HASH: 'HASH',
  HONEY: 'HONEY',
  ICE_CREAM: 'ICE_CREAM',
  INDOOR: 'INDOOR',
  INFUSED_FLOWER: 'INFUSED_FLOWER',
  INFUSED_PRE_ROLLS: 'INFUSED_PRE_ROLLS',
  INHALER: 'INHALER',
  JUICE: 'JUICE',
  KIEF: 'KIEF',
  KIF: 'KIF',
  LEAFLETTES: 'LEAFLETTES',
  LIGHT_DEP: 'LIGHT_DEP',
  LIP_BALM: 'LIP_BALM',
  LIVE_RESIN: 'LIVE_RESIN',
  MARSHMALLOW: 'MARSHMALLOW',
  MINT: 'MINT',
  MIXED: 'MIXED',
  OTHER_BATTERY_TYPES: 'OTHER_BATTERY_TYPES',
  OTHER: 'OTHER',
  OUTDOOR: 'OUTDOOR',
  PACK: 'PACK',
  PATCH: 'PATCH',
  PAX: 'PAX',
  PEN: 'PEN',
  PILL: 'PILL',
  POPCORN: 'POPCORN',
  POPS: 'POPS',
  PRE_GROUND: 'PRE_GROUND',
  PRE_ROLLS: 'PRE_ROLLS',
  PROPRIETARY: 'PROPRIETARY',
  READY_TO_ROLL: 'READY_TO_ROLL',
  ROSIN: 'ROSIN',
  SALVE: 'SALVE',
  SAUCE: 'SAUCE',
  SELTZER: 'SELTZER',
  SHAKE: 'SHAKE',
  SHATTER: 'SHATTER',
  SHOT: 'SHOT',
  SINGLE: 'SINGLE',
  SODA: 'SODA',
  SOLVENTLESS: 'SOLVENTLESS',
  SPRAY: 'SPRAY',
  SUBLINGUAL: 'SUBLINGUAL',
  SUGAR: 'SUGAR',
  SUN_GROWN: 'SUN_GROWN',
  SUPPOSITORY: 'SUPPOSITORY',
  TABLETS: 'TABLETS',
  TAFFY: 'TAFFY',
  TEA: 'TEA',
  THREAD_510: 'THREAD_510',
  TINCTURES: 'TINCTURES',
  TRANSDERMAL: 'TRANSDERMAL',
  TRIM: 'TRIM',
  WATER: 'WATER',
  WAX: 'WAX',
  BAKED_GOOD: 'BAKED_GOOD',
  BATTERY: 'BATTERY',
  BEVERAGE: 'BEVERAGE',
  CANDY: 'CANDY',
  CARTRIDGE: 'CARTRIDGE',
  CRYSTALLINE: 'CRYSTALLINE',
  DISPOSABLE: 'DISPOSABLE',
  WHOLE_FLOWER: 'WHOLE_FLOWER',
  OIL: 'OIL',
} as const;

export type ItemEntityUnitWeightMeasurement =
  (typeof ItemEntityUnitWeightMeasurement)[keyof typeof ItemEntityUnitWeightMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemEntityUnitWeightMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
  null: null,
} as const;

export type ItemEntityWeightMeasurement =
  (typeof ItemEntityWeightMeasurement)[keyof typeof ItemEntityWeightMeasurement];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemEntityWeightMeasurement = {
  LB: 'LB',
  MG: 'MG',
  G: 'G',
  null: null,
} as const;

export type ItemEntityStrainType = (typeof ItemEntityStrainType)[keyof typeof ItemEntityStrainType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemEntityStrainType = {
  OTHER: 'OTHER',
  SATIVA: 'SATIVA',
  INDICA: 'INDICA',
  HYBRID: 'HYBRID',
  SATIVA_DOMINANT: 'SATIVA_DOMINANT',
  INDICA_DOMINANT: 'INDICA_DOMINANT',
  null: null,
} as const;

export type ItemEntityTagsItem = (typeof ItemEntityTagsItem)[keyof typeof ItemEntityTagsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemEntityTagsItem = {
  ACCESSORY: 'ACCESSORY',
  BALANCE: 'BALANCE',
  BEGINNER: 'BEGINNER',
  BLACK_OWNED: 'BLACK_OWNED',
  BLEND: 'BLEND',
  BUDGET: 'BUDGET',
  CREATIVE: 'CREATIVE',
  CULTIVATOR: 'CULTIVATOR',
  DESIGNER: 'DESIGNER',
  DISTILLATE_INFUSED: 'DISTILLATE_INFUSED',
  EFFECT_BASED: 'EFFECT_BASED',
  ENERGETIC: 'ENERGETIC',
  ENTHUSIAST: 'ENTHUSIAST',
  EUPHORIC: 'EUPHORIC',
  FAMILY_OWNED: 'FAMILY_OWNED',
  FEMALE_OWNED: 'FEMALE_OWNED',
  FIVE_TO_ONE_CBD_THC_RATIO: 'FIVE_TO_ONE_CBD_THC_RATIO',
  FOCUSED: 'FOCUSED',
  FROZEN: 'FROZEN',
  GIDDY: 'GIDDY',
  GLASS: 'GLASS',
  HAPPY: 'HAPPY',
  HASH_INFUSED: 'HASH_INFUSED',
  HERITAGE_AND_LEGACY_BRAND: 'HERITAGE_AND_LEGACY_BRAND',
  HUNDRED_PERCENT_BIODEGRADABLE: 'HUNDRED_PERCENT_BIODEGRADABLE',
  HUNGRY: 'HUNGRY',
  MASS_MARKET: 'MASS_MARKET',
  MEDICAL: 'MEDICAL',
  MID_MARKET: 'MID_MARKET',
  MINORITY_OWNED: 'MINORITY_OWNED',
  MYLAR_BAGS: 'MYLAR_BAGS',
  NANO_EMULSION_OR_FAST_ACTING: 'NANO_EMULSION_OR_FAST_ACTING',
  NON_CANNABIS: 'NON_CANNABIS',
  ONE_TO_ONE_CBD_THC_RATIO: 'ONE_TO_ONE_CBD_THC_RATIO',
  ONE_TO_TEN_CBD_THC_RATIO: 'ONE_TO_TEN_CBD_THC_RATIO',
  ONE_TO_TWO_CBD_THC_RATIO: 'ONE_TO_TWO_CBD_THC_RATIO',
  PAIN_RELIEF: 'PAIN_RELIEF',
  PLASTIC: 'PLASTIC',
  PRECISE_DOSING: 'PRECISE_DOSING',
  PREMIUM: 'PREMIUM',
  RECREATIONAL: 'RECREATIONAL',
  REFRIGERATED: 'REFRIGERATED',
  RELAXED: 'RELAXED',
  ROSIN_INFUSED: 'ROSIN_INFUSED',
  SHELF_STABLE: 'SHELF_STABLE',
  SLEEP_AID: 'SLEEP_AID',
  SLEEPY: 'SLEEPY',
  SOCIAL_EQUITY: 'SOCIAL_EQUITY',
  STRAIN_SPECIFIC: 'STRAIN_SPECIFIC',
  TALKATIVE: 'TALKATIVE',
  TEN_TO_ONE_CBD_THC_RATIO: 'TEN_TO_ONE_CBD_THC_RATIO',
  THREE_TO_ONE_CBD_THC_RATIO: 'THREE_TO_ONE_CBD_THC_RATIO',
  TWO_TO_ONE_CBD_THC_RATIO: 'TWO_TO_ONE_CBD_THC_RATIO',
  UPLIFTED: 'UPLIFTED',
} as const;

export type ItemEntityInventoryUnitOfMeasure =
  (typeof ItemEntityInventoryUnitOfMeasure)[keyof typeof ItemEntityInventoryUnitOfMeasure];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemEntityInventoryUnitOfMeasure = {
  EACH: 'EACH',
  PACK: 'PACK',
  CASE: 'CASE',
  PALLET: 'PALLET',
} as const;

export type ItemEntityInventoryCategory =
  (typeof ItemEntityInventoryCategory)[keyof typeof ItemEntityInventoryCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemEntityInventoryCategory = {
  AIRGRAFT: 'AIRGRAFT',
  BALM: 'BALM',
  BOTANICAL: 'BOTANICAL',
  BROWNIE: 'BROWNIE',
  BUD: 'BUD',
  BUDDER: 'BUDDER',
  BUTANE_HASH_OIL: 'BUTANE_HASH_OIL',
  BUTTER: 'BUTTER',
  CAPSULE: 'CAPSULE',
  CARTRIDGE_510: 'CARTRIDGE_510',
  CHIPS: 'CHIPS',
  CHOCOLATE: 'CHOCOLATE',
  CO2_OIL: 'CO2_OIL',
  COFFEE: 'COFFEE',
  COLD_WATER_HASH: 'COLD_WATER_HASH',
  CONCENTRATE: 'CONCENTRATE',
  COOKIE: 'COOKIE',
  CREAM: 'CREAM',
  CRUMBLE: 'CRUMBLE',
  DART: 'DART',
  DIAMONDS: 'DIAMONDS',
  DISSOLVABLE_POWDER: 'DISSOLVABLE_POWDER',
  FROST: 'FROST',
  GREENHOUSE: 'GREENHOUSE',
  GUMMY: 'GUMMY',
  HARD_CANDY: 'HARD_CANDY',
  HASH: 'HASH',
  HONEY: 'HONEY',
  ICE_CREAM: 'ICE_CREAM',
  INDOOR: 'INDOOR',
  INFUSED_FLOWER: 'INFUSED_FLOWER',
  INFUSED_PRE_ROLLS: 'INFUSED_PRE_ROLLS',
  INHALER: 'INHALER',
  JUICE: 'JUICE',
  KIEF: 'KIEF',
  KIF: 'KIF',
  LEAFLETTES: 'LEAFLETTES',
  LIGHT_DEP: 'LIGHT_DEP',
  LIP_BALM: 'LIP_BALM',
  LIVE_RESIN: 'LIVE_RESIN',
  MARSHMALLOW: 'MARSHMALLOW',
  MINT: 'MINT',
  MIXED: 'MIXED',
  OTHER_BATTERY_TYPES: 'OTHER_BATTERY_TYPES',
  OTHER: 'OTHER',
  OUTDOOR: 'OUTDOOR',
  PACK: 'PACK',
  PATCH: 'PATCH',
  PAX: 'PAX',
  PEN: 'PEN',
  PILL: 'PILL',
  POPCORN: 'POPCORN',
  POPS: 'POPS',
  PRE_GROUND: 'PRE_GROUND',
  PRE_ROLLS: 'PRE_ROLLS',
  PROPRIETARY: 'PROPRIETARY',
  READY_TO_ROLL: 'READY_TO_ROLL',
  ROSIN: 'ROSIN',
  SALVE: 'SALVE',
  SAUCE: 'SAUCE',
  SELTZER: 'SELTZER',
  SHAKE: 'SHAKE',
  SHATTER: 'SHATTER',
  SHOT: 'SHOT',
  SINGLE: 'SINGLE',
  SODA: 'SODA',
  SOLVENTLESS: 'SOLVENTLESS',
  SPRAY: 'SPRAY',
  SUBLINGUAL: 'SUBLINGUAL',
  SUGAR: 'SUGAR',
  SUN_GROWN: 'SUN_GROWN',
  SUPPOSITORY: 'SUPPOSITORY',
  TABLETS: 'TABLETS',
  TAFFY: 'TAFFY',
  TEA: 'TEA',
  THREAD_510: 'THREAD_510',
  TINCTURES: 'TINCTURES',
  TRANSDERMAL: 'TRANSDERMAL',
  TRIM: 'TRIM',
  WATER: 'WATER',
  WAX: 'WAX',
  BAKED_GOOD: 'BAKED_GOOD',
  BATTERY: 'BATTERY',
  BEVERAGE: 'BEVERAGE',
  CANDY: 'CANDY',
  CARTRIDGE: 'CARTRIDGE',
  CRYSTALLINE: 'CRYSTALLINE',
  DISPOSABLE: 'DISPOSABLE',
  WHOLE_FLOWER: 'WHOLE_FLOWER',
  OIL: 'OIL',
} as const;

export type ItemEntityInventoryClass = (typeof ItemEntityInventoryClass)[keyof typeof ItemEntityInventoryClass];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemEntityInventoryClass = {
  CONCENTRATE: 'CONCENTRATE',
  EDIBLES: 'EDIBLES',
  FLOWER: 'FLOWER',
  PERSONAL_CARE: 'PERSONAL_CARE',
  PRE_ROLL: 'PRE_ROLL',
  VAPE: 'VAPE',
  ACCESSORIES: 'ACCESSORIES',
} as const;

export type ItemEntityInventoryType = (typeof ItemEntityInventoryType)[keyof typeof ItemEntityInventoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemEntityInventoryType = {
  CANNABIS: 'CANNABIS',
  NON_CANNABIS: 'NON_CANNABIS',
} as const;

export interface ItemEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  code: string;
  organizationId: string;
  inventoryType: ItemEntityInventoryType;
  inventoryClass: ItemEntityInventoryClass;
  inventoryCategory: ItemEntityInventoryCategory;
  unit: string;
  pricePerUnit: number;
  name: string;
  deletedAt: string | null;
  inventoryUnitOfMeasure: ItemEntityInventoryUnitOfMeasure;
  quantityPerUnitOfMeasure: number;
  tags: ItemEntityTagsItem[];
  strainType: ItemEntityStrainType;
  nonSampleItemId: string | null;
  skuDetailsPdfLink: string | null;
  janeProductId: number | null;
  length: number | null;
  width: number | null;
  height: number | null;
  weight: number | null;
  weightMeasurement: ItemEntityWeightMeasurement;
  unitWeight: number | null;
  unitWeightMeasurement: ItemEntityUnitWeightMeasurement;
  inventoryCategoryTags: ItemEntityInventoryCategoryTagsItem[];
  cannabisWeightPerUnit: number;
  cannabisWeightPerUnitMeasurement: ItemEntityCannabisWeightPerUnitMeasurement;
  isMedical: boolean;
  defaultTaxExemptionType: ItemEntityDefaultTaxExemptionType;
  /** User who created the record */
  createdById: string;
  description: string | null;
  availableOnMarketplace: boolean;
  marketplaceThcValue: number;
  marketplaceThcUnit: string;
  marketplaceSamplesEnabled: boolean;
}

export interface ItemBatchEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  itemId: string;
  batchId: string;
  deletedAt?: string;
  infoplusId?: number;
  licenseId: string;
  createdById?: string;
  updatedById?: string;
}

export type ExtendedLicensedLocationEntityVerificationStatus =
  (typeof ExtendedLicensedLocationEntityVerificationStatus)[keyof typeof ExtendedLicensedLocationEntityVerificationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtendedLicensedLocationEntityVerificationStatus = {
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED',
  REJECTED: 'REJECTED',
} as const;

export type ExtendedLicensedLocationEntitySiteCategory =
  (typeof ExtendedLicensedLocationEntitySiteCategory)[keyof typeof ExtendedLicensedLocationEntitySiteCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExtendedLicensedLocationEntitySiteCategory = {
  RETAILER: 'RETAILER',
  MANUFACTURER: 'MANUFACTURER',
  CULTIVATOR: 'CULTIVATOR',
  CONSUMER: 'CONSUMER',
  DISTRIBUTOR: 'DISTRIBUTOR',
  NABIS_WAREHOUSE: 'NABIS_WAREHOUSE',
  MICROBUSINESS: 'MICROBUSINESS',
  OTHER: 'OTHER',
  TESTING: 'TESTING',
} as const;

export interface ExtendedLicensedLocationEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  name: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zip: string;
  lat: number | null;
  lng: number | null;
  siteCategory: ExtendedLicensedLocationEntitySiteCategory;
  verificationStatus: ExtendedLicensedLocationEntityVerificationStatus;
  submittedById: string;
  verificationAt: string | null;
  deletedAt: string | null;
  doingBusinessAs: string | null;
  phoneNumber: string;
  hoursBusiness: string | null;
  hoursDelivery: string | null;
  deliveryByApptOnly: boolean;
  specialProtocol: boolean;
  schedulingSoftwareRequired: boolean;
  schedulingSoftwareLink: string | null;
  centralizedPurchasingNotes: string | null;
  collectionNotes: string | null;
  deliveryNotes: string | null;
  parentLicensedLocationId: string | null;
  deliveryHoursId: string | null;
  locationNotes: string | null;
  w9Link: string | null;
  taxIdentificationNumber: string | null;
  sellerPermitLink: string | null;
  createdById: string;
  updatedById: string | null;
  organizationId: string;
  infoplusId: number | null;
  licenses: LicenseEntity[] | null;
  restrictions: LicensedLocationRestrictionEntity[] | null;
  organization: OrganizationEntity;
  licensedLocationContact: LicensedLocationContactEntity[];
}

export type LicensedLocationContactEntityPreferredContactMethod =
  (typeof LicensedLocationContactEntityPreferredContactMethod)[keyof typeof LicensedLocationContactEntityPreferredContactMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LicensedLocationContactEntityPreferredContactMethod = {
  PHONE: 'PHONE',
  EMAIL: 'EMAIL',
  TEXT: 'TEXT',
} as const;

export type LicensedLocationContactEntityContactType =
  (typeof LicensedLocationContactEntityContactType)[keyof typeof LicensedLocationContactEntityContactType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LicensedLocationContactEntityContactType = {
  ORDER: 'ORDER',
} as const;

export interface LicensedLocationContactEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  licensedLocationId: string;
  organizationId: string;
  contactType: LicensedLocationContactEntityContactType;
  firstName: string;
  lastName: string;
  title: string | null;
  phoneNumber: string | null;
  email: string | null;
  preferredContactMethod: LicensedLocationContactEntityPreferredContactMethod;
}

export interface WarehouseEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  licenseId: string;
  infoplusId: number;
  region: string;
  isProduction: boolean;
  name: string;
  isInUseByOps: boolean;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zip: string;
  lat: number | null;
  lng: number | null;
  licensedLocationId: string;
  deletedAt: string | null;
}

export type OrderEntityFulfillability = (typeof OrderEntityFulfillability)[keyof typeof OrderEntityFulfillability];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderEntityFulfillability = {
  FULFILLABLE: 'FULFILLABLE',
  PARTIALLY_FULFILLABLE: 'PARTIALLY_FULFILLABLE',
  NOT_FULFILLABLE: 'NOT_FULFILLABLE',
  MANUAL: 'MANUAL',
  null: null,
} as const;

export type OrderEntityReferrer = (typeof OrderEntityReferrer)[keyof typeof OrderEntityReferrer];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderEntityReferrer = {
  BRAND: 'BRAND',
  RETAILER: 'RETAILER',
  SALES: 'SALES',
  MANUFACTURER: 'MANUFACTURER',
} as const;

export type OrderEntityAsnInventoryStatus =
  (typeof OrderEntityAsnInventoryStatus)[keyof typeof OrderEntityAsnInventoryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderEntityAsnInventoryStatus = {
  ORDERED: 'ORDERED',
  SHELVED: 'SHELVED',
  null: null,
} as const;

export type OrderEntityOrderInventoryStatus =
  (typeof OrderEntityOrderInventoryStatus)[keyof typeof OrderEntityOrderInventoryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderEntityOrderInventoryStatus = {
  ORDERED: 'ORDERED',
  FULFILLED: 'FULFILLED',
  PACKED: 'PACKED',
  null: null,
} as const;

export type OrderEntityAction = (typeof OrderEntityAction)[keyof typeof OrderEntityAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderEntityAction = {
  DELIVERY_TO_RETAILER: 'DELIVERY_TO_RETAILER',
  DELIVERY_TO_BRAND: 'DELIVERY_TO_BRAND',
  DROPOFF_TO_NABIS: 'DROPOFF_TO_NABIS',
  PICKUP_FROM_BRAND: 'PICKUP_FROM_BRAND',
  PICKUP_FROM_NABIS: 'PICKUP_FROM_NABIS',
  RETURN_FROM_RETAILER: 'RETURN_FROM_RETAILER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
} as const;

export type OrderEntitySource = (typeof OrderEntitySource)[keyof typeof OrderEntitySource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderEntitySource = {
  MARKETPLACE_ORDER: 'MARKETPLACE_ORDER',
  BRAND_ORDER: 'BRAND_ORDER',
  SALES_ORDER: 'SALES_ORDER',
} as const;

export type OrderEntityStatus = (typeof OrderEntityStatus)[keyof typeof OrderEntityStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderEntityStatus = {
  UNSCHEDULED: 'UNSCHEDULED',
  SCHEDULED: 'SCHEDULED',
  IN_TRANSIT: 'IN_TRANSIT',
  TRANSFERRING: 'TRANSFERRING',
  DELIVERED: 'DELIVERED',
  DELIVERED_WITH_EDITS: 'DELIVERED_WITH_EDITS',
  DELAYED: 'DELAYED',
  CANCELED: 'CANCELED',
  REJECTED: 'REJECTED',
  ATTEMPTED: 'ATTEMPTED',
} as const;

export interface OrderEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  name: string;
  organizationId: string;
  orderNumber: number;
  licensedLocationId: string;
  licenseId: string;
  warehouseId: string;
  creatorId: string;
  updatedById: string;
  status: OrderEntityStatus;
  source: OrderEntitySource;
  action: OrderEntityAction;
  irn: string | null;
  assigneeId: string | null;
  isIntaken: boolean;
  isOuttaken: boolean;
  isExcluded: boolean;
  isEdited: boolean;
  infoplusOrderId: number | null;
  infoplusAsnId: number | null;
  infoplusReturnAsnId: number | null;
  orderInventoryStatus: OrderEntityOrderInventoryStatus;
  asnInventoryStatus: OrderEntityAsnInventoryStatus;
  isReceived: boolean;
  referrer: OrderEntityReferrer;
  isSampleDemo: boolean;
  pickers: string[] | null;
  fulfillability: OrderEntityFulfillability;
  isStaged: boolean;
  isPrinted: boolean;
  stagingAreaId: string | null;
  manufacturerOrganizationId: string;
  processingAt: string | null;
  isPending: boolean;
  deletedAt: string | null;
  parentId: string | null;
}

export interface CreateOrderResponseDto {
  id: string;
  orderNumber: number;
}

/**
 * Indicates source of the order, e.g., Marketplace, Order Form, Sales Order Form
 */
export type CreateOrderDtoSource = (typeof CreateOrderDtoSource)[keyof typeof CreateOrderDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderDtoSource = {
  MARKETPLACE_ORDER: 'MARKETPLACE_ORDER',
  BRAND_ORDER: 'BRAND_ORDER',
  SALES_ORDER: 'SALES_ORDER',
} as const;

export type CreateOrderDtoPaymentMethod =
  (typeof CreateOrderDtoPaymentMethod)[keyof typeof CreateOrderDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderDtoPaymentMethod = {
  CASH: 'CASH',
  CHECK: 'CHECK',
  EFT: 'EFT',
  OTHER: 'OTHER',
  null: null,
} as const;

/**
 * Only applies to `Delivery to Retailer` orders
 */
export type CreateOrderDtoPaymentTerms = (typeof CreateOrderDtoPaymentTerms)[keyof typeof CreateOrderDtoPaymentTerms];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderDtoPaymentTerms = {
  COD: 'COD',
  NET_7: 'NET_7',
  NET_10: 'NET_10',
  NET_15: 'NET_15',
  NET_30: 'NET_30',
} as const;

export type CreateOrderDtoAction = (typeof CreateOrderDtoAction)[keyof typeof CreateOrderDtoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderDtoAction = {
  DELIVERY_TO_RETAILER: 'DELIVERY_TO_RETAILER',
  DELIVERY_TO_BRAND: 'DELIVERY_TO_BRAND',
  DROPOFF_TO_NABIS: 'DROPOFF_TO_NABIS',
  PICKUP_FROM_BRAND: 'PICKUP_FROM_BRAND',
  PICKUP_FROM_NABIS: 'PICKUP_FROM_NABIS',
  RETURN_FROM_RETAILER: 'RETURN_FROM_RETAILER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
} as const;

export type CreateOrderDtoTimezone = (typeof CreateOrderDtoTimezone)[keyof typeof CreateOrderDtoTimezone];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrderDtoTimezone = {
  'America/Anchorage': 'America/Anchorage',
  'America/Phoenix': 'America/Phoenix',
  'America/Chicago': 'America/Chicago',
  'America/New_York': 'America/New_York',
  'Pacific/Honolulu': 'Pacific/Honolulu',
  'America/Denver': 'America/Denver',
  'America/Los_Angeles': 'America/Los_Angeles',
  'Etc/UTC': 'Etc/UTC',
  null: null,
} as const;

export interface CreateOrderLineItemDto {
  code: string;
  name: string;
  unit: string;
  quantity: number;
  pricePerUnit: number;
  itemBatchId: string;
  overrideQuantityPerUnitOfMeasure: boolean;
  discount: number;
  lineItemManifestNotes: string | null;
  isSample: boolean;
  itemVolumePricingId: string | null;
  appliedTaxId?: string | null;
}

export interface CreateOrderDto {
  irn: string | null;
  deliveryDate: string;
  deliveryInstruction?: string;
  assignedSalesRepId?: string | null;
  timezone?: CreateOrderDtoTimezone;
  action: CreateOrderDtoAction;
  licensedLocationId: string;
  orderLicensedLocationContactIds: string[];
  orderRetailerContactIds?: string[];
  orderCreditMemoIds: string[];
  /** Only applies to `Delivery to Retailer` orders */
  paymentTerms?: CreateOrderDtoPaymentTerms;
  paymentMethod?: CreateOrderDtoPaymentMethod;
  licenseId: string;
  notes: string | null;
  lineItems: CreateOrderLineItemDto[];
  /** Source warehouse ID */
  warehouseId?: string;
  /** Require overdue balances prior to delivery */
  mustPayPriorBalance?: boolean;
  /** Indicates source of the order, e.g., Marketplace, Order Form, Sales Order Form */
  source?: CreateOrderDtoSource;
}

export interface OrderCreditMemoEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  creditMemoId: string;
  createdById: string;
  updatedById: string;
  deletedAt?: string;
}

export interface ApplyCreditMemoToOrderDto {
  creditMemoId: string;
}

export interface CreditMemoEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  organizationId: string;
  referenceId: string;
  amount: number;
  createdById: string;
  updatedById: string;
  deletedAt?: string;
}

export interface UpsertCreditMemoDto {
  referenceId: string;
  amount: number;
}

export type GetOrGenerateBundledBillsOfLadingResponseDtoScenario =
  (typeof GetOrGenerateBundledBillsOfLadingResponseDtoScenario)[keyof typeof GetOrGenerateBundledBillsOfLadingResponseDtoScenario];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrGenerateBundledBillsOfLadingResponseDtoScenario = {
  COMPLETED_AND_UP_TO_DATE: 'COMPLETED_AND_UP_TO_DATE',
  NEEDS_GENERATION: 'NEEDS_GENERATION',
  ALREADY_PROCESSING: 'ALREADY_PROCESSING',
} as const;

export interface GetOrGenerateBundledBillsOfLadingResponseDto {
  scenario: GetOrGenerateBundledBillsOfLadingResponseDtoScenario;
  presignedUrl: string | null;
}

export type GetOrGenerateBundledCoasResponseDtoScenario =
  (typeof GetOrGenerateBundledCoasResponseDtoScenario)[keyof typeof GetOrGenerateBundledCoasResponseDtoScenario];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrGenerateBundledCoasResponseDtoScenario = {
  COMPLETED_AND_UP_TO_DATE: 'COMPLETED_AND_UP_TO_DATE',
  SKIPPED_BECAUSE_ZERO_COAS: 'SKIPPED_BECAUSE_ZERO_COAS',
  NEEDS_GENERATION: 'NEEDS_GENERATION',
  ALREADY_PROCESSING: 'ALREADY_PROCESSING',
} as const;

export interface GetOrGenerateBundledCoasResponseDto {
  scenario: GetOrGenerateBundledCoasResponseDtoScenario;
  presignedUrl: string | null;
}

export interface OrderFilesEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  orderId: string;
  manifestS3Link: string | null;
  packingListS3FileLink: string | null;
  qrcodeS3FileLink: string | null;
  apSummaryS3FileLink: string | null;
  billOfLadingS3Link: string | null;
}

export interface GetPreSignedLinksDto {
  payload: string[];
}

export interface CreateDocumentationsDto {
  /** creates manifest and bill of lading for provided order ids */
  orderIds: string[];
}

export type UpdateBatchDtoInventoryType =
  (typeof UpdateBatchDtoInventoryType)[keyof typeof UpdateBatchDtoInventoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateBatchDtoInventoryType = {
  CANNABIS: 'CANNABIS',
  NON_CANNABIS: 'NON_CANNABIS',
} as const;

export type UpdateBatchDtoAromasItem = (typeof UpdateBatchDtoAromasItem)[keyof typeof UpdateBatchDtoAromasItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateBatchDtoAromasItem = {
  APPLE_PEAR: 'APPLE_PEAR',
  BANANA: 'BANANA',
  BERRY: 'BERRY',
  CHEESE: 'CHEESE',
  CHOCOLATE: 'CHOCOLATE',
  CITRUS: 'CITRUS',
  COFFEE: 'COFFEE',
  CREAMY: 'CREAMY',
  DRIED_FRUIT: 'DRIED_FRUIT',
  FLORAL: 'FLORAL',
  FRUIT: 'FRUIT',
  GRAIN_CEREAL: 'GRAIN_CEREAL',
  GRAPE: 'GRAPE',
  MELON: 'MELON',
  NUTTY: 'NUTTY',
  ORANGE: 'ORANGE',
  RESINOUS: 'RESINOUS',
  SAVORY: 'SAVORY',
  SPICE: 'SPICE',
  STONE_FRUIT: 'STONE_FRUIT',
  TROPICAL: 'TROPICAL',
  WOODY: 'WOODY',
  GAS: 'GAS',
  GLUE: 'GLUE',
  RUBBER: 'RUBBER',
  AMMONIA: 'AMMONIA',
  KUSH: 'KUSH',
  NATURAL: 'NATURAL',
  SKUNK: 'SKUNK',
  UNKNOWN_BENCHMARK: 'UNKNOWN_BENCHMARK',
  SWEET: 'SWEET',
  EARTHY: 'EARTHY',
  GRASSY: 'GRASSY',
  GREENS: 'GREENS',
  HERB: 'HERB',
  MENTHOL: 'MENTHOL',
  TEA: 'TEA',
  CHEMICAL: 'CHEMICAL',
  HERITAGE: 'HERITAGE',
  SUGARY: 'SUGARY',
  VEGETAL_EARTHEN: 'VEGETAL_EARTHEN',
  COMMON_CHEMICAL: 'COMMON_CHEMICAL',
  DIESEL: 'DIESEL',
  DOUGH: 'DOUGH',
  PETROLEUM: 'PETROLEUM',
} as const;

export interface UpdateBatchDto {
  code?: string;
  manufacturingDate?: string;
  expirationDate?: string;
  licenseId?: string | null;
  itemId?: string | null;
  cbdPercentage?: number | null;
  thcPercentage?: number | null;
  coaS3FileLink?: string | null;
  cbnPercentage?: number | null;
  thcWeight?: number | null;
  cbdWeight?: number | null;
  cbnWeight?: number | null;
  delta8Percentage?: number | null;
  delta8Weight?: number | null;
  aromas?: UpdateBatchDtoAromasItem[];
  isArchived?: boolean;
  sampleSizeWeight?: number | null;
  inventoryType?: UpdateBatchDtoInventoryType;
}

export interface GetBatchCoaResponseDto {
  url: string;
}

export type CreateBatchDtoInventoryType =
  (typeof CreateBatchDtoInventoryType)[keyof typeof CreateBatchDtoInventoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBatchDtoInventoryType = {
  CANNABIS: 'CANNABIS',
  NON_CANNABIS: 'NON_CANNABIS',
} as const;

export type CreateBatchDtoAromasItem = (typeof CreateBatchDtoAromasItem)[keyof typeof CreateBatchDtoAromasItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBatchDtoAromasItem = {
  APPLE_PEAR: 'APPLE_PEAR',
  BANANA: 'BANANA',
  BERRY: 'BERRY',
  CHEESE: 'CHEESE',
  CHOCOLATE: 'CHOCOLATE',
  CITRUS: 'CITRUS',
  COFFEE: 'COFFEE',
  CREAMY: 'CREAMY',
  DRIED_FRUIT: 'DRIED_FRUIT',
  FLORAL: 'FLORAL',
  FRUIT: 'FRUIT',
  GRAIN_CEREAL: 'GRAIN_CEREAL',
  GRAPE: 'GRAPE',
  MELON: 'MELON',
  NUTTY: 'NUTTY',
  ORANGE: 'ORANGE',
  RESINOUS: 'RESINOUS',
  SAVORY: 'SAVORY',
  SPICE: 'SPICE',
  STONE_FRUIT: 'STONE_FRUIT',
  TROPICAL: 'TROPICAL',
  WOODY: 'WOODY',
  GAS: 'GAS',
  GLUE: 'GLUE',
  RUBBER: 'RUBBER',
  AMMONIA: 'AMMONIA',
  KUSH: 'KUSH',
  NATURAL: 'NATURAL',
  SKUNK: 'SKUNK',
  UNKNOWN_BENCHMARK: 'UNKNOWN_BENCHMARK',
  SWEET: 'SWEET',
  EARTHY: 'EARTHY',
  GRASSY: 'GRASSY',
  GREENS: 'GREENS',
  HERB: 'HERB',
  MENTHOL: 'MENTHOL',
  TEA: 'TEA',
  CHEMICAL: 'CHEMICAL',
  HERITAGE: 'HERITAGE',
  SUGARY: 'SUGARY',
  VEGETAL_EARTHEN: 'VEGETAL_EARTHEN',
  COMMON_CHEMICAL: 'COMMON_CHEMICAL',
  DIESEL: 'DIESEL',
  DOUGH: 'DOUGH',
  PETROLEUM: 'PETROLEUM',
} as const;

export interface CreateBatchDto {
  code: string;
  manufacturingDate: string;
  expirationDate: string;
  licenseId?: string | null;
  itemId?: string | null;
  cbdPercentage?: number | null;
  thcPercentage?: number | null;
  coaS3FileLink?: string | null;
  cbnPercentage?: number | null;
  thcWeight?: number | null;
  cbdWeight?: number | null;
  cbnWeight?: number | null;
  delta8Percentage?: number | null;
  delta8Weight?: number | null;
  aromas?: CreateBatchDtoAromasItem[];
  isArchived: boolean;
  sampleSizeWeight?: number | null;
  inventoryType: CreateBatchDtoInventoryType;
}

export type BatchDetailResponseDtoInventoryType =
  (typeof BatchDetailResponseDtoInventoryType)[keyof typeof BatchDetailResponseDtoInventoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchDetailResponseDtoInventoryType = {
  CANNABIS: 'CANNABIS',
  NON_CANNABIS: 'NON_CANNABIS',
} as const;

export type BatchDetailResponseDtoAromasItem =
  (typeof BatchDetailResponseDtoAromasItem)[keyof typeof BatchDetailResponseDtoAromasItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchDetailResponseDtoAromasItem = {
  APPLE_PEAR: 'APPLE_PEAR',
  BANANA: 'BANANA',
  BERRY: 'BERRY',
  CHEESE: 'CHEESE',
  CHOCOLATE: 'CHOCOLATE',
  CITRUS: 'CITRUS',
  COFFEE: 'COFFEE',
  CREAMY: 'CREAMY',
  DRIED_FRUIT: 'DRIED_FRUIT',
  FLORAL: 'FLORAL',
  FRUIT: 'FRUIT',
  GRAIN_CEREAL: 'GRAIN_CEREAL',
  GRAPE: 'GRAPE',
  MELON: 'MELON',
  NUTTY: 'NUTTY',
  ORANGE: 'ORANGE',
  RESINOUS: 'RESINOUS',
  SAVORY: 'SAVORY',
  SPICE: 'SPICE',
  STONE_FRUIT: 'STONE_FRUIT',
  TROPICAL: 'TROPICAL',
  WOODY: 'WOODY',
  GAS: 'GAS',
  GLUE: 'GLUE',
  RUBBER: 'RUBBER',
  AMMONIA: 'AMMONIA',
  KUSH: 'KUSH',
  NATURAL: 'NATURAL',
  SKUNK: 'SKUNK',
  UNKNOWN_BENCHMARK: 'UNKNOWN_BENCHMARK',
  SWEET: 'SWEET',
  EARTHY: 'EARTHY',
  GRASSY: 'GRASSY',
  GREENS: 'GREENS',
  HERB: 'HERB',
  MENTHOL: 'MENTHOL',
  TEA: 'TEA',
  CHEMICAL: 'CHEMICAL',
  HERITAGE: 'HERITAGE',
  SUGARY: 'SUGARY',
  VEGETAL_EARTHEN: 'VEGETAL_EARTHEN',
  COMMON_CHEMICAL: 'COMMON_CHEMICAL',
  DIESEL: 'DIESEL',
  DOUGH: 'DOUGH',
  PETROLEUM: 'PETROLEUM',
} as const;

export interface BatchDetailResponseDto {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  code: string;
  manufacturingDate: string;
  expirationDate: string;
  organizationId: string;
  licenseId: string;
  deletedAt: string | null;
  cbdPercentage: number | null;
  thcPercentage: number | null;
  coaS3FileLink: string | null;
  cbnPercentage: number | null;
  thcWeight: number | null;
  cbdWeight: number | null;
  cbnWeight: number | null;
  delta8Percentage: number | null;
  delta8Weight: number | null;
  aromas: BatchDetailResponseDtoAromasItem[];
  sampleSizeWeight: number | null;
  calculatedThcPercentage: number;
  calculatedThcWeight: number;
  inventoryType: BatchDetailResponseDtoInventoryType;
  licenseNickname: string;
  items: ItemDto[];
}

export interface GetBatchesDetailsResponseDto {
  hasNextPage: boolean;
  data: BatchDetailResponseDto[];
}

export type ItemDtoInventoryClass = (typeof ItemDtoInventoryClass)[keyof typeof ItemDtoInventoryClass];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemDtoInventoryClass = {
  CONCENTRATE: 'CONCENTRATE',
  EDIBLES: 'EDIBLES',
  FLOWER: 'FLOWER',
  PRE_ROLL: 'PRE_ROLL',
  VAPE: 'VAPE',
  PERSONAL_CARE: 'PERSONAL_CARE',
} as const;

export interface ItemDto {
  id: string;
  name: string;
  inventoryClass: ItemDtoInventoryClass;
}

export type BatchEntityInventoryType = (typeof BatchEntityInventoryType)[keyof typeof BatchEntityInventoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchEntityInventoryType = {
  CANNABIS: 'CANNABIS',
  NON_CANNABIS: 'NON_CANNABIS',
} as const;

export type BatchEntityAromasItem = (typeof BatchEntityAromasItem)[keyof typeof BatchEntityAromasItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchEntityAromasItem = {
  APPLE_PEAR: 'APPLE_PEAR',
  BANANA: 'BANANA',
  BERRY: 'BERRY',
  CHEESE: 'CHEESE',
  CHOCOLATE: 'CHOCOLATE',
  CITRUS: 'CITRUS',
  COFFEE: 'COFFEE',
  CREAMY: 'CREAMY',
  DRIED_FRUIT: 'DRIED_FRUIT',
  FLORAL: 'FLORAL',
  FRUIT: 'FRUIT',
  GRAIN_CEREAL: 'GRAIN_CEREAL',
  GRAPE: 'GRAPE',
  MELON: 'MELON',
  NUTTY: 'NUTTY',
  ORANGE: 'ORANGE',
  RESINOUS: 'RESINOUS',
  SAVORY: 'SAVORY',
  SPICE: 'SPICE',
  STONE_FRUIT: 'STONE_FRUIT',
  TROPICAL: 'TROPICAL',
  WOODY: 'WOODY',
  GAS: 'GAS',
  GLUE: 'GLUE',
  RUBBER: 'RUBBER',
  AMMONIA: 'AMMONIA',
  KUSH: 'KUSH',
  NATURAL: 'NATURAL',
  SKUNK: 'SKUNK',
  UNKNOWN_BENCHMARK: 'UNKNOWN_BENCHMARK',
  SWEET: 'SWEET',
  EARTHY: 'EARTHY',
  GRASSY: 'GRASSY',
  GREENS: 'GREENS',
  HERB: 'HERB',
  MENTHOL: 'MENTHOL',
  TEA: 'TEA',
  CHEMICAL: 'CHEMICAL',
  HERITAGE: 'HERITAGE',
  SUGARY: 'SUGARY',
  VEGETAL_EARTHEN: 'VEGETAL_EARTHEN',
  COMMON_CHEMICAL: 'COMMON_CHEMICAL',
  DIESEL: 'DIESEL',
  DOUGH: 'DOUGH',
  PETROLEUM: 'PETROLEUM',
} as const;

export interface BatchEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  code: string;
  manufacturingDate: string;
  expirationDate: string;
  organizationId: string;
  licenseId: string;
  deletedAt: string | null;
  cbdPercentage: number | null;
  thcPercentage: number | null;
  coaS3FileLink: string | null;
  cbnPercentage: number | null;
  thcWeight: number | null;
  cbdWeight: number | null;
  cbnWeight: number | null;
  delta8Percentage: number | null;
  delta8Weight: number | null;
  aromas: BatchEntityAromasItem[];
  sampleSizeWeight: number | null;
  calculatedThcPercentage: number;
  calculatedThcWeight: number;
  inventoryType: BatchEntityInventoryType;
}

export interface GetBatchesResponseDto {
  hasNextPage: boolean;
  data: BatchEntity[];
}

export interface OrganizationUserMessageResponseDto {
  message: string;
}

export type OrganizationUserResponseStatus =
  (typeof OrganizationUserResponseStatus)[keyof typeof OrganizationUserResponseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationUserResponseStatus = {
  invited: 'invited',
  active: 'active',
} as const;

export type OrganizationUserResponseState =
  (typeof OrganizationUserResponseState)[keyof typeof OrganizationUserResponseState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationUserResponseState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface OrganizationUserResponse {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  address1: string;
  address2?: string | null;
  city: string;
  state: OrganizationUserResponseState;
  zip: string;
  phone: string;
  status: OrganizationUserResponseStatus;
  profilePicture?: string | null;
  organizationId: string;
  organizationUserCreatedAt: string;
  organizationUserCreatedById: string;
  organizationUserId: string;
  organizationUserUpdatedAt: string;
  organizationUserUpdatedById: string;
  roles: OrganizationUserRole[];
}

export interface OrganizationUserFindManyResponseDto {
  hasNextPage: boolean;
  data: OrganizationUserResponse[];
}

export interface OrganizationUserEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  userId: string;
  organizationId: string;
}

export interface CreateOrganizationUserDto {
  userId: string;
}

export interface CheckRefreshTokenValidityDto {
  unhashedRefreshToken: string;
}

export interface CreateRefreshTokenDto {
  userId: string;
  unhashedRefreshToken: string;
}

export interface AuthResetPasswordDto {
  email: string;
  password: string;
  hash: string;
}

export interface AuthForgotPasswordDto {
  email: string;
}

export interface AuthGoogleLoginSubmitDto {
  accessToken?: string | null;
  credential?: string | null;
}

export interface AuthLoginDto {
  user: UserEntity;
  refreshToken: string;
  token: string;
}

export interface AuthEmailLoginDto {
  email: string;
  password: string;
}

export type UpdateLicensedLocationDtoSiteCategory =
  (typeof UpdateLicensedLocationDtoSiteCategory)[keyof typeof UpdateLicensedLocationDtoSiteCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateLicensedLocationDtoSiteCategory = {
  RETAILER: 'RETAILER',
  MANUFACTURER: 'MANUFACTURER',
  CULTIVATOR: 'CULTIVATOR',
  CONSUMER: 'CONSUMER',
  DISTRIBUTOR: 'DISTRIBUTOR',
  NABIS_WAREHOUSE: 'NABIS_WAREHOUSE',
  MICROBUSINESS: 'MICROBUSINESS',
  OTHER: 'OTHER',
  TESTING: 'TESTING',
} as const;

export type UpdateLicensedLocationDtoState =
  (typeof UpdateLicensedLocationDtoState)[keyof typeof UpdateLicensedLocationDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateLicensedLocationDtoState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface UpdateLicensedLocationDto {
  name?: string;
  address1?: string;
  address2?: string | null;
  city?: string;
  state?: UpdateLicensedLocationDtoState;
  zip?: string;
  lat?: number | null;
  lng?: number | null;
  siteCategory?: UpdateLicensedLocationDtoSiteCategory;
  doingBusinessAs?: string | null;
  phoneNumber?: string;
  hoursBusiness?: string | null;
  hoursDelivery?: string | null;
  deliveryByApptOnly?: boolean | null;
  specialProtocol?: boolean | null;
  schedulingSoftwareRequired?: boolean | null;
  schedulingSoftwareLink?: string | null;
  centralizedPurchasingNotes?: string | null;
  collectionNotes?: string | null;
  organizationId?: string | null;
  parentOrganizationId?: string | null;
  deliveryNotes?: string | null;
  deliveryHoursId?: string | null;
  locationNotes?: string | null;
  w9Link?: string | null;
  taxIdentificationNumber?: string | null;
  sellerPermitLink?: string | null;
  license?: CreateLicenseDto;
  contactDetails?: BaseLicensedLocationContact;
  id: string;
}

export interface RetailerLocationsResponseDto {
  id: string;
  name: string;
  organizationId: string;
}

export type LicensedLocationEntityVerificationStatus =
  (typeof LicensedLocationEntityVerificationStatus)[keyof typeof LicensedLocationEntityVerificationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LicensedLocationEntityVerificationStatus = {
  VERIFIED: 'VERIFIED',
  UNVERIFIED: 'UNVERIFIED',
  REJECTED: 'REJECTED',
} as const;

export type LicensedLocationEntitySiteCategory =
  (typeof LicensedLocationEntitySiteCategory)[keyof typeof LicensedLocationEntitySiteCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LicensedLocationEntitySiteCategory = {
  RETAILER: 'RETAILER',
  MANUFACTURER: 'MANUFACTURER',
  CULTIVATOR: 'CULTIVATOR',
  CONSUMER: 'CONSUMER',
  DISTRIBUTOR: 'DISTRIBUTOR',
  NABIS_WAREHOUSE: 'NABIS_WAREHOUSE',
  MICROBUSINESS: 'MICROBUSINESS',
  OTHER: 'OTHER',
  TESTING: 'TESTING',
} as const;

export interface LicensedLocationEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  name: string;
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  zip: string;
  lat: number | null;
  lng: number | null;
  siteCategory: LicensedLocationEntitySiteCategory;
  verificationStatus: LicensedLocationEntityVerificationStatus;
  submittedById: string;
  verificationAt: string | null;
  deletedAt: string | null;
  doingBusinessAs: string | null;
  phoneNumber: string;
  hoursBusiness: string | null;
  hoursDelivery: string | null;
  deliveryByApptOnly: boolean;
  specialProtocol: boolean;
  schedulingSoftwareRequired: boolean;
  schedulingSoftwareLink: string | null;
  centralizedPurchasingNotes: string | null;
  collectionNotes: string | null;
  deliveryNotes: string | null;
  parentLicensedLocationId: string | null;
  deliveryHoursId: string | null;
  locationNotes: string | null;
  w9Link: string | null;
  taxIdentificationNumber: string | null;
  sellerPermitLink: string | null;
  createdById: string;
  updatedById: string | null;
  organizationId: string;
  infoplusId: number | null;
  licenses: LicenseEntity[] | null;
  restrictions: LicensedLocationRestrictionEntity[] | null;
}

export interface GetLicensedLocationsResponseDto {
  hasNextPage: boolean;
  data: LicensedLocationEntity[];
}

export type LicensedLocationRestrictionEntityRestriction =
  (typeof LicensedLocationRestrictionEntityRestriction)[keyof typeof LicensedLocationRestrictionEntityRestriction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LicensedLocationRestrictionEntityRestriction = {
  COD_REQUIRED: 'COD_REQUIRED',
} as const;

export interface LicensedLocationRestrictionEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  licensedLocationId: string;
  restriction: LicensedLocationRestrictionEntityRestriction;
  createdById: string;
  updatedById: string | null;
}

export type LicenseEntityType = (typeof LicenseEntityType)[keyof typeof LicenseEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LicenseEntityType = {
  RETAILER: 'RETAILER',
  RETAILER_NONSTOREFRONT: 'RETAILER_NONSTOREFRONT',
  DISTRIBUTOR: 'DISTRIBUTOR',
  DISTRIBUTOR_TRANSPORT_ONLY: 'DISTRIBUTOR_TRANSPORT_ONLY',
  MICROBUSINESS: 'MICROBUSINESS',
  TESTING_LABORATORY: 'TESTING_LABORATORY',
  TESTING: 'TESTING',
  CANNABIS_EVENTS: 'CANNABIS_EVENTS',
  MANUFACTURER: 'MANUFACTURER',
  CULTIVATOR: 'CULTIVATOR',
} as const;

export type LicenseEntityCategory = (typeof LicenseEntityCategory)[keyof typeof LicenseEntityCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LicenseEntityCategory = {
  ADULT_USE: 'ADULT_USE',
  MEDICINAL: 'MEDICINAL',
  COMBINED: 'COMBINED',
} as const;

export interface LicenseEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  nickname: string;
  category: LicenseEntityCategory;
  type: LicenseEntityType;
  licenseNumber: string;
  legalEntityName: string;
  issuanceDate: string | null;
  expirationDate: string | null;
  contactName: string;
  contactPhone: string;
  organizationId: string | null;
  licensedLocationId: string | null;
  adminNotes: string | null;
  contactEmail: string | null;
  deletedAt: string | null;
}

export type CreateLicensedLocationDtoSiteCategory =
  (typeof CreateLicensedLocationDtoSiteCategory)[keyof typeof CreateLicensedLocationDtoSiteCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateLicensedLocationDtoSiteCategory = {
  RETAILER: 'RETAILER',
  MANUFACTURER: 'MANUFACTURER',
  CULTIVATOR: 'CULTIVATOR',
  CONSUMER: 'CONSUMER',
  DISTRIBUTOR: 'DISTRIBUTOR',
  NABIS_WAREHOUSE: 'NABIS_WAREHOUSE',
  MICROBUSINESS: 'MICROBUSINESS',
  OTHER: 'OTHER',
  TESTING: 'TESTING',
} as const;

export type CreateLicensedLocationDtoState =
  (typeof CreateLicensedLocationDtoState)[keyof typeof CreateLicensedLocationDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateLicensedLocationDtoState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export type BaseLicensedLocationContactPreferredContactMethod =
  (typeof BaseLicensedLocationContactPreferredContactMethod)[keyof typeof BaseLicensedLocationContactPreferredContactMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseLicensedLocationContactPreferredContactMethod = {
  PHONE: 'PHONE',
  EMAIL: 'EMAIL',
  TEXT: 'TEXT',
} as const;

export type BaseLicensedLocationContactContactType =
  (typeof BaseLicensedLocationContactContactType)[keyof typeof BaseLicensedLocationContactContactType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseLicensedLocationContactContactType = {
  ORDER: 'ORDER',
} as const;

export interface BaseLicensedLocationContact {
  firstName: string;
  lastName: string;
  title?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  contactType: BaseLicensedLocationContactContactType;
  preferredContactMethod: BaseLicensedLocationContactPreferredContactMethod;
}

export interface CreateLicensedLocationDto {
  name: string;
  address1: string;
  address2?: string | null;
  city: string;
  state: CreateLicensedLocationDtoState;
  zip: string;
  lat?: number | null;
  lng?: number | null;
  siteCategory: CreateLicensedLocationDtoSiteCategory;
  doingBusinessAs?: string | null;
  phoneNumber: string;
  hoursBusiness?: string | null;
  hoursDelivery?: string | null;
  deliveryByApptOnly?: boolean | null;
  specialProtocol?: boolean | null;
  schedulingSoftwareRequired?: boolean | null;
  schedulingSoftwareLink?: string | null;
  centralizedPurchasingNotes?: string | null;
  collectionNotes?: string | null;
  organizationId?: string | null;
  parentOrganizationId: string | null;
  deliveryNotes?: string | null;
  deliveryHoursId?: string | null;
  locationNotes?: string | null;
  w9Link?: string | null;
  taxIdentificationNumber?: string | null;
  sellerPermitLink?: string | null;
  license: CreateLicenseDto;
  contactDetails: BaseLicensedLocationContact;
}

export type CreateLicenseDtoType = (typeof CreateLicenseDtoType)[keyof typeof CreateLicenseDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateLicenseDtoType = {
  RETAILER: 'RETAILER',
  RETAILER_NONSTOREFRONT: 'RETAILER_NONSTOREFRONT',
  DISTRIBUTOR: 'DISTRIBUTOR',
  DISTRIBUTOR_TRANSPORT_ONLY: 'DISTRIBUTOR_TRANSPORT_ONLY',
  MICROBUSINESS: 'MICROBUSINESS',
  TESTING_LABORATORY: 'TESTING_LABORATORY',
  TESTING: 'TESTING',
  CANNABIS_EVENTS: 'CANNABIS_EVENTS',
  MANUFACTURER: 'MANUFACTURER',
  CULTIVATOR: 'CULTIVATOR',
} as const;

export type CreateLicenseDtoCategory = (typeof CreateLicenseDtoCategory)[keyof typeof CreateLicenseDtoCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateLicenseDtoCategory = {
  ADULT_USE: 'ADULT_USE',
  MEDICINAL: 'MEDICINAL',
  COMBINED: 'COMBINED',
} as const;

export interface CreateLicenseDto {
  nickname: string;
  category: CreateLicenseDtoCategory;
  type: CreateLicenseDtoType;
  licenseNumber: string;
  legalEntityName: string;
  issuanceDate: string | null;
  expirationDate: string | null;
  contactName: string;
  contactPhone: string;
  adminNotes: string | null;
  contactEmail: string | null;
  organizationId: string | null;
  licensedLocationId: string | null;
}

export type OrganizationWarehouseEntityRelationshipType =
  (typeof OrganizationWarehouseEntityRelationshipType)[keyof typeof OrganizationWarehouseEntityRelationshipType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationWarehouseEntityRelationshipType = {
  HOME_HUB: 'HOME_HUB',
} as const;

export interface OrganizationWarehouseEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  organizationId: string;
  warehouseId: string;
  relationshipType: OrganizationWarehouseEntityRelationshipType;
  createdById: string;
  updatedById: string | null;
  deletedAt: string | null;
}

export interface InfoplusApiErrorResponse {
  code: string;
  message: string;
  status: number;
}

export type GetOrderMessageResponseDtoInfoplusError = InfoplusApiErrorResponse | null;

export interface GetOrderMessageResponseDto {
  message: string;
  done: boolean;
  createdAt: string;
  updatedAt: string;
  infoplusError?: GetOrderMessageResponseDtoInfoplusError;
  retryCount: number;
  isProcessing: boolean;
  action: string;
}

export interface GetOrderMessagesResponseDto {
  data: GetOrderMessageResponseDto[];
}

export interface ServiceAuthEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  username: string;
  password: string;
  clientName: string;
  clientDescription: string;
  deletedAt: string | null;
}

export interface CreateServiceAuth {
  username: string;
  clientName: string;
  clientDescription: string;
}

export interface UpdateInventoryLedgerItemDto {
  quantity: number;
  orderNumber: number;
  skuBatchId: string;
  orderLineId: number;
  itemReceiptId: number;
  inventoryAdjustmentId: number;
  type: string;
  infoplusWarehouseId: number;
  infoplusTaskCompletedAt: string;
}

export interface UpdateShipmentCartonsDto {
  shipmentNo: number;
  numberOfCartons: number;
}

export interface UpdateOrderCartonsDto {
  orderNo: number;
  numberOfCartons: number;
}

export interface UpdateOrderStateDto {
  infoplusOrderId: number;
  orderNumber: number;
  shipmentNumber: number;
  orderDate: string;
}

export interface UpdateShipmentFulfillmentDto {
  pickers: string[];
  shipmentNumbers: string[];
}

export interface UpdateShipmentInventoryStatus {
  shipmentNumber: number;
  status: string;
  isAsn: boolean;
}

export interface UpdateOrderFulfillabilityRequestDto {
  shipmentNumber: number;
  fulfillability: string;
}

export type UpdateOrganizationDtoType = (typeof UpdateOrganizationDtoType)[keyof typeof UpdateOrganizationDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrganizationDtoType = {
  BRAND: 'BRAND',
  MANUFACTURER: 'MANUFACTURER',
  DISTRIBUTOR: 'DISTRIBUTOR',
  RETAILER: 'RETAILER',
  SALES: 'SALES',
} as const;

export type UpdateOrganizationDtoState = (typeof UpdateOrganizationDtoState)[keyof typeof UpdateOrganizationDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateOrganizationDtoState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface UpdateOrganizationDto {
  name?: string;
  address1?: string;
  address2?: string | null;
  city?: string;
  state?: UpdateOrganizationDtoState;
  zip?: string;
  phone?: string;
  doingBusinessAs?: string | null;
  receiveReports?: boolean;
  infoplusId?: number | null;
  logoS3Link?: string | null;
  type?: UpdateOrganizationDtoType;
  warehouseId?: string;
  parentOrganizationId?: string | null;
  taxInclusivePricing?: boolean;
  id: string;
}

export type CreateOrganizationDtoType = (typeof CreateOrganizationDtoType)[keyof typeof CreateOrganizationDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrganizationDtoType = {
  BRAND: 'BRAND',
  MANUFACTURER: 'MANUFACTURER',
  DISTRIBUTOR: 'DISTRIBUTOR',
  RETAILER: 'RETAILER',
  SALES: 'SALES',
} as const;

export type CreateOrganizationDtoState = (typeof CreateOrganizationDtoState)[keyof typeof CreateOrganizationDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateOrganizationDtoState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface CreateOrganizationDto {
  name: string;
  address1: string;
  address2: string | null;
  city: string;
  state: CreateOrganizationDtoState;
  zip: string;
  phone: string;
  doingBusinessAs: string | null;
  receiveReports: boolean;
  infoplusId: number | null;
  logoS3Link: string | null;
  type: CreateOrganizationDtoType;
  warehouseId?: string;
  parentOrganizationId: string | null;
  taxInclusivePricing: boolean;
}

export interface RetailerLicenseResponseDto {
  id: string;
  nickname: string;
  licensedLocationId: string;
  licenseNumber: string;
  issuanceDate: string;
  expirationDate: string;
}

export interface RetailerLocationsWithLicensesResponseDto {
  id: string;
  name: string;
  organizationId: string;
  licenses: RetailerLicenseResponseDto[];
}

/**
 * A map of organizationIds to arrays of organization-level features.
 */
export type UserDetailsResponseDtoFeaturesForOrganizations = { [key: string]: string[] };

export type UserDetailsResponseDtoAppFeaturesItem =
  (typeof UserDetailsResponseDtoAppFeaturesItem)[keyof typeof UserDetailsResponseDtoAppFeaturesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserDetailsResponseDtoAppFeaturesItem = {
  CAN_ADMIN_DASHBOARD: 'CAN_ADMIN_DASHBOARD',
  CAN_BREAK_CASE_PACK_QUANTITY: 'CAN_BREAK_CASE_PACK_QUANTITY',
  CAN_C_ORGANIZATION: 'CAN_C_ORGANIZATION',
  CAN_CREATE_INTERNAL_TRANSFER_ORDER: 'CAN_CREATE_INTERNAL_TRANSFER_ORDER',
  CAN_CREATE_RETURN_FROM_RETAILER_ORDER: 'CAN_CREATE_RETURN_FROM_RETAILER_ORDER',
  CAN_CRUD_ACCOUNTS: 'CAN_CRUD_ACCOUNTS',
  CAN_CRUD_ADMIN_FEATURES: 'CAN_CRUD_ADMIN_FEATURES',
  CAN_CRUD_BANK_ACCOUNT: 'CAN_CRUD_BANK_ACCOUNT',
  CAN_CRUD_LICENSES: 'CAN_CRUD_LICENSES',
  CAN_CRUD_ORGANIZATION_USER: 'CAN_CRUD_ORGANIZATION_USER',
  CAN_CRUD_ROLES: 'CAN_CRUD_ROLES',
  CAN_CRUD_SERVICE_AUTH: 'CAN_CRUD_SERVICE_AUTH',
  CAN_CRUD_SHIPMENTS: 'CAN_CRUD_SHIPMENTS',
  CAN_CRUD_ZIPCODES: 'CAN_CRUD_ZIPCODES',
  CAN_VIEW_ALL_LICENSED_LOCATIONS_ON_ORDER_FORM: 'CAN_VIEW_ALL_LICENSED_LOCATIONS_ON_ORDER_FORM',
  CAN_VIEW_NABIS_ADMIN_ORDERS: 'CAN_VIEW_NABIS_ADMIN_ORDERS',
  CAN_VIEW_TABLEAU_ANALYTICS: 'CAN_VIEW_TABLEAU_ANALYTICS',
  CAN_CU_ORGANIZATION_SETTINGS_SELF_COLLECTED: 'CAN_CU_ORGANIZATION_SETTINGS_SELF_COLLECTED',
  CAN_READ_ORGANIZATION_SETTINGS: 'CAN_READ_ORGANIZATION_SETTINGS',
  CAN_MANAGE_ORGANIZATION_SETTINGS: 'CAN_MANAGE_ORGANIZATION_SETTINGS',
  CAN_CRUD_ACCOUNTING: 'CAN_CRUD_ACCOUNTING',
  CAN_VIEW_ALL_ORGANIZATIONS: 'CAN_VIEW_ALL_ORGANIZATIONS',
} as const;

export interface UserDetailsResponseDto {
  /** The authenticated user id */
  userId: string;
  /** Application features for the authenticated user */
  appFeatures: UserDetailsResponseDtoAppFeaturesItem[];
  /** Organizations that the authenticated user "belongs to" */
  organizations: OrganizationEntity[];
  /** A map of organizationIds to arrays of organization-level features. */
  featuresForOrganizations: UserDetailsResponseDtoFeaturesForOrganizations;
  /** A detailed user object */
  user: UserEntity;
}

export type OrganizationEntityType = (typeof OrganizationEntityType)[keyof typeof OrganizationEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationEntityType = {
  BRAND: 'BRAND',
  MANUFACTURER: 'MANUFACTURER',
  DISTRIBUTOR: 'DISTRIBUTOR',
  RETAILER: 'RETAILER',
  SALES: 'SALES',
} as const;

export type OrganizationEntityState = (typeof OrganizationEntityState)[keyof typeof OrganizationEntityState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationEntityState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface OrganizationEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  name: string;
  address1: string;
  address2: string | null;
  city: string;
  state: OrganizationEntityState;
  zip: string;
  phone: string;
  urlSlug: string;
  doingBusinessAs: string | null;
  receiveReports: boolean;
  infoplusId: number | null;
  logoS3Link: string | null;
  type: OrganizationEntityType;
  parentOrganizationId: string | null;
  deletedAt: string | null;
  warehouseId: string | null;
  taxInclusivePricing: boolean;
  organizationBundledGroupId: string | null;
}

export type UpdateUserDtoState = (typeof UpdateUserDtoState)[keyof typeof UpdateUserDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateUserDtoState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
  null: null,
} as const;

export interface UpdateUserDto {
  email?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  address1?: string;
  address2?: string | null;
  city?: string;
  state?: UpdateUserDtoState;
  zip?: string;
  phone?: string;
  profilePicture?: string | null;
  status?: string;
  id: string;
}

export interface UserFindAllResponseDto {
  data: UserWithOrganizationRoles[];
  hasNextPage: boolean;
}

export type UserWithOrganizationRolesStatus =
  (typeof UserWithOrganizationRolesStatus)[keyof typeof UserWithOrganizationRolesStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWithOrganizationRolesStatus = {
  invited: 'invited',
  active: 'active',
} as const;

export type UserWithOrganizationRolesState =
  (typeof UserWithOrganizationRolesState)[keyof typeof UserWithOrganizationRolesState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWithOrganizationRolesState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface NabisRole {
  roleDisplayName: string;
  roleId: string;
  roleName: string;
}

export interface OrganizationUserRole {
  organizationId: string;
  organizationName: string;
  organizationUserRoleId: string;
  roleDisplayName: string;
  roleId: string;
  roleName: string;
  roleType: string;
}

export interface UserWithOrganizationRoles {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  address1: string;
  address2?: string | null;
  city: string;
  state: UserWithOrganizationRolesState;
  zip: string;
  phone: string;
  status: UserWithOrganizationRolesStatus;
  profilePicture?: string | null;
  roles: OrganizationUserRole[];
  nabisRoles: NabisRole[];
}

export type UserEntityStatus = (typeof UserEntityStatus)[keyof typeof UserEntityStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserEntityStatus = {
  invited: 'invited',
  active: 'active',
} as const;

export type UserEntityState = (typeof UserEntityState)[keyof typeof UserEntityState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserEntityState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
} as const;

export interface UserEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  address1: string;
  address2?: string | null;
  city: string;
  state: UserEntityState;
  zip: string;
  phone: string;
  status: UserEntityStatus;
  profilePicture?: string | null;
}

export type CreateUserDtoState = (typeof CreateUserDtoState)[keyof typeof CreateUserDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateUserDtoState = {
  AL: 'AL',
  AK: 'AK',
  AZ: 'AZ',
  AR: 'AR',
  CA: 'CA',
  CO: 'CO',
  CT: 'CT',
  DE: 'DE',
  FL: 'FL',
  GA: 'GA',
  HI: 'HI',
  ID: 'ID',
  IL: 'IL',
  IN: 'IN',
  IA: 'IA',
  KS: 'KS',
  KY: 'KY',
  LA: 'LA',
  ME: 'ME',
  MD: 'MD',
  MA: 'MA',
  MI: 'MI',
  MN: 'MN',
  MS: 'MS',
  MO: 'MO',
  MT: 'MT',
  NE: 'NE',
  NV: 'NV',
  NH: 'NH',
  NJ: 'NJ',
  NM: 'NM',
  NY: 'NY',
  NC: 'NC',
  ND: 'ND',
  OH: 'OH',
  OK: 'OK',
  OR: 'OR',
  PA: 'PA',
  RI: 'RI',
  SC: 'SC',
  SD: 'SD',
  TN: 'TN',
  TX: 'TX',
  UT: 'UT',
  VT: 'VT',
  VA: 'VA',
  WA: 'WA',
  WV: 'WV',
  WI: 'WI',
  WY: 'WY',
  null: null,
} as const;

export interface CreateUserDto {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  address1: string;
  address2?: string | null;
  city: string;
  state?: CreateUserDtoState;
  zip: string;
  phone: string;
  profilePicture?: string | null;
  status: string;
}

export interface UserRemoveRoleFromUserResponseDto {
  success: boolean;
}

export interface UserRoleEntity {
  id: string;
  createdAt: string;
  updatedAt: string | null;
  userId: string;
  roleId: string;
}
